! function(name, module, context) {
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if (window.define)
        define('hotels/searchResult',['vendor/mustache', 'libs/ct_view', 'libs/ct_store', 'libs/ct_pers', 'hotels/shortList', 'hotels/flightSolution', 'common/filter', 'libs/ct_infilist', 'common/firstRun', 'hotels/fetchHotelsJson', 'hotels/dynamicDataLoader', 'hotels/sorter', 'hotels/nearbyhotels', 'hotels/showAllHotelsInCity', 'widgets/jquery.pajinate', 'hotels/checkAvailability', 'hotels/guidedNav', 'widgets/CashRegister', 'widgets/ct_priceslider', 'widgets/sticky_kit', 'hotels/masterJsonExt', 'widgets/royal-slider', 'widgets/jquery.inview.min'], module)
    else
        //>>excludeEnd("requireTmpl");
        context[name] = module(Mustache, CT.View, CT.Store, CT.Pers, CT.settings.shortListHotelsView, CT.FlightSolution, CT.settings.commonFilter, InfiList, firstRun, fetchHotelsJson)

}('searchResultView', function(Mustache, View, store, Pers, shortListViewSettings, FlightSolution, cf, InfiList, firstRun, fetchHotelsJson) {
        /* =============================== PRIVATE PROPERTIES ============================ */
        // Use the settings object internally
        window.showLolBanner = true;
        window.mainTemplate = 'HotelListTagsTpl';
        window.srpClass = 'srp-v2';
        // if not 'B2B' and not white label, in white label companyConfig is defined
        if (window.product === "B2B" || window.companyConfig) {
            window.mainTemplate = "HotelTwoColListTpl";
            window.srpClass = 'srp';
        } else {
            window.mainTemplate = "HotelListTagsTpl";
            window.srpClass = 'srp-v2';
        }
        // The below mentioned global variables are used in the react lol code
        // It sets a cookie with lolModalAutoOpenTime as expiry time
        // Lol Modal auto opens in absence of cookie
        window.lolModalAutoOpenTime = 30; // days
        window.enableLolModalAutoOpen = true;

        window.filterByLocality = function(localities) {
            if (window.localities.length) {
                window.showLolBanner = false;
            }
            // document.location.search = document.location.search + '&localities=' + localities.join(",");
            CT.cache.tabsMap[CT.settings.currentTab]['localities'] = localities;
            window.lolOnlyLocalites = localities;
            window.localities = localities;
            CT.fire('filters.apply');
        }

        window.fireLolClevertapEvent = function(eventName, data) {
            //console.log("eventName, data", eventName, data);
            CT.utils.trackers.clevertapGlobleData.destinationCountry = $('#Country').val() ? $('#Country').val() : "N/A"
            CT.cache[CT.settings.currentTab].autocompleteValSelected = false
            CT.cache[CT.settings.currentTab].removeGoogleSearch = false
            CT.utils.trackers.clevertapGlobleData.marketNature = masterJSON.hmn ? masterJSON.hmn : "N/A";
            CT.utils.trackers.clevertapGlobleData.destinationCity = masterJSON.cnm ? masterJSON.cnm : "N/A";
            var shortlistedCount = CT.masterJson.getShortListedHotelCount();
            CT.utils.helperFunctions.trackClaverTapEvtHotel(eventName, Object.assign({
                pageName: "SRP",
                hotelDetails: "NA",
                searchCategorySelected: String(CT.utils.trackers.eventData.categorySelected ? CT.utils.trackers.eventData.categorySelected : "NA"),
                searchType: String(CT.utils.trackers.eventData.searchType ? CT.utils.trackers.eventData.searchType : "NA"),
                searchedItem: String(CT.utils.trackers.eventData.searchedString ? CT.utils.trackers.eventData.searchedString : "NA"),
                selectedDestination: masterJSON.cnm ? masterJSON.cnm : "N/A",
                timeSpent: "NA",
                pageLoadTime: String(Date.now() - CT.utils.trackers.eventData.pageLoadStartTime),
                featuredRank: "NA",
                userRank: "NA",
                srpFeatures: "NA",
                starRating: "NA",
                taRating: "NA",
                taReviewsCount: "NA",
                hotelType: "NA",
                PAH: "NA"
            }, data));
        }

        var s = CT.settings[CT.app]
        var inViewHotelIds = [];
        var allQueryParams = CT.cache.tabsMap[CT.settings.currentTab];
        var firstHotelId = null;
        var firstHotel = null;
        var srpRedirectionFromUtm = null;
        var utmSource = null;
        if (allQueryParams) {
            var firstHotelId = allQueryParams.hotel_id;
            var srpRedirectionFromUtm = allQueryParams.srp_redirection_from_utm;
            var utmSource = allQueryParams.utm_source;
        }
        var version = store('Cfg').get('ver')
        var hotelsSkeleton = ''
        var tmp // This module's tmp variable. It's like dev/null. Slap data in it to cache stuff for a few moments

        var commonSearchResultSettings = {
            updateAirlineName: function(e) {
                var $thisTag = $(e.target),
                    airlineName, $logoDiv, $textTag;

                if ($thisTag.prop('tagName') == 'IMG') {
                    $logoDiv = $thisTag.parents('.airLogo');
                    $textTag = $logoDiv.next('.airlineName').find('.name');

                    airlineName = $thisTag.attr('data-nm');
                    tmp = $textTag.html();

                    $textTag.html(airlineName);
                    $logoDiv.attr('data-tmp', tmp);
                }
            },

            revertAirlineName: function(e) {
                var $logoDiv = $(e.target).parents('.airLogo');

                $logoDiv.next('.airlineName').find('.name').html($logoDiv.attr('data-tmp'));
                $logoDiv.removeAttr('data-tmp');
            },

            logGaLTtrack: function(e) {
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR_2col', 'sliderLeft', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                var hotelTitle = $(e.currentTarget).parents('section.clearFix').find('nav.summary .info h2 a').attr('title');
                var startRating = $(e.currentTarget).parents('section.clearFix').find('.metaData span').attr('title');
                var taRating = $(e.currentTarget).parents('section.clearFix').find('.metaData .review .taRating').attr('title');
                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_ImageScrolled", {
                    "hotelDetails": hotelTitle,
                    "starRating": startRating,
                    "taRating": taRating
                });
            },

            logGaRTtrack: function(e) {
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR_2col', 'sliderRight', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                var hotelTitle = $(e.currentTarget).parents('section.clearFix').find('nav.summary .info h2 a').attr('title');
                var startRating = $(e.currentTarget).parents('section.clearFix').find('.metaData span').attr('title');
                var taRating = $(e.currentTarget).parents('section.clearFix').find('.metaData .review .taRating').attr('title');
                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_ImageScrolled", {
                    "hotelDetails": hotelTitle,
                    "starRating": startRating,
                    "taRating": taRating
                });
            },

            showIfHidden: function(e) {
                //console.log("showIfHidden", e);
                var rightArrow = $(e.currentTarget).find("div.rsArrow.rsArrowRight");
                //console.log("rightArrow", rightArrow);
                //console.log("rightArrow.style", $(rightArrow).style);
                // var style = $(e.currentTarget).style();
            },

            /*
             * @desc : updates trip summary displayed next to "modify search" link on top of the page
             */
            updateTripSummary: function( /* Hash params */ paramsHash, /* boolean */ render) {
                var renderObj = {},
                    copyParams, html, checkIn, checkOut,
                    pluralizeObj = CT.messages.hotel.pluralizeObj
                if (CT.app == 'dp')
                    copyParams = ['origin', 'destination', 'depart_date', 'num_rooms', 'adults', 'childs', 'infants'];
                else {
                    copyParams = ['from', 'city', 'state', 'country', 'area', 'poi', 'num_rooms', 'chk_in', 'chk_out', 'childs', 'adults', 'dateLessSearch', 'hotelId', 'hotelName'];
                    //paramsHash['adults'] = paramsHash['adults'] || 0;
                    //paramsHash['childs'] = paramsHash['childs'] || 0;
                    paramsHash['adults'] = 0;
                    paramsHash['childs'] = 0;
                    for (var i = 1; i <= paramsHash['num_rooms']; i++) {
                        paramsHash['adults'] = Int(paramsHash['adults']) + Int(paramsHash['adults' + i]);
                        paramsHash['childs'] = Int(paramsHash['childs']) + Int(paramsHash['children' + i]);
                    }
                    if (CT.subProd == "airBnb") {
                        paramsHash['childs'] = 0;
                    }
                }

                _.forEach(copyParams, function(param) {
                    if ((param == 'origin' || param == 'destination') && paramsHash[param]) {
                        renderObj[param] = paramsHash[param].split(',')[0];
                    } else {
                        renderObj[param] = paramsHash[param];
                    }
                });

                if (CT.app == 'dp') {
                    renderObj.deptDate = moment(paramsHash.depart_date, "DD/MM/YYYY").format("ddd, D MMM, YYYY");
                } else {
                    if (paramsHash.chk_in && paramsHash.chk_out) {
                        renderObj.checkInDate = moment(paramsHash.chk_in, "DD/MM/YYYY").format("ddd, D MMM");
                        renderObj.checkOutDate = moment(paramsHash.chk_out, "DD/MM/YYYY").format("ddd, D MMM");
                        renderObj.dateLessSearch = false;
                    } else {
                        renderObj.dateLessSearch = true;
                    }
                }

                checkIn = (paramsHash.chk_in) ? moment(paramsHash.chk_in, "DD/MM/YYYY") : "";
                checkOut = (paramsHash.chk_out) ? moment(paramsHash.chk_out, "DD/MM/YYYY") : "";
                renderObj.num_nights = checkOut ? checkOut.diff(checkIn, 'days') : "";

                if (renderObj.num_nights == 1) {
                    renderObj.oneRmNdNgt = true;
                } else {
                    renderObj.oneRmNdNgt = false;

                }

                _.forEach(pluralizeObj, function(eachCont) {
                    tmp = parseInt(renderObj[eachCont.key]);
                    if (tmp) {
                        if (tmp == 0) {
                            delete renderObj[eachCont.key];
                        } else {
                            renderObj[eachCont.key] = tmp + ' ' + (tmp == 1 ? eachCont.s : eachCont.p);
                        }
                    }
                });

                tmp = CT.cache[CT.settings.currentTab];
                tmp.searchParams = {};
                tmp.searchParams.processed = renderObj;
                tmp.searchParams.all = paramsHash;
                tmp.searchParams.defaults = {
                    nri: false
                };

                if (render) {
                    html = CT.to_html('TripSummaryTpl', renderObj);
                    $('.modifyBar .modifyLink').after(html);
                }
            },

            closeDeals: function(e) {
                e.preventDefault()
                $(e.target).closest('.mDeal').hide()
            }
        }



        // The main results view settings object
        var searchResultViewSettings = {

            attributes: {
                'class': 'resultContainer'
            },



            initialize: function() {
                // Trigger a clevertap event with formated data
                function triggerEventWithHotelIds() {
                    // Filter to get all unique hotel Ids and convert them to a single string seprated by +
                    inViewHotelIds = _.uniq(inViewHotelIds);
                    var hotelsList = _.reduce(inViewHotelIds, function (accumlator, e) { return accumlator + '+' + e })
                    CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_HotelsViewed', {
                        "source": "SRP",
                        "hotelsList": hotelsList
                    });
                }

                // The event must be triggered on session expire which has two definitions:
                // First when the user has spent clevertapSessionDurationMicroSec time.
                // Second when the use navigates away or closes this page.
                setTimeout(triggerEventWithHotelIds, clevertapSessionDurationMicroSec);
                window.addEventListener("unload", function (e) {
                    triggerEventWithHotelIds()
                });

                //TODO: move it to the right place : karthik
                CT.utils.resetCurrency();
                $('.resultContainer').hide()
                this.$el.appendTo('#Result').show();
                $(window).scroll(this.handleScroll);

                function invalidateBackCache() {
                    // won't add the page to the pageCache Ã¯Â¿Â½Ã¯Â¿Â½ leaving the page to load normally                    
                }
                if (window.addEventListener) {
                    window.addEventListener('pagehide', function(e) {
                        $('.glassShield').hide();
                        $('.interstitialWrapper').hide();
                        $('.booking.loading').removeClass('loading');
                    }, true);
                    //window.addEventListener("unload", invalidateBackCache, false);
                } else if (window.attachEvent) {
                    window.attachEvent('onpagehide', function() {
                        $('.glassShield').hide();
                        $('.interstitialWrapper').hide();
                        $('.booking.loading').removeClass('loading');
                    });
                    //window.attachEvent("unload", invalidateBackCache, false);

                }
                CT.cache[CT.settings.currentTab].eventsTimes = {};
                CT.cache[CT.settings.currentTab].eventsTimes.sid = [];
                //if mapview is already selected then on page reload instead of greeting it from CT.cahe take value form url params
                var viewType = '';
                if (CT.settings.routes && CT.settings.routes.getUrlParams) {
                    viewType = CT.settings.routes.getUrlParams().view;
                }
                CT.cache[CT.settings.currentTab].viewType = viewType || 'list' //CT.cache[CT.settings.currentTab].viewType || 'list';
            },



            subscriptions: {
                'liItem.update': 'updateItem'
                    //,'finalMasterJSON.ready' : 'updateMasterJson'
                    ,
                'loadingBar.set': 'setLoadingBar'
            },



            disableHotel: function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            },

            offerBanner: function(e) {
                var trackObj = {};
                trackObj['urlClicked'] = $(e.target).attr('href');
                var offerHeading = $(e.currentTarget).find('strong').text();
                var offerDescription = $(e.currentTarget).text();
                var offerName = offerDescription.match(/\b([A-Z]{1,})\b/g) || offerDescription.match(/\b([0-9]{1,})\b%/g) || [];
                offerHeading += offerName.join("+");
                CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_MotherOffer_clicked', {
                    "offerName": offerHeading
                });
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'Offers_Topbanner_Clicked', 'urlClicked:' + trackObj.urlClicked, '100');
            },


            changePhotoSlider: function(e) {
                if (window.twoCol == true) {
                    var ele = $(e.target).parents('li.listItem');
                    if (ele.length > 0) {
                        var slider = ele.find(".royalSlider").data('royalSlider');
                        if (slider)
                            slider.startAutoPlay();
                    }
                }
            },



            movePhotoSlider: function(e) {
                if (CT.cache[CT.settings.currentTab].sliderImgsloaded == false) return false;
                if (window.twoCol == true) {
                    var ele = $(e.target).parents('li.listItem');
                    if (ele.length > 0) {
                        var slider = ele.find(".royalSlider").data('royalSlider');
                        if (slider) slider.stopAutoPlay();
                    }
                }
            },



            events: {
                'click .rsSlide': 'showCurrentImage',
                'click .mDeal .close': 'closeDeals',
                'click li.listItem.disabled a': 'disableHotel',
                'click li.listItem.disabled button': 'disableHotel',
                'mouseover li.listItem': 'changePhotoSlider',
                'mouseout li.listItem': 'movePhotoSlider',
                'click .openQuickLook': 'openQuickLook',
                'click .tempFiltersButton': 'ipadHotelChanges',
                'click .closeFilter': 'ipadCloseFilter',
                'click .bookHotel': 'bookHotel',
                'click .shortlistHotel': 'shortListHotel',
                'click li a.close': 'removeShortListHotel',
                'click .compareHotel': 'openCompareHotelWindow',
                'change .selectSortersClick': 'triggerSorter',
                'click nav.sorters': 'triggerOptionChange',
                'click ul.viewSwitcher a': 'toggleMapListView',
                "click .badgeFilter li a": "triggerBadgeFilter",
                "click .backLink": "triggerListView",
                "click .tagList li": "triggerTagsFilter",
                "click .tagList li.promoTag": "toggleActiveState",
                "click #triggerPromoTagBtn": "promoTagBtnDone",
                "click .undoLastFilter": "undoLastFilter",
                'click .resetLink,.showAll': 'triggerResetFilter',
                'click .primaryFilterContent input': 'triggerFilters',
                'click .closeParent': 'removeContainerElement',
                'click .excludeNearByCities': 'excludeNearByCities',
                'click .checkAvail': 'checkAvailability',
                'click .requestBooking': 'requestBooking',
                'click .dismissUpsellButton': 'dismissUpsellBanner',
                'click .perRoomPerNightDispHeader': 'perRoomPerNightDisp',
                'click .totPriceDispHeader': 'perRoomPerNightDisp',
                'click .allHotelsLink': 'shwAllHotels',
                'click .curate': 'openCurateModal',
                'click .agToolTip': 'showFareBreakUp',
                'click .showComm': 'showCommission',
                'click .hideComm': 'hideCommission',
                'click .emailHt': 'showEmailHotelModal',
                'click .printHt': 'showPrintHotelModal',
                'click #cancellationCharge': 'showCancelTipsy',


                //'click a.nextEle' : 'showFirstRunTipsy',

                'click .viewShortlistHotels': 'viewShortlistHotels',
                //'click .placeType a' : 'triggerPTFilter',
                'click .hotelPics .thumbnails a': 'initHotelPicModalWindow',
                'click .dpList .booking': 'initiatePackageBooking',
                'click .hotelDetails': 'initHotelModalWindow',
                'contextmenu a.hotelDetails': 'addAdditionalValues',
                'click .showDetails': 'initHotelModalWindow',
                'click .undoFilter': 'initUndoFilter',
                'click .flightInfo span.changeFlights': 'openChangeFlightsModal',
                'click .modifySearch': 'redirectToHomePage',
                'click .guidedClose': 'guidedScrollClose',
                'click .openGuidedNav': 'openGuidedBlock',
                'click .closePinpointBanner': 'closePinpointBanner',
                'click .pinPoint': 'showPinPointModalWindow',
                'click .filterButton': 'toggleAltFilters',
                'click .weekendFilterPopup .closeButton': 'hideAltFilters',
                'click .getawaysNoHotels': 'getawaysNoHotels',
                'mouseover .airLogo': 'updateAirlineName',
                'mouseout .airLogo': 'revertAirlineName',
                'click .royalSlider div.rsArrowLeft': 'logGaLTtrack',
                'click .royalSlider div.rsArrowRight': 'logGaRTtrack',
                // 'mouseover .royalSlider div.rsArrow': 'showIfHidden',
                //'mouseover .pinPointInit' : 'showPinPoint',
                //'mouseout .pinPointInit' : 'dontShowPinPoint',

                'click .opaqueTipsy': 'showOpaqueTipsy',
                'keyup .smallSearch input': 'checkForEmptyInput',
                'keyup .mapViewSearch input': 'checkForEmptyInput',

                'filters.apply': 'applyFilters',
                'checkAvailability.trigger': 'checkAvailability',
                'separator.add': 'addSeparator',
                'separator.removeAll': 'removeAllSeparator',
                'htRmRatesDiff.update': 'updateHtRmRatesDiff',
                'amenities.show': 'showAmenities',
                'tripSummary.update': 'updateTripSummary',
                'zeroOrFewResultNote.show': 'showZeroOrFewResultNote',
                'infiniteScroll.init': 'initInfScroll',
                'tooPicky.show': 'showTooPickyMessage',
                'results.update': 'update',

                'click .clearFieldAuto': 'removeSearchFilter',
                'finalMasterJSON.ready': 'updateMasterJson',
                'realTimePriceUpdate.init': 'realTimePriceUpdate',
                'changeCurrency.trigger': 'triggerChangeCurrency',
                'nearByNotification.hide': 'hideNearByNotification',
                'loadPlacesAutocomplete': 'loadPlacesAutocomplete',
                'showGnBannerOnload': 'showGnBannerOnload',
                // 'submit #locationBasedHotels': 'showNearbyHotels',
                'click .cityCentre': 'triggerLocationSearch',
                'click #clearLocationSort': 'clearLocationSort',
                'click .clearLocationSortMap': 'clearLocationSort',
                'click .shwMoreDeals': 'shwMoreDeals',
                'click .mDeal p a ': 'offerBanner',
                'click p.merchandising a.weak': 'srpOffer',
                'click .dodList': 'triggerDealOfTheDay',
                'keyup .showNearBy': 'toggleTopPlaces',
                'focus #showNearByBox': 'showTopPlaces',
                'blur #showNearByBox': 'checkPlaceSelected',
                'click .locationToSort': 'updateLocationSearch',
                'mouseover .spoonForm': 'showClearButton',
                'mouseout .spoonForm': 'hideClearButton',
                'mouseover .mapViewLocationSearch': 'showClearButtonMap',
                'mouseout .mapViewLocationSearch': 'hideClearButtonMap',
                // 'keyup #showNearByBox': 'loadGooglePlacesApi',
                'click .presetFilter': 'triggerResetFilter',
                'click .shwMoreChains': 'shwMoreChains',
                'click .viewLocation': 'toggleMapListView',
                'click .clearTags': 'clearTagsFilter',
                'click .showAllHotelsForPoi': 'showAllHotelsForPoi',
                'mouseenter .strikeThroughPrice': 'showStpPop',
                'mouseenter #amenitiesLabel span[rel="tTooltip"]': 'showAmenitiesPop',
                'mouseout #amenitiesLabel span[rel="tTooltip"]': "showAmenitiesPopMouseOut",
                "click .metaTags__more": "showMoreTags",
                "click button.shortlist": "shortListHotels",
                "mouseenter .flex.checkbox-interest": "lolBannerHover",
                "mousedown .flex.checkbox-interest": "lolBannerFilter",
                "click .stickyBarShortlist": "goToShortlistPage"
            },
            lolBannerFilter: function(e) {
                window.showLolBanner = false;
                console.log("magicMagicWhereArtThough: e", e);
                var interestName = e.target.innerText || e.target.value
                if (interestName === "Nature" || interestName === "nature") {
                    interestName = "Nature and Wildlife";
                }
                if (window.openModalAndAddInterest) {
                    window.openModalAndAddInterest(interestName, true);
                } else {
                    // $("div.list-lol-banner").parent().hide();
                }
                window.fireLolClevertapEvent("Hotels_SRP_LoLBanner_click", { source: "banner", banner: true });
            },
            lolBannerHover: function(e) {
                // change background image on hover
                var interestName = e.target.innerText || e.target.value
                console.log("interestName", interestName);
                if (!e.target.innerText) {
                    console.log("e", e);
                }
                $(".image-content").css("background-image","url('" + window.staticBaseDomain + "/images/lol-banner/" + interestName.toLowerCase() + ".svg')");
            },
            shortListHotels: function(e) {
                var isLoggedIn =  CT.utils.readCTAuthCookie();
                var $target = $(e.currentTarget);
                var url = "";
                var type = $target.hasClass("shortlisted") ? "remove" : "add";
                var hotelId = $target.parents(".listItem").attr("id");
                var hotelObj = CT.masterJson.getHotel(hotelId);
                var currSListLen = CT.masterJson.getShortListedHotelCount();
                if(type == "add"){
                    $target.attr('original-title', '');
                    // original-title="Shortlist this hotel for comparison and easy access later"
                    hotelObj.isShortlisted = true;
                    CT.masterJson.setShortlistedHotelCount(currSListLen + 1);
                    url = "/hotels/slapi/shortlist/add";
                    CT.masterJson.setHotel(hotelObj);
                    CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_shortlist_addHotel',{
                        "source": "SRP",
                        "hotelDetails": hotelObj.nm,
                        "starRating": hotelObj.sr,
                        "price": hotelObj.priceInfo.rms[0].tot,
                        "taRating": hotelObj.tar,
                        "PAH": hotelObj.pp ? "Yes" : "No",
                        "hotelType": hotelObj.vtsEnabled ? "360" : "",
                        "srpFeatures": hotelObj.dod ? "DoTD" : ""
                    });
                }else{
                    $target.attr('original-title', 'Shortlist this hotel for comparison and easy access later');
                    hotelObj.isShortlisted = false;
                    CT.masterJson.setShortlistedHotelCount(currSListLen - 1);
                    CT.masterJson.setHotel(hotelObj);
                    CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_shortlist_deleteHotel',{
                        "source": "SRP",
                        "hotelDetails": hotelObj.nm,
                        "starRating": hotelObj.sr,
                        "price": hotelObj.priceInfo.rms[0].tot,
                        "taRating": hotelObj.tar,
                        "PAH": hotelObj.pp ? "Yes" : "No",
                        "hotelType": hotelObj.vtsEnabled ? "360" : ""
                    });
                    url = "/hotels/slapi/shortlist/delete";
                }
                $target.toggleClass("shortlisted").prop('disabled', true); 
                CT.fire("shortListedHotelCount.update");
                //write ajax call to trigger API call
                var searchParams = CT.cache[CT.settings.currentTab].searchParams.all;
                var numOfRooms = searchParams.num_rooms || 0;
                var adultList = [];
                var childList = [];
                var ca = [];
                for(var i =0 ; i < numOfRooms ; i ++) {
                    adultList.push(searchParams["adults"+(i+1)]);
                    childList.push(searchParams["children"+(i+1)]);
                    ca.push(searchParams["ca"+(i+1)] || []);
                }
                var dataToBeSent = [{
                    "sln" : "mylist",
                    "ids" : [hotelId],
                    "sc" : {
                        "city": searchParams.city,
                        "state": searchParams.state,
                        "country": searchParams.country,
                        "area": "",
                        "dest_code": "",
                        "chk_in": searchParams.chk_in || "",
                        "chk_out": searchParams.chk_out || "",
                        "adult": adultList,
                        "children": childList,
                        "num_rooms": numOfRooms || "",
                        "ca": ca   
                    }
                }];

                if(!isLoggedIn){
                    if(hotelObj.isShortlisted){
                        var hotel = {
                            "nm": hotelObj.nm,
                            "im": hotelObj.im,
                            "sr": hotelObj.sr,
                            "latlng": hotelObj.latlng,
                            "tar": hotelObj.tar,
                            "tarev": hotelObj.tarev,
                            "ar": hotelObj.ar,
                            "id": hotelObj.id
                        }
                        CT.utils.shortlists.add(CT.cache[CT.settings.currentTab].searchParams.all.city, hotel, dataToBeSent[0].sc);                            
                        CT.masterJson.setShortlistId(CT.cache[CT.settings.currentTab].searchParams.all.city);
                    } else {
                        CT.utils.shortlists.remove(CT.cache[CT.settings.currentTab].searchParams.all.city, hotelObj.id);
                    }
                    $target.prop('disabled', false);
                } else {
                    $.ajax({
                        url : url,
                        type:'POST',
                        data : JSON.stringify(dataToBeSent),
                        contentType: "application/json; charset=utf-8",
                        success: function(data){
                            $target.prop('disabled', false);
                            if(data[0]){
                                CT.masterJson.setShortlistId(data[0].shortlistId);                                
                            }
                        },
                        error :function(err){
                            $target.toggleClass("shortlisted").prop('disabled', false); 
                            CT.masterJson.setShortlistedHotelCount(currSListLen);
                            CT.fire("shortListedHotelCount.update");    
                        }
                    });   
                }
            },
            goToShortlistPage: function(e) {
                var shortlistId = CT.masterJson.getShortlistId() || "";
                var url = "/hotels/shortlist/" + shortlistId + "?" + window.location.search.substring(1) + "&pahCCRequired=false&pageName=SRP";
                //console.log("Redirecting to shortList page ---- >>> ");
                window.open(url, "_blank");

            },
            showStpPop: function(e) {
                var stpType = $(e.currentTarget).attr("data-stpType");
                var discPer = $(e.currentTarget).attr("data-discPerc");
                disPer = discPer ? Number(Number(discPer).toFixed(1)) : 0;
                //Tracking event for strike through pop show
                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_STP_Hover", {
                    "stpType": stpType
                });
            },
            showAmenitiesPop: function(e) {
                var timeout = null;
                var ele = $(e.currentTarget)
                var eleParent = ele.parents('section.clearFix');
                timeout = setTimeout(function() {
                    var hotelTitle = eleParent.find('nav.summary .info h2 a').attr('title');
                    var startRating = eleParent.find('.metaData span').attr('title');
                    var taRating = eleParent.find('.metaData .review .taRating').attr('title');
                    var amenityName = ele.attr('original-title');
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_Amenities_Hover", {
                        "hotelDetails": hotelTitle,
                        "starRating": startRating,
                        "taRating": taRating,
                        "amenityName": amenityName
                    });
                    $(e.currentTarget).removeAttr('data-timeout');
                }, 100);
                $(e.currentTarget).attr('data-timeout', timeout);
            },
            showAmenitiesPopMouseOut: function(e) {
                var timeout = parseInt($(e.currentTarget).attr('data-timeout'));
                clearTimeout(timeout);
            },
            triggerListView: function(e) {
                if (CT.isLocationEnabled) {
                    this.$el.find(".propertySection a.presetFilter").show();
                    this.$el.find(".propertySection a.viewLocation").show();
                }
                CT.cache[CT.settings.currentTab].viewType = "list"
                this.$el.find('.mapCanvas').css('display', 'none')
                CT.fire("changeView", [{
                    view: "listView"
                }]);
            },
            shwMoreChains: function(event) {
                event.stopPropagation();
                $("#ResultContainer_" + CT.settings.currentTab).find(".filters").css({
                    "z-index": "1"
                })
                CT.utils.showModalDialog('/hotelstatic/includes/modal_hotelChains.shtml', '400px', '515px', true, false);
            },
            showOpaqueTipsy: function(e) {
                var $thisTag = $(e.target);
                var hotelId = $thisTag.closest("li.listItem").attr("id");
                var tipsyMarkup = CT.masterJson.getHotel(hotelId).tipsyMarkup;
                $thisTag.attr("data-tipsytitle", tipsyMarkup).tipsy({
                    gravity: 'NW',
                    trigger: 'manual',
                    className: 'popOver inPopOver light',
                    html: true,
                    opacity: 1,
                    title: "data-tipsytitle",
                    addCloseButton: true
                }).tipsy('show');
            },
            triggerDealOfTheDay: function(e) {
                var $thisTag = $(e.target);
                var hotelId = $thisTag.closest("li.dodList").attr("data-hotelId");
                var hotelModelURL = CT.utils.helperFunctions.openHotelModalV2(hotelId, undefined, "#");
                window.open(hotelModelURL, "_blank");
            },
            clearTagsFilter: function(e) {
                //console.log("In clearTagsFilter");
                // window.secondarySort = 'featured';
                CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter = '';
                this.$el.find("nav.tagsFilter input:checked").each(function() {
                    $(this).attr('checked', false)
                });
                this.$el.find('.tagList li.active').each(function() {
                    $(this).removeClass('active')
                })
                this.$el.find(".tagBoxClear").hide();
                // Do not clear sort, requirement of  HOTCON-377 
                // $('#ResultContainer_' + CT.settings.currentTab).find("section.secondaryBar nav.sorters a").removeClass("current sortAsc sortDes");
                // $('#ResultContainer_' + CT.settings.currentTab).find("section.secondaryBar nav.sorters a[data-sort='featured']").addClass("current");
                // CT.fire('sorterUrlParams.set', [{
                //     sort: "featured"
                // }]);
                CT.utils.trackers.mixpanelTrackingData.numTagsClicked = "0";
                CT.utils.trackers.mixpanelTrackingData.tagsSelected = "N/A";
                CT.numTagsClicked = '';
                CT.tagsSelected = [];
                //console.log("CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter", CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter);
                //console.log("In clearTagsFilter before last line");
                //for defining sort when clear filter is clicked
                var currentSortOrder = CT.cache[CT.settings.currentTab].searchParams.all.sort_order || (window.secondarySort==='ta'?'desc':'asc');                
                CT.fire('sorterUrlParams.set', [{sort: window.secondarySort, sort_order: currentSortOrder }]);
                CT.fire('filters.apply');
            },
            shwMoreDeals: function(e) {
                CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_HotelLevelOffer_click', {
                    "linkType": "More Offers"
                });
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                $(e.target).closest(".listItem").find(".hiddenDeal").toggle();
                $(e.target).hide();
                //$(".hiddenDeal").toggle();
            },
            srpOffer: function(e) {
                if ($(e.target).text().indexOf('offer') != -1) {
                    CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_HotelLevelOffer_click', {
                        "linkType": "See Offer Details"
                    });
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'Offers_OnSRPresult_Clicked', $(e.target).closest("li").index() + 1 + ':' + $(e.target).attr('href'), '100');
                }
            },
            loadPlacesAutocomplete: function(e) {
                //console.log("loadPlacesAutocomplete");
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab),
                    htLatlng;
                var mjson = CT.masterJson.get();
                var hotelsArr = mjson.ht;
                var markerBounds = new google.maps.LatLngBounds();
                CT.cache[CT.settings.currentTab].autoCompleteLatitude = ""
                CT.cache[CT.settings.currentTab].autoCompleteLangitude = ""
                var hslatlng = _.filter(hotelsArr, function(obj) {
                    return (obj.latlng) ? obj : '';
                });
                _.each(hslatlng, function(item, i) {
                    htLatlng = new google.maps.LatLng(item.latlng[0], item.latlng[1]);
                    markerBounds.extend(htLatlng);
                })
                var latLong, defaultBounds;
                var city = CT.cache[CT.settings.currentTab].searchParams.all.city;
                var country = CT.cache[CT.settings.currentTab].searchParams.all.country;
                var geocoder = new google.maps.Geocoder();
                var that = this;
                geocoder.geocode({
                    'address': city
                }, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        lat = results[0].geometry.location.lat()
                        lng = results[0].geometry.location.lng();
                        //Get SW and NE bounds
                        var SWLat = results[0].geometry.viewport.getSouthWest().lat();
                        var SWLng = results[0].geometry.viewport.getSouthWest().lng();
                        var NELat = results[0].geometry.viewport.getNorthEast().lat();
                        var NELng = results[0].geometry.viewport.getNorthEast().lng();
                        //cityLatandLng
                        var cityLatLng = {
                            'lat': lat,
                            'lng': lng
                        };
                        //set the city name to use in the shownearbyhotels function
                        var defaultBounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng({
                                lat: SWLat,
                                lng: SWLng
                            }), new google.maps.LatLng({
                                lat: NELat,
                                lng: NELng
                            }));
                        var geoLocation = {
                            lat: SWLat,
                            lng: NELng
                        };
                        var circle = new google.maps.Circle({
                            center: new google.maps.LatLng(geoLocation),
                            radius: window.googleHotelSearchRadius
                        });
                        var options = {
                            bounds: defaultBounds,
                            offset: 3,
                            componentRestrictions: {
                                country: CT.cache[CT.settings.currentTab].searchParams.all.country
                            },
                            fields: ["name", "geometry.location", "place_id", "formatted_address",'types']
                        };
                        function autoCompleteCall(localitySearchString) {
                            try {
                                var url = 'https://gql.cleartrip.com/graphql/googlelocalitysearch?'
                                +'input='+localitySearchString+'&'
                                +'location='+cityLatLng.lat+',' +cityLatLng.lng+'&'
                                +'radius='+60000+'&'
                                +'strictbounds=true&'
                                 if (CT.cache[CT.settings.currentTab].searchParams.all.country=== 'IN' && CT.settings.hotel.useMapMyIndia) {
                                    url = 'https://gql.cleartrip.com/graphql/mapmyindialocalitysearch?'
                                    +"query="+localitySearchString+'&'
                                    +'location='+cityLatLng.lat+',' +cityLatLng.lng+'&'
                                    +"city="+CT.cache[CT.settings.currentTab].searchParams.all.city+'&'
                                    +"state="+CT.cache[CT.settings.currentTab].searchParams.all.state
                                }
                                var autocompleteResp =  $.get(url)
                                .done(function (data) {
                                    $currentTab.find('#localityPredictionDiv').empty();
                                    window.localityPredictions = data.predictions
                                    if (localityPredictions) {
                                        $currentTab.find('#localityPredictionDiv').show() 
                                        var autocompleteListHTML = ''
                                        localityPredictions.forEach(function (pridiction, index) {
                                            var separator = ','
                                            if(pridiction.description.indexOf(',') === -1 && pridiction.description.indexOf('-') > 2){
                                                separator = '-'
                                            }
                                            var pridictionElements = pridiction.description.split(separator)
                                            var matched = pridictionElements[0]
                                            pridictionElements.splice(0, 1)
                                            var remaining = pridictionElements.join(',')
                                            autocompleteListHTML += '<div class="prediction-item" id="predictionItemDiv"' +
                                                'index=' + '"' + index + '"' +
                                                'name=' + '"' + pridiction.description + '"' + '>'
                                                +'<span class="prediction-matched">'+matched+'</span>'+(remaining && ', ' +remaining)+'</div>'
                                        })
                                        $currentTab.find('#localityPredictionDiv').append($(autocompleteListHTML))
                                    }
                                }).fail(function(e) {
                                    console.log('localitySearch FAILED: ', e)
                                  })
                            }catch(e){
                                console.log('ERROR IN localitySearch: ', e)
                            }
                        }
                        $currentTab.find('#showNearByBox').on('keyup', function(e) {
                            var n = 2
                            var localitySearchString = e.target.value;
                            if (localitySearchString.trim().length > n) {
                                if (window.searchTimeout) {
                                    clearTimeout(window.searchTimeout)
                                }
                                window.searchTimeout = setTimeout(function () {            
                                    autoCompleteCall(localitySearchString)
                                },500)
                            } else {
                                $currentTab.find('#localityPredictionDiv').empty();                                 
                            }
                        })
                        $currentTab.find('#localityPredictionDiv').on('click', '#predictionItemDiv', function (e) {
                            e.stopPropagation();
                            try {
                                var searchInput = e.currentTarget.getAttribute('name')
                                var selectedLoactionIndex = e.currentTarget.getAttribute('index')
                                $currentTab.find('#showNearByBox').val(searchInput)
                                if (CT.cache[CT.settings.currentTab].searchParams.all.country
                                    === 'IN' && CT.settings.hotel.useMapMyIndia){
                                        var place = localityPredictions[selectedLoactionIndex].placeDetails || {};
                                        var address = place.formatted_address || '';
                                        var lat = currentLat = CT.cache[CT.settings.currentTab].autoCompleteLatitude;
                                        var lng = currentLng = CT.cache[CT.settings.currentTab].autoCompleteLangitude;
                                        if (place.lat && place.lng) {
                                            lat = place.lat;
                                            lng = place.lng
                                        }
                                        var result = place.address_components;
                                        //var typeOfArea = place.types.indexOf("sublocality")>-1 ? "sublocality" : place.types.indexOf("point_of_interest")>-1 ? "point_of_interest" : "others";
                                        // CT.cache[CT.settings.currentTab].isGoogleHotelNameSearch = (place.types[0] === "lodging");
                                        var typeOfArea = "point_of_interest"
                                        window.cityNameTomap = "";
                                        var mJson = CT.masterJson.get();
                                        if (CT.cache[CT.settings.currentTab].autoCompleteLatitude === "" && mJson.clni) {
                                            currentLat = mJson.clni.clat;
                                            currentLng = mJson.clni.clng;
                                        }
                                        var distanceFromCurrentSearch = CT.utils.helperFunctions.getDistanceFromLatLonInKm(lat, lng, currentLat, currentLng);
                                        CT.cache[CT.settings.currentTab].autoCompleteLatitude = lat
                                        CT.cache[CT.settings.currentTab].autoCompleteLangitude = lng
                                        CT.cache[CT.settings.currentTab].autocompleteValSelected = true
                                        CT.cache[CT.settings.currentTab].setSearchTypeToLocation = true
                                        // $currentTab.find("#locationBasedHotels button").trigger('click',[lat,lng,that.$el.find("#showNearByBox"),typeOfArea])
                                        $currentTab.find('#localityPredictionDiv').empty();
                                        $currentTab.find('#localityPredictionDiv').hide();
                                        
                                        that.showNearbyHotels(lat, lng, that.$el.find("#showNearByBox"), typeOfArea, cityLatLng);
                                        CT.cache[CT.settings.currentTab].searchParams.all.poi=(address.split(',')[0] || address)
                                        CT.cache[CT.settings.currentTab].searchParams.all.poiLat=lat
                                        CT.cache[CT.settings.currentTab].searchParams.all.poiLng=lng
                                        CT.settings.routes.navigate('/results?' + _.serialize(CT.cache[CT.settings.currentTab].searchParams.all), {
                                            trigger: false,
                                            replace: true
                                        });
                                        /* var latitude = place.geometry.location.A;
                                        var longitude = place.geometry.location.F;
                                        var mesg = "Address: " + address;
                                        mesg += "\nLatitude: " + latitude;
                                        mesg += "\nLongitude: " + longitude;
                                        alert(mesg);*/
                                        CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Places_Autocomplete', address, '100');
                                        CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_locality_search", {
                                            "searchQuery": searchInput,
                                            "lenSearchedItem": String(searchInput.length),
                                            "selectedLocation": address.name || address,
                                            "distanceFromCurrentSearch": String(distanceFromCurrentSearch),
                                            "dropOff": "No",
                                            "LS_Source_Point":"MMI"
                                        });
                                    }
                                    else{
                                        var geocoder = new window.google.maps.Geocoder();
                                        var OK = window.google.maps.GeocoderStatus.OK;
                                        geocoder.geocode({ address: searchInput}, function (results, status) {
                                            if (status !== OK) {
                                                console.log('ERROR in geocoder')
                                                return
                                            }
                                            var place = results[0] || {};
                                            var address = place.formatted_address || place;
                                            var lat = currentLat = CT.cache[CT.settings.currentTab].autoCompleteLatitude;
                                            var lng = currentLng = CT.cache[CT.settings.currentTab].autoCompleteLangitude;
                                            if (place.geometry && place.geometry.location) {
                                                lat = place.geometry.location.lat();
                                                lng = place.geometry.location.lng()
                                            }
                                            var result = place.address_components;
                                            //var typeOfArea = place.types.indexOf("sublocality")>-1 ? "sublocality" : place.types.indexOf("point_of_interest")>-1 ? "point_of_interest" : "others";
                                            CT.cache[CT.settings.currentTab].isGoogleHotelNameSearch = (place.types[0] === "lodging");
                                            var typeOfArea = "point_of_interest"
                                            window.cityNameTomap = "";
                                            for (var i in result) {
                                                var typesTocheck = result[i].types;
                                                for (var j in typesTocheck) {
                                                    if (typesTocheck[j].trim() == "locality") {
                                                        window.cityNameTomap = result[i]["long_name"];
                                                        break;
                                                    }
                                                }
                                            }
                                            var mJson = CT.masterJson.get();
                                            if (CT.cache[CT.settings.currentTab].autoCompleteLatitude === "" && mJson.clni) {
                                                currentLat = mJson.clni.clat;
                                                currentLng = mJson.clni.clng;
                                            }
                                            var distanceFromCurrentSearch = CT.utils.helperFunctions.getDistanceFromLatLonInKm(lat, lng, currentLat, currentLng);
                                            CT.cache[CT.settings.currentTab].autoCompleteLatitude = lat
                                            CT.cache[CT.settings.currentTab].autoCompleteLangitude = lng
                                            CT.cache[CT.settings.currentTab].autocompleteValSelected = true
                                            CT.cache[CT.settings.currentTab].setSearchTypeToLocation = true
                                            // $currentTab.find("#locationBasedHotels button").trigger('click',[lat,lng,that.$el.find("#showNearByBox"),typeOfArea])
                                            $currentTab.find('#localityPredictionDiv').empty();
                                            $currentTab.find('#localityPredictionDiv').hide();
                                            that.showNearbyHotels(lat, lng, that.$el.find("#showNearByBox"), typeOfArea, cityLatLng);
                                            CT.cache[CT.settings.currentTab].searchParams.all.poi=(address.split(',')[0] || address)
                                            CT.cache[CT.settings.currentTab].searchParams.all.poiLat=lat
                                            CT.cache[CT.settings.currentTab].searchParams.all.poiLng=lng
                                            CT.settings.routes.navigate('/results?' + _.serialize(CT.cache[CT.settings.currentTab].searchParams.all), {
                                                trigger: false,
                                                replace: true
                                            });
                                            /* var latitude = place.geometry.location.A;
                                            var longitude = place.geometry.location.F;
                                            var mesg = "Address: " + address;
                                            mesg += "\nLatitude: " + latitude;
                                            mesg += "\nLongitude: " + longitude;
                                            alert(mesg);*/
                                            CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Places_Autocomplete', address, '100');
                                            CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_locality_search", {
                                                "searchQuery": searchInput,
                                                "lenSearchedItem": String(searchInput.length),
                                                "selectedLocation": address.name || address,
                                                "distanceFromCurrentSearch": String(distanceFromCurrentSearch),
                                                "dropOff": "No",
                                                "LS_Source_Point":"Google"
                                            });
                                        });
                                    }
                                } catch (e) {
                                    console.log(e)
                            }
                        });
                        // $currentTab.find('#mapAutocomplete').on('keyup', function(e) {
                        //     var n = 2
                        //     if ($(this).val().length <= n) {
                        //         google.maps.event.clearInstanceListeners($currentTab.find('#mapAutocomplete')[0]);
                        //         $(".pac-container").remove();
                        //         return
                        //     } else {
                        //         //google.maps.event.clearInstanceListeners($currentTab.find('#showNearByBox')[0]);
                        //         if ($(".pac-container").length == 0) {
                        //             var places = new google.maps.places.Autocomplete($currentTab.find('#mapAutocomplete')[0], options);
                        //             places.setBounds(circle.getBounds());
                        //             /*var searchBox = new google.maps.places.SearchBox($currentTab.find('#showNearByBox')[0], {
                        //                          bounds: markerBounds
                        //                      });*/
                        //             //new google.maps.places.Autocomplete((document.getElementById('autocomplete')),{types: ['geocode']});
                        //             google.maps.event.addListener(places, 'place_changed', function() {
                        //                 var place = places.getPlace();
                        //                 var address = place.formatted_address;
                        //                 var lat = place.geometry.location.lat();
                        //                 var lng = place.geometry.location.lng();
                        //                 //var latlng = new google.maps.LatLng(lat, lng)
                        //                 var result = place.address_components;
                        //                 //var typeOfArea = place.types.indexOf("sublocality")>-1 ? "sublocality" : place.types.indexOf("point_of_interest")>-1 ? "point_of_interest" : "others";
                        //                 var typeOfArea = "point_of_interest"
                        //                 window.cityNameTomap = "";
                        //                 for (var i in result) {
                        //                     var typesTocheck = result[i].types;
                        //                     for (var j in typesTocheck) {
                        //                         if (typesTocheck[j].trim() == "locality") {
                        //                             window.cityNameTomap = result[i]["long_name"];
                        //                             break;
                        //                         }
                        //                     }
                        //                 }
                        //                 CT.cache[CT.settings.currentTab].autoCompleteLatitude = lat
                        //                 CT.cache[CT.settings.currentTab].autoCompleteLangitude = lng
                        //                 CT.cache[CT.settings.currentTab].autocompleteValSelected = true
                        //                 // $currentTab.find("#locationBasedHotels button").trigger('click',[lat,lng,that.$el.find("#showNearByBox"),typeOfArea])
                        //                 that.showNearbyHotels(lat, lng, that.$el.find("#mapAutocomplete"), typeOfArea, cityLatLng);

                        //                 /* var latitude = place.geometry.location.A;
                        //                      var longitude = place.geometry.location.F;
                        //                      var mesg = "Address: " + address;
                        //                      mesg += "\nLatitude: " + latitude;
                        //                      mesg += "\nLongitude: " + longitude;
                        //                      alert(mesg);*/
                        //                 CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Places_Autocomplete', address, '100');
                        //                 $currentTab.find('.propertySection .viewLocation').hide();
                        //             });
                        //         }
                        //     }
                        // })

                        //                 $currentTab.find('#showNearByBox').on('keyup', function(e) {
                        // var inputVal=$(e.target).val();
                        // getPlacesPredictions(inputVal)       
                        //                 });
                    }
                });
            },
            showAllHotelsForPoi: function() {
                console.warn("showAllHotelsForPoi");
                $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', false)
                //CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal=false
                CT.cache[CT.settings.currentTab].showFewHotelsDistance = ""
                CT.cache[CT.settings.currentTab].plceselected = false
                CT.cache[CT.settings.currentTab].showAllPoiClicked = true
                CT.fire('filters.apply')
            },
            showCurrentImage: function(e) {
                e.stopPropagation();
                var royalSlider = $('#' + $(e.target).parents('li.listItem').attr('id') + ' .royalSlider').data('royalSlider');
                if (royalSlider) {
                    $(e.target).parents('li.listItem').first().find('span.hotelDetails').click();
                }
                return false;
            },

            addAdditionalValues: function(e) {

                var hotelV2 = window.hotelModalV2;
                if (CT.subProd !== "wg" && hotelV2) {
                    var $thisTag = $(e.target),
                        hotelId, tagHash,hotelSlugId;
                    hotelId = $thisTag.closest("li.listItem").attr("id");
                    hotelSlugId = $thisTag.closest("li.listItem").attr("data-hotelslugid");
                    tagHash = $thisTag.attr("data-hash");
                    if (e.target.tagName == "A") {
                        var hotelModelURL = CT.utils.helperFunctions.openHotelModalV2(hotelId, undefined, tagHash,hotelSlugId);
                        $thisTag.attr("href", hotelModelURL)
                    }
                }
            },
            getawaysNoHotels: function(e) {
                var url = $(e.target).closest("li").attr("data-href");
                var win = window.open(url, '_blank');
                win.focus();
            },
            openCurateModal: function(e) {
                CT.utils.showModalDialog('/hotelstatic/includes/curation_Modal.shtml', '90%', '480px', 'yes', false, undefined, undefined, true, undefined, undefined, undefined);
            },
            triggerFilters: function(e) {
                var chkdEle = [];
                var that = this;
                this.$el.find('.altFiltersForm input').closest("label").removeClass("selected");
                var _status;
                if (this.$el.find('.filtersForm input[name="destinationsTheme"]').val() == $(e.target).val()) {
                    $(e.target).removeAttr("checked");
                    CT.utils.addHiddenField(this.$el.find('.filtersForm'), "destinationsTheme", "")
                } else {
                    $(e.target).closest("label").addClass("selected");
                    CT.utils.addHiddenField(this.$el.find('.filtersForm'), "destinationsTheme", this.$el.find('.altFiltersForm input:checked').val())
                }
                $.each(this.$el.find('.destinations input'), function(index1, value1) {
                    $(value1).attr('checked', false) //.removeClass('marked');
                    $(value1).closest("label").removeClass("selected")
                })
                this.$el.find('.filtersForm').trigger('triggerFilters');
                _status = $(e.target).is(':checked') ? "On" : "Off"
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_DestinationsTheme', 'DestinationsTheme_' + $(e.target).next("span").html().trim(" ") + "_" + _status, '100');

            },
            triggerLocationSearch: function(e) {
                console.warn("triggerLocationSearch");
                e.preventDefault();
                var $thisTag = $(e.target);
                $('.showNearBy').val($thisTag.html());
                this.showNearbyHotels($thisTag.parent().parent().find('.showNearBy'));
            },
            showNearbyHotels: function(latitude, longitude, ele, typeOfArea, cityLatLng) {
                if (arguments.length == 1)
                    return;
                this.$el.find(".googleWidget").removeClass("slideMeDown");
                // $(e.target).find("button").addClass("loading");
                var that = this;
                window.locationselectedMixpanel = true
                var currentCity = CT.cache[CT.settings.currentTab].searchParams.all.city;
                //window.typeOfArea = typeOfArea
                var nearByCityMap = CT.masterJson.get().ncm ? CT.masterJson.get().ncm : "";
                var isInTheCity = false;
                var toFormatedAddress;
                var getLocationValue = $(ele).val();
                if (getLocationValue != "") {
                    CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal = true
                    CT.cache[CT.settings.currentTab].plceselected = true
                    CT.cache[CT.settings.currentTab].firsTimePlaceSelected = true
                    // CT.cache[CT.settings.currentTab].showFewHotelsDistance = CT.masterJson.get().hdfmn ? CT.masterJson.get().hdfmn : ""
                    CT.cache[CT.settings.currentTab].showFewHotelsDistance = CT.masterJson.get().hdfmn ? "99999999" : ""
                }
                // if((CT.cache[CT.settings.currentTab].searchParams.all.poi[0]=="" || CT.cache[CT.settings.currentTab].searchParams.all.poi=="" ) && getLocationValue!=""){
                //  CT.cache[CT.settings.currentTab].searchParams.all.poi=[]
                //  CT.cache[CT.settings.currentTab].searchParams.all.poi.push(getLocationValue.split(',')[0])
                // }
                //                
                //Restricting Location Search 100Kms within the city
                // var distanceOfArea=CT.utils.helperFunctions.getDistanceFromLatLonInKm(latitude,longitude,cityLatLng.lat,cityLatLng.lng);
                // if(distanceOfArea>0){
                toFormatedAddress = getLocationValue;
                isInTheCity = true;
                that.sortPlacesnearby(latitude, longitude, toFormatedAddress, $(ele), isInTheCity, "googleAutocomple", typeOfArea);
                // }
                // else{
                //  toFormatedAddress=getLocationValue;
                //  that.sortPlacesnearby(latitude, longitude, toFormatedAddress, $(ele), isInTheCity, "googleAutocomple", typeOfArea);
                // }
                /*
                var checkCityMap = function() {
                    var flag = false;
                    _.each(nearByCityMap, function(item, idx) {
                        if (getLocationValue.toLowerCase().indexOf(item.toLowerCase()) >= 0)
                            flag = true;
                    })
                    return flag;
                }
                var fetchAddress = function() {
                    if (getLocationValue !== $(e.target).find('input').attr('placeholder') && getLocationValue !== "") {
                        var $thisTag = ($(e.target).length && $(e.target)) || $(e);
                        $(e.target).find('.button').addClass('loading');

                        //Fire the geocode API with additional location parameter
                        var getLocation = getLocationValue;
                        //Fire the call
                        $.ajax({
                            url: "//maps.googleapis.com/maps/api/geocode/json",
                            data: {
                                address: getLocation
                            },
                            success: function(data) {
                                var latitude = data.results[0].geometry.location.lat;
                                var longitude = data.results[0].geometry.location.lng;
                                var formatted_address = toFormatedAddress;
                                var address_components = data.results[0].address_components[0];
                                that.sortPlacesnearby(latitude, longitude, formatted_address, $(e.target), address_components, isInTheCity, "googleAutocomple");
                            }

                        });
                        CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TS', 'locationSearced', getLocationValue, '100');
                    }
                }
                if (getLocationValue.toLowerCase().indexOf(currentCity.toLowerCase()) >= 0 || checkCityMap()) {
                    toFormatedAddress = getLocationValue;
                    isInTheCity = true;
                    // fetchAddress();
                    this.sortPlacesnearby(latitude, longitude, toFormatedAddress, $(ele), isInTheCity, "googleAutocomple", typeOfArea);
                } else {
                    var cityString = window.cityNameTomap ? window.cityNameTomap.trim() : '';
                    if (cityString) {
                        $.ajax({
                            type: 'GET',
                            url: '/places/hac?&v=2&s=' + cityString,
                            mimeType: "application/json",
                            success: function(data) {
                                var results = data;
                                _.each(results.r, function(item, idx) {
                                    if (item.cya && item.cya.trim() == cityString && item.cy == currentCity.trim()) {
                                        isInTheCity = true;
                                    }
                                });
                                toFormatedAddress = getLocationValue;
                                // fetchAddress();
                                that.sortPlacesnearby(latitude, longitude, toFormatedAddress, $(ele), isInTheCity, "googleAutocomple", typeOfArea);

                            },
                            error: function() {
                                $(ele).find('button').removeClass('loading');
                                $('.searchedLocality').find('small').html('Oops!').parent().find('span').html("Could not find " + formatted_address).parent().fadeIn();
                                that.clearLocationSort("notFound");
                            }
                        })
                    } else {
                        isInTheCity = false;
                        toFormatedAddress = getLocationValue;
                        // fetchAddress();
                        this.sortPlacesnearby(latitude, longitude, toFormatedAddress, $(ele), isInTheCity, "googleAutocomple", typeOfArea);
                    }
                }*/

            },
            sortPlacesnearby: function(latitude, longitude, formatted_address, ele, isInTheCityFlag, autocompleteType, areaType) {
                var that = this;
                var $currentElem = this.$el;
                $currentElem.find("nav.locality input:checked").removeAttr("checked");
                if (latitude == 0 || longitude == 0) {
                    $('.searchedLocality').find('small').html('Oops!').parent().find('span').html("Could not find " + formatted_address).parent().fadeIn();
                    that.clearLocationSort("notFound");
                    $(ele).find('.button').removeClass('loading');
                    return;
                }
                var citySearched = CT.cache[CT.settings.currentTab].searchParams.all.city;
                var cityId = CT.masterJson.get().json ? CT.masterJson.get().json.city : CT.masterJson.get().city;
                var noResults = new RegExp(CT.cache[CT.settings.currentTab].searchParams.all.city, 'i');
                var listTosort = CT.masterJson.get().ht;
                if (isInTheCityFlag) {
                    CT.cache[CT.settings.currentTab].searchedLocation = formatted_address;
                    var splitLocation = CT.cache[CT.settings.currentTab].searchedLocation.split(',');
                    if (splitLocation.length > 3)
                        splitLocation.splice(-3, 3);
                    CT.cache[CT.settings.currentTab].searchedLocation = splitLocation.join(',');
                    CT.cache[CT.settings.currentTab].searchedLocationLatLng = [latitude, longitude];
                    CT.cache[CT.settings.currentTab].latitude = latitude
                    CT.cache[CT.settings.currentTab].longitude = longitude
                    CT.cache[CT.settings.currentTab].pointOfIntrestValue = splitLocation[0]
                    if (CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" && CT.isLocationEnabled == true) {
                        $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').trigger('click')
                    }
                    if (CT.isLocationEnabled == true) {
                        var areaOfSearch;
                        var typeOfArea;
                        var areaNature;
                        var counterToTpl = 0;
                        var copyForFilteredHt = {
                            "exact": [],
                            "others": []
                        };
                        var filteredListToSort = CT.cache[CT.settings.currentTab].filteredHt["exact"].concat(CT.cache[CT.settings.currentTab].filteredHt["others"]);
                        CT.cache[CT.settings.currentTab].googleSortedPoi = "",
                            CT.cache[CT.settings.currentTab].googleSortedArea = "";
                        if (filteredListToSort.length == 0)
                            filteredListToSort = CT.masterJson.get().ht;
                        var locationId, areaId, poiId;
                        if (areaType) {
                            areaOfSearch = formatted_address.split(",")[0];
                            // CT.cache[CT.settings.currentTab].searchParams.all.poi=[]
                            // CT.cache[CT.settings.currentTab].searchParams.all.poi.push(areaOfSearch)
                            // searchParams=_.deserialize(CT.cache[CT.settings.currentTab].searchParams.all)
                            // CT.settings.routes.navigate('/results?' + _.serialize(searchParams), {
                            //     trigger: false,
                            //     replace: true
                            // })
                            CT.cache[CT.settings.currentTab].pointOfIntrestValue = areaOfSearch
                            if (areaType == "point_of_interest") {
                                typeOfArea = areaType;
                                if (!$.isEmptyObject(CT.masterJson.get().poi)) {
                                    _.each(CT.masterJson.get().poi[cityId], function(val) {
                                        if ((val.nm||val.name).toLowerCase().replace(/[\s\.\-\&\#\*\@]/g, '').indexOf(areaOfSearch.toLowerCase().replace(/[\s\.\-\&\#\*\@]/g, '')) > -1) {
                                            locationId = val["id"] ? val["id"] : '';
                                            // $("#ResultContainer_" + CT.settings.currentTab).find("nav.locality input:checked").removeAttr("checked");
                                            // $("#ResultContainer_" + CT.settings.currentTab).find("nav.locality input#"+CT.settings.currentTab+val.nm).attr("checked","checked");
                                            CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                            CT.cache[CT.settings.currentTab].googleSortedPoi = [val.nm||val.name];
                                            CT.cache[CT.settings.currentTab].googleSortedPoiLatLng = [latitude, longitude]

                                        }

                                    })
                                }
                                if (!CT.cache[CT.settings.currentTab].googleSortedPoi) {
                                    CT.cache[CT.settings.currentTab].googleSortedPoi = [areaOfSearch];
                                    CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                }
                                areaNature = "poi"
                            } else if (areaType == "sublocality") {
                                if (areaOfSearch.toLowerCase().replace(/[\s\.\-\&\#\*\@]/g, '').indexOf("airport") >= 0 || areaOfSearch.toLowerCase().replace(/[\s\.\-\&\#\*\@]/g, '').indexOf("railway station") >= 0 || areaOfSearch.toLowerCase().replace(/[\s\.\-\&\#\*\@]/g, '').indexOf("bus station") >= 0 || areaOfSearch.toLowerCase().replace(/[\s\.\-\&\#\*\@]/g, '').indexOf("bus stand") >= 0) {
                                    typeOfArea = "point_of_interest";
                                    if (!$.isEmptyObject(CT.masterJson.get().poi)) {
                                        _.each(CT.masterJson.get().poi[cityId], function(val) {
                                            if (val.nm.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '').indexOf(areaOfSearch.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '')) > -1) {
                                                locationId = val["id"] ? val["id"] : '';
                                                CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                                CT.cache[CT.settings.currentTab].googleSortedPoi = [val.nm];
                                                CT.cache[CT.settings.currentTab].googleSortedPoiLatLng = [latitude, longitude]
                                            }
                                        })
                                    }
                                    if (!CT.cache[CT.settings.currentTab].googleSortedPoi) {
                                        CT.cache[CT.settings.currentTab].googleSortedPoi = [areaOfSearch]
                                        CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                    }
                                    areaNature = "poi"
                                } else {
                                    if (!$.isEmptyObject(CT.masterJson.get().ar)) {
                                        for (var key in CT.masterJson.get().ar[cityId]) {
                                            if (areaOfSearch.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '').match(CT.masterJson.get().ar[cityId][key].nm.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '')) != null) {
                                                CT.cache[CT.settings.currentTab].googleSortedPoi = "";
                                                CT.cache[CT.settings.currentTab].googleSortedArea = [CT.masterJson.get().ar[cityId][key].nm];
                                                if (!CT.masterJson.get().ar[cityId][key]["latlng"])
                                                    CT.cache[CT.settings.currentTab].googleSortedAreaLatLng = [latitude, longitude]
                                                locationId = CT.masterJson.get().ar[cityId][key]["id"] ? CT.masterJson.get().ar[cityId][key]["id"] : '';
                                                break;
                                            }
                                        }
                                    }
                                    if (!CT.cache[CT.settings.currentTab].googleSortedArea) {
                                        CT.cache[CT.settings.currentTab].googleSortedArea = ""
                                        CT.cache[CT.settings.currentTab].googleSortedPoi = [areaOfSearch];
                                        CT.cache[CT.settings.currentTab].googleSortedPoiLatLng = [latitude, longitude]
                                        typeOfArea = "point_of_interest";
                                        areaNature = "poi";
                                    } else
                                        typeOfArea = areaType;

                                }
                            } else {
                                if (areaOfSearch.toLowerCase().indexOf("airport") >= 0 ||
                                    areaOfSearch.toLowerCase().indexOf("railway station") >= 0 ||
                                    areaOfSearch.toLowerCase().indexOf("bus station") >= 0 ||
                                    areaOfSearch.toLowerCase().indexOf("bus stand") >= 0) {
                                    typeOfArea = "point_of_interest";
                                    if (!$.isEmptyObject(CT.masterJson.get().poi)) {
                                        _.each(CT.masterJson.get().poi[cityId], function(val) {
                                            if (val.nm.toLowerCase().indexOf(areaOfSearch.toLowerCase()) > -1) {
                                                locationId = val["id"] ? val["id"] : '';
                                                CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                                CT.cache[CT.settings.currentTab].googleSortedPoi = [val.nm];
                                                CT.cache[CT.settings.currentTab].googleSortedPoiLatLng = [latitude, longitude]
                                            }
                                        })
                                    }
                                    if (!CT.cache[CT.settings.currentTab].googleSortedPoi) {
                                        CT.cache[CT.settings.currentTab].googleSortedPoi = [areaOfSearch]
                                        CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                    }
                                    areaNature = "poi";
                                } else {
                                    if (!$.isEmptyObject(CT.masterJson.get().poi)) {
                                        _.each(CT.masterJson.get().poi[cityId], function(val) {
                                            if (val.nm.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '').indexOf(areaOfSearch.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '')) > -1) {
                                                poiId = val["id"] ? val["id"] : '';
                                                CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                                CT.cache[CT.settings.currentTab].googleSortedPoi = [val.nm];
                                                CT.cache[CT.settings.currentTab].googleSortedPoiLatLng = [latitude, longitude];
                                                typeOfArea = "point_of_interest";
                                                areaNature = "poi";
                                            }
                                        })

                                    }
                                    if (!$.isEmptyObject(CT.masterJson.get().ar)) {
                                        _.each(CT.masterJson.get().ar[cityId], function(val) {
                                            if (val.nm.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '').indexOf(areaOfSearch.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '')) > -1) {
                                                areaId = val["id"] ? val["id"] : '';
                                                CT.cache[CT.settings.currentTab].googleSortedPoi = "";
                                                CT.cache[CT.settings.currentTab].googleSortedArea = [val.nm];
                                                typeOfArea = "sublocality";
                                                areaNature = "area";
                                            }
                                        })

                                    }
                                    if (!CT.cache[CT.settings.currentTab].googleSortedArea && !CT.cache[CT.settings.currentTab].googleSortedPoi) {
                                        typeOfArea = "point_of_interest"
                                        CT.cache[CT.settings.currentTab].googleSortedPoi = [areaOfSearch]
                                        CT.cache[CT.settings.currentTab].googleSortedArea = "";
                                        areaNature = "poi"
                                    }
                                }
                            }
                        }
                        if (typeOfArea == "sublocality" || typeOfArea == "others") {
                            if (filteredListToSort.length > 0) {
                                _.each(filteredListToSort, function(item) {
                                    if (item.hasSpriteIcon && item.classToarea) {
                                        delete item.hasSpriteIcon;
                                        delete item.classToarea;
                                    } else {
                                        if (item.distanceFromAreaString)
                                            delete item.distanceFromAreaString;
                                    }
                                    if (item.areaSearch) {
                                        item.areaSearch = false;
                                    }
                                    if (item.poiSearch)
                                        item.poiSearch = false;
                                    delete item.areaName;
                                    delete item.areaLat;
                                    delete item.areaLng;
                                    if (item.distanceFromLocation)
                                        delete item.distanceFromLocation;
                                    if (item.ar.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '').indexOf(areaOfSearch.toLowerCase().replace(/[\s\.\-\&\*\@\#\!\(\)]/g, '')) > -1) {
                                        item.hasSpriteIcon = "<i class='hotelSprite mapPinLocality'></i>";
                                        item.classToarea = "poiName highlightMe";
                                        item.isgoogleSearch = true;
                                        item.locId = locationId ? locationId : '';
                                        areaNature = "area";
                                        copyForFilteredHt["exact"].push(item);
                                        counterToTpl++;
                                    } else {
                                        if (item.latlng) {
                                            var hotelLat = item.latlng[0];
                                            var hotelLng = item.latlng[1];
                                            var distanceFromArea = CT.utils.helperFunctions.getDistanceFromLatLonInKm(latitude, longitude, hotelLat, hotelLng);
                                            var locationInMetres = distanceFromArea * 1000;
                                            item.distanceFromLocation = distanceFromArea;
                                            if (locationInMetres > 1000)
                                                item.distanceFromAreaString = distanceFromArea.toFixed(1) % 1 !== 0 ? (distanceFromArea.toFixed(1) + " km from " + areaOfSearch) : (distanceFromArea.toFixed() + " km from " + areaOfSearch);
                                            else
                                                item.distanceFromAreaString = distanceFromArea.toFixed(1) + " km from " + areaOfSearch;
                                        } else
                                            item.distanceFromLocation = 6372;
                                        if (areaNature !== "area") {
                                            item.locId = locationId ? locationId : poiId ? poiId : '';
                                            item.isgoogleSearch = true;

                                        }
                                        copyForFilteredHt["others"].push(item);
                                    }
                                })
                            }
                        } else if (typeOfArea == "point_of_interest") {
                            if (filteredListToSort.length > 0) {
                                _.each(filteredListToSort, function(item) {
                                    if (item.hasSpriteIcon && item.classToarea) {
                                        delete item.hasSpriteIcon;
                                        delete item.classToarea;
                                    } else {
                                        if (item.distanceFromAreaString)
                                            delete item.distanceFromAreaString;
                                    }
                                    if (item.areaSearch) {
                                        item.areaSearch = false;
                                    }
                                    if (item.poiSearch)
                                        item.poiSearch = false;
                                    if (item.distanceFromLocation)
                                        delete item.distanceFromLocation;
                                    if (item.latlng) {
                                        var hotelLat = item.latlng[0];
                                        var hotelLng = item.latlng[1];
                                        var distanceFromArea = CT.utils.helperFunctions.getDistanceFromLatLonInKm(latitude, longitude, hotelLat, hotelLng);
                                        var locationInMetres = distanceFromArea * 1000;
                                        item.isgoogleSearch = true;
                                        if (locationId && locationId != '')
                                            item.locId = locationId ? locationId : '';
                                        else
                                            CT.utils.helperFunctions.addLocationDetails(item, {
                                                area: areaOfSearch,
                                                lat: latitude,
                                                lng: longitude
                                            });
                                        item.distanceFromLocation = distanceFromArea;
                                        if (distanceFromArea) {
                                            if (locationInMetres > 1000)
                                                item.distanceFromAreaString = distanceFromArea.toFixed(1) % 1 !== 0 ? (distanceFromArea.toFixed(1) + " km from " + areaOfSearch) : (distanceFromArea.toFixed() + " km from " + areaOfSearch);
                                            else
                                                item.distanceFromAreaString = distanceFromArea.toFixed(1) + " km from " + areaOfSearch;
                                        }
                                    } else
                                        item.distanceFromLocation = 6372;
                                    copyForFilteredHt["others"].push(item);
                                })
                            }
                        }
                        if (!areaNature || areaNature != "area") {
                            copyForFilteredHt["exact"] = copyForFilteredHt["others"];
                            copyForFilteredHt["others"] = [];
                            CT.cache[CT.settings.currentTab].googleSortedArea = "";
                            CT.cache[CT.settings.currentTab].googleSortedPoi = [areaOfSearch];
                            CT.cache[CT.settings.currentTab].googleSortedPoiLatLng = [latitude, longitude];
                            CT.cache[CT.settings.currentTab].filteredHt = copyForFilteredHt;
                            //$currentElem.find('nav.sorters .location').trigger('click')
                            $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', true)
                            $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a').each(function(index, ele) {
                                $(this).removeClass('current')
                                $(this).removeClass('sortAsc')
                                $(this).removeClass('sortDes')
                            })
                            //$currentElem.find('nav.sorters .featuredSort').removeClass('current')
                            $currentElem.find('nav.sorters .location').addClass("current sortAsc").css("padding-right","5px");
                            $currentElem.find('nav.sorters .location').text('Distance from ' + CT.cache[CT.settings.currentTab].searchedLocation).css('display', 'block');
                            // CT.fire('filters.apply');
                        } else if (areaNature == "area") {
                            CT.cache[CT.settings.currentTab].filteredHt = copyForFilteredHt;
                            $currentElem.find('nav.sorters .location').text("");
                            if ($currentElem.find("nav.sorters a.current").hasClass("location"))
                                $currentElem.find('nav.sorters .featuredSort').trigger('click');
                            else {
                                if ($currentElem.find("nav.sorters a.current").hasClass("sortAsc")) {
                                    $currentElem.find("nav.sorters a.current").removeClass("sortAsc").addClass("sortDes");
                                } else if ($currentElem.find("nav.sorters a.current").hasClass("sortDes")) {
                                    $currentElem.find("nav.sorters a.current").removeClass("sortDes").addClass("sortAsc");
                                }
                                $currentElem.find('nav.sorters a.current').trigger('click');
                            }
                        }
                        // $(ele).find('.button').removeClass('loading');
                        $("#ResultContainer_" + CT.settings.currentTab).find(".googleWidget").hide();
                        that.showLocalitySearchMsg({
                            name: formatted_address.split(",")[0] + ", " + window.cityNameTomap,
                            type: !areaNature || areaNature == "others" ? "poi" : areaNature,
                            count: counterToTpl
                        });
                        // var filterMixpanelprop = {
                        //     "filterType": "location",
                        //     "filterValue": formatted_address,
                        //     "hotelsBeforeFilter": CT.cache[CT.settings.currentTab].prevFltCount,
                        //     "hotelAfterFilter": CT.cache[CT.settings.currentTab].crntFilCount
                        // }
                        // CT.utils.trackers.mixpanelTrackingData["locationSorterReferer"] = "srp"
                    } else {
                        _.each(listTosort, function(item, ind) {
                            if (item.latlng) {
                                var hotelLat = item.latlng[0];
                                var hotelLng = item.latlng[1];
                                var distanceFromArea = CT.utils.helperFunctions.getDistanceFromLatLonInKm(latitude, longitude, hotelLat, hotelLng);
                                var newDistance = CT.utils.helperFunctions.getDistanceFromLatLonInKm(latitude, longitude, hotelLat, hotelLng);
                                locationInMetres = newDistance * 1000;
                                item.distanceFromLocation = distanceFromArea;
                                item.fromCustomLocation = CT.cache[CT.settings.currentTab].searchedLocation

                                if (locationInMetres > 1000) {
                                    //If whole number, show 1km and not 1.0km
                                    item.distanceFromLocationToShow = newDistance.toFixed(1) % 1 !== 0 ? (newDistance.toFixed(1) + " km") : (newDistance.toFixed() + " km");
                                } else {
                                    item.distanceFromLocationToShow = distanceFromArea + "m"
                                }
                            } else {
                                //If lat, lng data is not available, push to bottom, 6372, more than radius of Earth - Vijay Sutrave
                                item.distanceFromLocation = 6372;
                            }
                        });
                        $(ele).find('.button').removeClass('loading');
                        $('nav.sorters .location').trigger('click')
                        $('nav.sorters .location').text('Distance from ' + CT.cache[CT.settings.currentTab].searchedLocation).css('display', 'block');
                    }

                    // CT.cache[CT.settings.currentTab].filteredHt.exact=listTosort;CT.cache[CT.settings.currentTab].others=[];

                    // var sortedList = _.first($("#ResultContainer_" + CT.settings.currentTab).find(".listView li.listItem"), 5);
                    // var mixPanelHotelObjArr = []
                    // for (var i = 0; i < sortedList.length; i++) {
                    //     var hotelObj = CT.masterJson.getHotel($(sortedList[i]).attr("id")),
                    //         tmpObj = {};
                    //     tmpObj["hotelId"] = hotelObj.id;
                    //     tmpObj["hotelName"] = hotelObj.nm;
                    //     mixPanelHotelObjArr.push(tmpObj)
                    // }
                    $('.searchedLocality').find('small').html('Sorting by distance from').parent().find('span').html(CT.cache[CT.settings.currentTab].searchedLocation).parent().hide();
                } else {
                    $('nav.sorters .featuredSort').trigger('click');
                    $(ele).find('.button').removeClass('loading');
                    $('.searchedLocality').find('small').html('Oops!').parent().find('span').html("Could not find " + formatted_address).parent().fadeIn();
                    that.clearLocationSort("notFound");
                }
            },

            clearLocationSort: function(e) {

                if (CT.isLocationEnabled == true) {
                    $('.mapAutocomplete:last').attr('value', '')
                    $('.mapAutocomplete:last').attr('placeholder', 'Enter an address or location')
                    CT.cache[CT.settings.currentTab].pointOfIntrestValue = ""
                    if (CT.cache[CT.settings.currentTab].viewType == "map") {
                        $('.googleWidget').show()
                    }
                    _.each(CT.masterJson.get().ht, function(item, ind) {
                        if (item.hasSpriteIcon && item.classToarea) {
                            delete item.hasSpriteIcon;
                            delete item.classToarea;
                        } else
                        if (item.distanceFromAreaString)
                            delete item.distanceFromAreaString;
                        if (item.areaSearch)
                            item.areaSearch = false
                        if (item.poiSearch)
                            item.poiSearch = false;
                        if (item.isgoogleSearch)
                            item.isgoogleSearch = false;

                        delete item.distanceFromLocation;
                    });
                } else {
                    _.each(CT.masterJson.get().ht, function(item, ind) {
                        delete item.distanceFromLocation;
                        delete item.distanceFromLocationToShow;
                        delete item.fromCustomLocation;
                    });
                }
                var getLocationValue = $('.showNearBy')[1] && $('.showNearBy')[1].value;
                delete CT.cache[CT.settings.currentTab].searchedLocation;
                delete CT.cache[CT.settings.currentTab].searchedLocationLatLng;
                $('.showNearBy').val("").focus().trigger("keyup");
                $('nav.sorters .featuredSort').trigger("click")
                $('nav.sorters .location').css('display', 'none');
                this.$el.find(".showNearBy").val(this.$el.find(".showNearByBox").attr("placeholder"));
                this.$el.find('.showNearBy').addClass('placeholderlight');
                this.$el.find('#showNearByBox').trigger("keyup");
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TS', 'clearedLocationSort', getLocationValue, '100');
                if (e !== "notFound" && $(e.srcElement).hasClass('clearFieldAuto')) {
                    $('.searchedLocality').fadeOut();
                }
                CT.cache[CT.settings.currentTab].searchParams.all.area = "";
                CT.cache[CT.settings.currentTab].searchParams.all.poi = "";
                CT.cache[CT.settings.currentTab].googleSortedPoi = "";
                CT.cache[CT.settings.currentTab].googleSortedArea = "";
                if (CT.isLocationEnabled && CT.cache[CT.settings.currentTab].removeGoogleSearch == true) {
                    CT.cache[CT.settings.currentTab].removeGoogleSearch = false
                }
                $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').removeAttr('checked');
                CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal = false
                CT.cache[CT.settings.currentTab].plceselected = false
                this.$el.find(".propertySection").remove();
                CT.fire("filters.apply");
                //this.$el.find('.filtersForm').trigger('filters_reset');
            },

            showCancelTipsy: function(e) {
                e.stopPropagation();
                $thisTag = $(e.target);
                var getHotelID = $thisTag.closest('li').attr('id');
                var offset = $thisTag.offset(),
                    left = offset.left,
                    _top = offset.top

                if ($('.hotelFarePopover').length == 0) {
                    $(document.body).append(CT.to_html('FarePopoverTpl'))
                }

                $('.hotelFarePopover').css({
                    'display': 'block',
                    'position': 'absolute',
                    'z-index': '200000',
                    'top': _top + 20,
                    'left': left
                }).addClass('cancellationsPopover');
                $('.hotelFarePopover').find('.tipsyInner').html("<img src='data:image/gif;base64,R0lGODlhFQAFAMQdABUVFcfHxw8PD4qKirCwsODg4BwcHKamptHR0aysrOLi4tTU1FxcXBEREXV1dXd3d35+fn9/fxQUFA4ODu3t7fr6+vz8/Pn5+V5eXvv7+/j4+P39/QAAAP///wAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAdACwAAAAAFQAFAAAFMGC3ZVtnmmN5iqSoEIV1bm8811aVGMd16jyfCdjbLAaIzOyYXCKVGopm1YlOV9ZOCAAh+QQFAAAdACwBAAEAAwADAAAFCWAEQAAnPY0TAgAh+QQJAAAdACwAAAAADAAFAAAFIGCACVjQnWiHcSyWRgAkcB0npAAnrW36NI4AY8IwpU4hACH5BAkAAB0ALAAAAAAVAAUAAAU2YLdlW2d2ASZgwemKEQBZJ8bdmBtDXQVwkstJcOMIXD+J6NFwZGrF3InpMGkoGleAMWG0XqYQACH5BAkAAB0ALAAAAAAVAAUAAAU+YLdlW2eaY3kGmIAFm0IU1rlFAFSbGOdjlYThcDlVABxJ0STwcQSbxQCRsT0ajirPieloKJqT6RteMSaMQAgAIfkEBQAAHQAsAAAAABUABQAABTZgt2VbZ5pjeYqkqBCFdW5vPEcAZFWJcVwnng9oqgA4kstmMUBkZkzn7NFwPDUUzaqD1a66nRAAOw==' />");

                var vObj = CT.masterJson.getHotel(getHotelID);
                if (vObj && vObj.priceInfo && vObj.priceInfo.rms) {
                    var tmp = CT.cache[CT.settings.currentTab].searchParams.all
                    tmp.roomTypeCode = $thisTag.attr('data-roomTypeCode');
                    tmp.bookingCode = $thisTag.attr('data-bookingCode');
                    tmp.ct_hotelid = getHotelID;
                }
                var postURL = '/hotels/cancelPolicy?' + _.serialize(tmp);
                if (!$thisTag.attr('data-policycalldone')) {
                    $.ajax({
                        url: postURL,
                        success: function(data) {
                            if (data !== "") {
                                $('.hotelFarePopover').find('.tipsyInner').html(data);
                                $thisTag.closest(".rateRulesContainer").find(".viewChargesContainer").html(data);
                            } else {
                                $('.hotelFarePopover').find('.tipsyInner').html("Oops, cancellation policy not found!");
                                $thisTag.closest(".rateRulesContainer").find(".viewChargesContainer").html('Oops, cancellation policy not found!').css('display', 'none');
                            }
                            $thisTag.attr('data-policycalldone', 'true');
                        },
                        error: function() {
                            $('.hotelFarePopover').find('.tipsyInner').html("Oops, cancellation policy not found!")
                        }
                    });
                } else {
                    var htmlText = $thisTag.closest(".rateRulesContainer").find(".viewChargesContainer").html();
                    $('.hotelFarePopover').find('.tipsyInner').html(htmlText)
                }
            },
            shwAllHotels: function(e) {
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_GR', 'ShowAllHotelsClick_' + $(e.target).attr("data-city"), CT.cache[CT.settings.currentTab].paramsForGA, '100');
            },
            hideAltFilters: function(e) {
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                $currentTab.find(".getawaysFilter").hide();
                $currentTab.find(".weekendFilterPopup").hide();
                $currentTab.find(".filterButton").removeClass("activeFilterButton popUpShown")
            },
            toggleAltFilters: function(e) {
                var eleList = $(e.target).closest("a").attr("data-filterPopUp").split("|");
                if ($(e.target).hasClass("clearWeekendFilter") != true) {
                    var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                    $currentTab.find(".getawaysFilter").hide();
                    $currentTab.find(".filterButton").removeClass("activeFilterButton")

                    if ($(e.target).closest("a").hasClass("popUpShown") == false) {
                        for (var k = 0; k < eleList.length; k++) {
                            $currentTab.find("." + eleList[k]).show();
                        }
                        $currentTab.find(".filterButton").removeClass("popUpShown")
                        $(e.target).closest("a").addClass("activeFilterButton popUpShown");
                        $currentTab.find(".weekendFilterPopup").show();
                        $currentTab.find(".weekendFilterPopup").find(".popupArrow").css({
                            "margin-left": $(e.target).closest("a").offset().left - $currentTab.find(".weekendFilterPopup").offset().left + 15
                        });

                    } else {
                        $(e.target).closest("a").removeClass("activeFilterButton popUpShown")
                        $currentTab.find(".weekendFilterPopup").hide();
                    }
                    var handler = function(event) {
                        if ($(event.target).is(".weekendFilterPopup, .weekendFilterPopup *, .filterButton, .filterButton *")) return;
                        $(document).off("click", handler);
                        //$currentTab.find('.filters').hide();
                        $currentTab.find(".weekendFilterPopup").hide();
                        $currentTab.find(".filterButton").removeClass("activeFilterButton popUpShown")
                    }
                    $(document).on("click", handler);
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_GR', eleList, CT.cache[CT.settings.currentTab].paramsForGA, '100');
                } else {
                    this.$el.find('.filtersForm').trigger('filter.clearWeekendFilter', [eleList, $(e.target).closest("a")])
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_GR', 'ClearWeekendFilter-' + eleList, CT.cache[CT.settings.currentTab].paramsForGA, '100');

                }

            },
            prDispUnitToggle: function(ele) {
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                if (ele === "perRoomPerNightDispHeader") {
                    $currentTab.find(".totPriceDisp").hide();
                    $currentTab.find(".perRoomPrDisp").show();
                    $currentTab.find(".perRoomPerNightDispHeader").addClass("current");
                    $currentTab.find(".totPriceDispHeader").removeClass("current");
                } else {
                    $currentTab.find(".totPriceDispHeader").addClass("current");
                    $currentTab.find(".perRoomPerNightDispHeader").removeClass("current");
                    $currentTab.find(".totPriceDisp").show();
                    $currentTab.find(".perRoomPrDisp").hide();
                }
                CT.utils.cookies.create("prDispUnitEle", CT.cache[CT.settings.currentTab].prDispUnitEle, 365);
            },
            perRoomPerNightDisp: function(e) {
                e.preventDefault();
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                if ($(e.target).hasClass("perRoomPerNightDispHeader")) {
                    cf.updateFilter('price', {
                        min: CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax != undefined ? CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax.min : 0,
                        max: CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax != undefined ? CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax.max : 0,
                        name: 'price'
                    }, null, true)
                    CT.cache[CT.settings.currentTab].prDispUnitEle = "perRoomPerNightDispHeader";
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_PerRoomPerNight', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                } else {
                    cf.updateFilter('price', {
                        min: CT.cache[CT.settings.currentTab].filterValues.priceMinMax.min,
                        max: CT.cache[CT.settings.currentTab].filterValues.priceMinMax.max,
                        name: 'price'
                    }, null, true)
                    CT.cache[CT.settings.currentTab].prDispUnitEle = "totPriceDispHeader"
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_TotalPrice', CT.cache[CT.settings.currentTab].paramsForGA, '100');

                }

                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_PriceDisplayToggled", {
                    "priceDisplaySelected": (CT.cache[CT.settings.currentTab].prDispUnitEle === "totPriceDispHeader") ? "Total" : "Per room per night"
                });
                CT.utils.cookies.create("prDispUnitEle", CT.cache[CT.settings.currentTab].prDispUnitEle, 365);
                this.prDispUnitToggle(CT.cache[CT.settings.currentTab].prDispUnitEle);
            },
            ipadHotelChanges: function(e) {
                CT.utils.helperFunctions.ipadChanges(e, this.$el);
            },
            ipadCloseFilter: function(e) {
                CT.utils.helperFunctions.ipadCloseFilter(e, this.$el);
                //this.$el.find('.filters').removeClass('filterPopOver');
                //$(".tempFiltersButton").closest("li").removeClass('current')
            },
            checkForEmptyInput: function(e) {
                /* var val = $(e.target).val();

                 if (val == '') {
                     this.$el.find('.filtersForm .locality input:checked').removeAttr('checked');
                     this.$el.find('.filtersForm input[name="hotelName"]').val('');
                     this.$el.find('.smallSearch input, .mapViewSearch input').val('');
                     CT.fire('filters.apply');
                 }*/
            },



            showFareBreakUp: function(e) {
                var $thisTag = $(e.target),
                    fareBreakJson = {},
                    that = this,
                    rmCode = $thisTag.attr('data-roomTypeCode'),
                    hotelId = $thisTag.parents('li.listItem').attr('id'),
                    hotelRms = CT.masterJson.getHotel(hotelId).priceInfo.rms,
                    offset = $thisTag.offset(),
                    _left = offset.left,
                    _top = offset.top;
                $('.tipsy .close').trigger("click");

                var _rmsObj = _.find(hotelRms, function(obj) {
                    if (obj.rmtc == rmCode) return obj;
                });
                var searchParams = CT.cache[CT.settings.currentTab].searchParams.processed;
                var totRoomNights = Int(searchParams.num_nights) * Int(searchParams.num_rooms);

                var rmRt = parseInt(_rmsObj.tot) - parseInt(_rmsObj.t * totRoomNights) - parseInt(_rmsObj.st * totRoomNights);
                var oTax = _rmsObj.t * totRoomNights;
                var sTax = _rmsObj.st * totRoomNights;
                var pr = parseInt(_rmsObj.tot) + parseInt(_rmsObj.agm);
                var comm = _rmsObj.agc;
                var tds = _rmsObj.agt;
                var mkup = _rmsObj.agm;
                var agPr = parseInt(pr) + parseInt(((comm - mkup) + tds));

                fareBreakJson = {
                    "rmRt": CT.utils.formatForCurrency(rmRt),
                    "oTax": CT.utils.formatForCurrency(oTax),
                    "sTax": CT.utils.formatForCurrency(sTax),
                    "pr": CT.utils.formatForCurrency(pr),
                    "comm": CT.utils.formatForCurrency(Math.abs(comm)),
                    "tds": CT.utils.formatForCurrency(tds),
                    "mrkup": CT.utils.formatForCurrency(mkup),
                    "agCost": CT.utils.formatForCurrency(agPr)
                };
                if (window.productCode == "AG" && !(sTax && sTax > 0)) {
                    delete fareBreakJson["sTax"];
                }

                var fareHtml = CT.to_html('FareBreakupHotelTpl', fareBreakJson);

                $(document.body).find('.hotelFarePopover').remove()
                $(document.body).append(CT.to_html('FarePopoverTpl'));

                $('.hotelFarePopover')
                    .find('.tipsyInner').html('').append(fareHtml).end()
                    .css({
                        'display': 'block',
                        'position': 'absolute',
                        'z-index': '200000',
                        'top': _top + 13,
                        'left': _left,
                        'width': '282px'
                    })
                    .delegate(".close", "click", function() {
                        $('.hotelFarePopover').hide();
                    });

            },



            showCommission: function(e) {
                $('body').addClass('showCommission');
                var ele = $(e.target);
                ele.removeClass('showComm addGray');
                ele.addClass('hideComm close');
                this.$el.find('.sorters li.commission,.listItem a.agToolTip').show();
            },



            hideCommission: function(e) {
                $('body').removeClass('showCommission');
                var ele = $(e.target);
                ele.addClass('showComm addGray');
                ele.removeClass('hideComm close');
                this.$el.find('.sorters li.commission,.listItem a.agToolTip').hide();
            },



            showEmailHotelModal: function(e) {
                CT.utils.showModalDialog('/hotelstatic/includes/modal_email_hotels.shtml', '90%', '600px', 'yes', false, undefined, undefined, true, undefined, undefined, undefined);
            },

            showPrintHotelModal: function(e) {
                CT.utils.showModalDialog('/hotelstatic/includes/modal_print_hotels.shtml', '90%', '600px', 'yes', false, undefined, undefined, true, undefined, undefined, undefined);
            },


            hideNearByNotification: function(e) {
                var tmp;

                tmp = CT.cache[CT.settings.currentTab];
                if (this.$el.find('.filtersForm .nearByCities').length > 0 && !tmp.onLoad)
                    tmp.hideMessages.nearByNotification = true;
            },



            excludeNearByCities: function(e) {
                var hotels = CT.masterJson.get().ht;

                e.preventDefault();

                for (i = 0; i < hotels.length; i++) {
                    if (hotels[i].nci) {
                        hotels.splice(i, 1);
                        i--;
                    }
                }

                CT.fire('filters.apply');
                $(e.target).parent().siblings().find('.closeParent').trigger('click');
            },


            showPinPoint: function() {
                var tabCache = CT.cache[CT.settings.currentTab],
                    that = this;
                tabCache.gnTimer = null;
                tabCache.gnDelay = 100;
                tabCache.gnTimer = setTimeout(function() {
                    that.$el.find('.pinPointInit').fadeOut('4000', function() {
                        that.$el.find('.pinPointTrigger').fadeIn('slow');
                    });
                    return false;
                }, tabCache.gnDelay)
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'PinPoint_GuidedScrollShown', CT.cache[CT.settings.currentTab].paramsForGA, '100');
            },
            dontShowPinPoint: function() {
                var tabCache = CT.cache[CT.settings.currentTab];
                clearTimeout(tabCache.gnTimer);
            },
            guidedScrollClose: function(e) {
                var tabCache = CT.cache[CT.settings.currentTab];
                var newId = 'ResultContainer_' + CT.settings.currentTab;
                this.$el = this.$el || $('#' + newId);
                tabCache.guidedNav = true;
                tabCache.dontShowGNonScroll = true;
                //this.$el.find(".guidedMessage").remove();
                this.$el.find(".pinPointInit, .pinPointTrigger").remove();
                // this.$el.find(".openGN").show();

                // this.$el.find(".openGN").addClass("highlightMe");
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'PinPoint_GuidedScrollClose', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                return false;
            },
            guidedClose: function(e) {
                var obj = {
                    "sid": window.parent.CT.cache[CT.settings.currentTab].sid,
                    "ppcr": -1,
                    "st": CT.cache[CT.settings.currentTab].pinPointCurrStep,
                    "ar": ""
                }
                $.extend(true, obj, CT.cache[CT.settings.currentTab].pinPointSearchParams);
                window.parent.CT.utils.helperFunctions.dashBoardLogging(obj)
                CT.cache[CT.settings.currentTab].GNFilterApplied = false;


                return false;
            },
            showGnBannerOnload: function() {
                var isCTUser = unescape(CT.utils.cookies.read('userid')).indexOf('@cleartrip.com');
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                var gnTriggered = false;
                if (CT.settings[CT.app].guidedNavEnabled && CT.cache[CT.settings.currentTab].isCitySearch === true && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
                    if (CT.settings[CT.app].guidedNavForCTUsers) {
                        if (isCTUser != -1) {
                            $currentTab.find(".pinPointTab").show()
                            gnTriggered = true;
                            // CT.fire('guidedNavTrigger');
                        }
                    } else {
                        $currentTab.find(".pinPointTab").show()
                        // CT.fire('guidedNavTrigger')

                    }
                    /* if(gnTriggered === false && (CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "34600" || CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "32550" )){
                      $currentTab.find(".pinPointTab").show()
                     // CT.fire('guidedNavTrigger') 
                    }*/
                }
            },
            openGuidedBlock: function(e) {
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                var callBackParams = {};
                callBackParams.callBackFunc = searchResultViewSettings.guidedClose;
                callBackParams.callBackAttr = true;
                var availCount = 0,
                    tmp;
                _.each(CT.masterJson.get().ht, function(item, ind) {
                    if (item.priceInfo) {
                        availCount++;
                    }
                })
                CT.cache[CT.settings.currentTab].availableCount = availCount;
                CT.avaiActiveHotel = availCount;
                CT.totalHotel = CT.masterJson.get().ht.length;
                $('.pinPointInit, .pinPointTrigger').hide();
                CT.utils.cookies.create("gnLastShown", moment(), 365);
                // store("UI").set("guidedNavShown",true)
                CT.cache[CT.settings.currentTab].guidedNav = true
                CT.utils.showModalDialog('/hotelstatic/includes/guided-nav-modal.shtml', '700px', '480px', 'yes', false, undefined, undefined, true, undefined, undefined, undefined, callBackParams);
                CT.cache[CT.settings.currentTab].pinPointCurrStep = 0;
                $("#modal_window").css("background-color", "#000000")
                if (e.target.id == 'pinpointBlockBannerStart') {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'PinPoint_GetStarted', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                }
                if (e.target.id == 'pinPointTab') {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'PinPoint_Button', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                }
                if (e.target.id == 'pinpointBlockTryAgain') {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'PinPoint_TryAgainMini', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                }
                if (e.target.id == 'scrollgnBlock') {
                    searchResultViewSettings.guidedScrollClose();
                }
                return false;
            },
            closePinpointBanner: function(e) {
                var tabCache = CT.cache[CT.settings.currentTab];
                if (e.target.id == 'pinpointBlockBanner') {
                    this.$el.find(".pinPointBlock").fadeOut("slow");
                    var gnShownSession = sessionStorage.getItem("gnShownSession");
                    if (gnShownSession == null || gnShownSession == 'undefined') {
                        sessionStorage.setItem("gnShownSession", true);
                    }
                    tabCache.guidedNav = true;
                    tabCache.dontShowGNonScroll = true;
                    CT.utils.cookies.create("gnLastShown", moment(), 365);
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'PinPoint_CloseBanner', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                }
                if (e.target.id == 'pinpointBlockDoneBanner') {
                    this.$el.find(".pinPointBlockDone").fadeOut("slow");
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'PinPoint_CloseMini', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                }
            },

            dismissUpsellBanner: function(e) {
                var upsellBanner = $(e.target)
                upsellBanner.parents('.flightHotelSRPUpsells').hide();
            },

            checkAvailability: function(e, hotelId) {
                var $currentResults = this.$el,
                    msg = $.extend(true, {}, CT.messages[CT.app].checkAvail),
                    html;
                //html = Mustache.to_html($("#BlankSreenTemplate").html(), msg);
                //$currentResults.addClass('blankSlate').find('.listView').prepend(html);
                var tabCache = CT.cache[CT.settings.currentTab];
                var currentTab = $('#ResultContainer_' + CT.settings.currentTab);

                //if the call is from hotel modal window
                if (hotelId) {
                    CT.utils.hideModalDialog();
                    if ($('body').hasClass('mapView')) {
                        currentTab.find("#listViewLink").click();
                    }
                    tabCache.roomChecked = hotelId;
                }

                //$('#ResultContainer_'+CT.settings.currentTab).append(CT.to_html('BlankSreenTemplate', msg));
                //$('#ResultContainer_'+CT.settings.currentTab).find('section.viewContainer').hide();
                //$('#ResultContainer_'+CT.settings.currentTab).find('#area').hide();
                tabCache.checkAvailScroll = $(document).scrollTop();
                $(document).scrollTop(0);
                $('#ResultContainer_' + CT.settings.currentTab).find('#modifySearchLink').trigger('click');
                //$('.glassShield').show().css('margin-top', parseInt($('.glassShield').css('margin-top').split('px')[0]) + CT.utils.setElementSize(["#SearchForm"], 'height') - 46);
                //$('.glassShield').show().css('margin-top', $($(".primaryBar")[1]).height() + $("#Home").height());
                //$('#ResultContainer_'+CT.settings.currentTab+' .messageScreen').html("");
                //$('#ResultContainer_'+CT.settings.currentTab+' .messageScreen').css('min-height', CT.utils.setElementSize([".globalNav", ".globalFooter", "#SearchForm"], 'height')).css('min-height');
                $("#SearchForm").find(".checkin_date").attr("data-tipsytitle", CT.messages.hotel.ProvideChkInChkOut).tipsy({
                    gravity: 'N',
                    trigger: 'manual',
                    className: 'popOver',
                    html: true,
                    opacity: 1,
                    title: "data-tipsytitle",
                    addCloseButton: true
                }).tipsy('show');

            },
            requestBooking: function(e) {
                var self = this;
                var $hotelId = $(e.currentTarget).closest("li.listItem").attr("id");
                var $hotelName = CT.masterJson.getHotel($hotelId).nm;
                var $queryDetails = CT.cache[CT.settings.currentTab].searchParams.all;

                var city = '',
                    num_rooms = '',
                    r1AdultCount = '',
                    r1ChildCount = '',
                    r1Child1Age = '',
                    r1Child2Age = '',
                    r1Child3Age = '',
                    r2AdultCount = '',
                    r2ChildCount = '',
                    r2Child1Age = '',
                    r2Child2Age = '',
                    r2Child3Age = '',
                    r3AdultCount = '',
                    r3ChildCount = '',
                    r3Child1Age = '',
                    r3Child2Age = '',
                    r3Child3Age = '',
                    r4AdultCount = '',
                    r4ChildCount = '',
                    r4Child1Age = '',
                    r4Child2Age = '',
                    r4Child3Age = '',
                    r5AdultCount = '',
                    r5ChildCount = '',
                    r5Child1Age = '',
                    r5Child2Age = '',
                    r5Child3Age = '',
                    r6AdultCount = '',
                    r6ChildCount = '',
                    r6Child1Age = '',
                    r6Child2Age = '',
                    r6Child3Age = '';

                num_rooms = $queryDetails.num_rooms;
                city = $queryDetails.city;

                r1AdultCount = $queryDetails.adults1;
                r1ChildCount = $queryDetails.children1;
                if ($queryDetails.children1 >= 1) r1Child1Age = $queryDetails.ca1[0];
                if ($queryDetails.children1 >= 2) r1Child2Age = $queryDetails.ca1[1];
                if ($queryDetails.children1 >= 3) r1Child3Age = $queryDetails.ca1[2];

                if ($queryDetails.adults2) r2AdultCount = $queryDetails.adults2;
                if ($queryDetails.children2) r2ChildCount = $queryDetails.children2;
                if ($queryDetails.children2 >= 1) r2Child1Age = $queryDetails.ca2[0];
                if ($queryDetails.children2 >= 2) r2Child2Age = $queryDetails.ca2[1];
                if ($queryDetails.children2 >= 3) r2Child3Age = $queryDetails.ca2[2];

                if ($queryDetails.adults3) r3AdultCount = $queryDetails.adults3;
                if ($queryDetails.children3) r3ChildCount = $queryDetails.children3;
                if ($queryDetails.children3 >= 1) r3Child1Age = $queryDetails.ca3[0];
                if ($queryDetails.children3 >= 2) r3Child2Age = $queryDetails.ca3[1];
                if ($queryDetails.children3 >= 3) r3Child3Age = $queryDetails.ca3[2];

                if ($queryDetails.adults4) r4AdultCount = $queryDetails.adults4;
                if ($queryDetails.children4) r4ChildCount = $queryDetails.children4;
                if ($queryDetails.children4 >= 1) r4Child1Age = $queryDetails.ca4[0];
                if ($queryDetails.children4 >= 2) r4Child2Age = $queryDetails.ca4[1];
                if ($queryDetails.children4 >= 3) r4Child3Age = $queryDetails.ca4[2];

                if ($queryDetails.adults5) r5AdultCount = $queryDetails.adults5;
                if ($queryDetails.children5) r5ChildCount = $queryDetails.children5;
                if ($queryDetails.children5 >= 1) r5Child1Age = $queryDetails.ca5[0];
                if ($queryDetails.children5 >= 2) r5Child2Age = $queryDetails.ca5[1];
                if ($queryDetails.children5 >= 3) r5Child3Age = $queryDetails.ca5[2];

                if ($queryDetails.adults6) r6AdultCount = $queryDetails.adults6;
                if ($queryDetails.children6) r6ChildCount = $queryDetails.children6;
                if ($queryDetails.children6 >= 1) r6Child1Age = $queryDetails.ca6[0];
                if ($queryDetails.children6 >= 2) r6Child2Age = $queryDetails.ca6[1];
                if ($queryDetails.children6 >= 3) r6Child3Age = $queryDetails.ca6[2];

                var $queryString = "hotelName=" + $hotelName + ", " + city + "&checkIn=" + $queryDetails.chk_in + "&checkOut=" + $queryDetails.chk_out + "&roomCount=" + num_rooms;
                //room1 details;
                $queryString = $queryString + "&r1AdultCount=" + r1AdultCount + "&r1ChildCount=" + r1ChildCount + "&r1Child1Age=" + r1Child1Age + "&r1Child2Age=" + r1Child2Age + "&r1Child3Age=" + r1Child3Age;
                //room2 details;
                $queryString = $queryString + "&r2AdultCount=" + r2AdultCount + "&r2ChildCount=" + r2ChildCount + "&r2Child1Age=" + r2Child1Age + "&r2Child2Age=" + r2Child2Age + "&r2Child3Age=" + r2Child3Age;
                //room3 details;
                $queryString = $queryString + "&r3AdultCount=" + r3AdultCount + "&r3ChildCount=" + r3ChildCount + "&r3Child1Age=" + r3Child1Age + "&r3Child2Age=" + r3Child2Age + "&r3Child3Age=" + r3Child3Age;
                //room4 details;
                $queryString = $queryString + "&r4AdultCount=" + r4AdultCount + "&r4ChildCount=" + r4ChildCount + "&r4Child1Age=" + r4Child1Age + "&r4Child2Age=" + r4Child2Age + "&r4Child3Age=" + r4Child3Age;
                //room5 details;
                $queryString = $queryString + "&r5AdultCount=" + r5AdultCount + "&r5ChildCount=" + r5ChildCount + "&r5Child1Age=" + r5Child1Age + "&r5Child2Age=" + r5Child2Age + "&r5Child3Age=" + r5Child3Age;
                //room6 details;
                $queryString = $queryString + "&r6AdultCount=" + r6AdultCount + "&r6ChildCount=" + r6ChildCount + "&r6Child1Age=" + r6Child1Age + "&r6Child2Age=" + r6Child2Age + "&r6Child3Age=" + r6Child3Age;

                $(e.target).addClass('loading');
                $.ajax({
                    url: "/sendCheckAvailabilityEmail",
                    type: 'POST',
                    data: $queryString,
                    success: function(data) {
                        var sucessHtml = '<span class="successMessage" style="display:block"><i class="icon good"></i>Booking requested, we will get back to you.</span>';
                        $(e.target).removeClass('loading');
                        $(e.target).parent().html(sucessHtml);

                    },
                    error: function(data) {
                        var failureHtml = CT.Mustache.to_html(CT.messages[CT.app].unavailable, {
                            phoneSales: window.ccNumber
                        });
                        $(e.target).removeClass('loading');
                        $(e.target).parent().html(failureHtml);

                    }

                });

            },
            triggerResetFilter: function(e) {
                window.resetSelectedLocalites ? window.resetSelectedLocalites() : console.log("resetSelectedLocalites not defined");
                var strFilterApplied = $("#ResultContainer_" + CT.settings.currentTab).find('.filtersForm input:checked').serialize();
                var regex = /=(.*?)&|=(.*?)*/igm;
                var value = strFilterApplied.match(regex);
                strFilterApplied = strFilterApplied.replace(regex, " ").split(" ");
                var regexToShortenString = /^[a-z]|[A-Z]|[a-z]$/gm;

                strFilterApplied = strFilterApplied.reduce(function(newString, currentValue, currentIndex) {
                    if (currentValue) {
                        var shortenString = currentValue.match(regexToShortenString).join("").toLowerCase();
                        return newString + shortenString + value[currentIndex];
                    }
                    return newString;
                }, "");
                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_Filter_Cleared", {
                    "filterType": strFilterApplied,
                    "showAllType": "All"
                });
                var $element = $(e.currentTarget),
                    tmp;
                if (CT.isLocationEnabled) {
                    $("#ResultContainer_" + CT.settings.currentTab).find("nav.locality input:checked").removeAttr("checked");
                    $("#ResultContainer_" + CT.settings.currentTab).find("nav.locality input:checked").removeAttr("checked");
                    if (e.currentTarget.classList.contains('resetLink') == false && CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == false) {
                        $('#ResultContainer_' + CT.settings.currentTab).find(".propertySection").remove();
                        this.$el.find(".googleWidget").show();
                    } else if (e.currentTarget.classList.contains("locationChange") == true || e.currentTarget.className == "resetLink" || e.currentTarget.className == "button resetLink") {
                        $('#ResultContainer_' + CT.settings.currentTab).find(".propertySection").remove();
                        $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a.location').removeClass('sortDes')
                        $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a.location').removeClass('sortAsc')
                        this.$el.find(".googleWidget").show();
                    }
                    //Reset locality filter
                    if(e.currentTarget.className == "resetLink" || e.currentTarget.className == "button resetLink"){
                        window.localities = [];
                        $("#ResultContainer_" + CT.settings.currentTab).find("nav.lolfilter input:checked").removeAttr("checked");
                    }
                    if (window.showTags && $("#ResultContainer_" + CT.settings.currentTab).find(".tagList li.active").length > 0 && e.target.classList.contains("locationChange") == false) {
                        if(window.remvoeActiveClassFromTag != false){
                            $("#ResultContainer_" + CT.settings.currentTab).find(".tagList li.active").removeClass('active')
                        }
                        window.remvoeActiveClassFromTag = true;
                        var showFewFilterChecked = false
                        if ($("#ResultContainer_" + CT.settings.currentTab).find("nav.showFewFilter input").attr('checked')) {
                            var showFewFilterChecked = true
                        }
                        $("#ResultContainer_" + CT.settings.currentTab).find("nav.tagsFilter input:checked").removeAttr('checked')
                        if (showFewFilterChecked == true) {
                            $("#ResultContainer_" + CT.settings.currentTab).find("nav.showFewFilter").attr('checked', true)
                        }
                        CT.utils.trackers.mixpanelTrackingData.numTagsClicked = "N/A"
                        CT.utils.trackers.mixpanelTrackingData.tagsSelected = "N/A"
                        this.$el.find(".tagBoxClear").hide();
                        CT.numTagsClicked = ''
                        CT.tagsSelected = []
                    }
                    if (window.showTags && $("#ResultContainer_" + CT.settings.currentTab).find(".tagList li.active").length > 0) {
                        this.$el.find(".tagBoxClear").show()
                    }
                    // this.$el.find(".googleWidget").removeClass("placeholder");
                    // this.$el.find(".searchWidgetRow #showNearByBox").val($(e.target).attr("data-text"));
                    $(".pac-container").remove();
                    if (CT.cache[CT.settings.currentTab].viewType == "map") {
                        var autocompleteMap = this.$el.find("#mapAutocomplete")
                        $(autocompleteMap).val("").focus();
                        $(autocompleteMap).attr("placeholder", "Where you want to stay?");
                        //$("#mapAutocomplete").val(CT.cache[CT.settings.currentTab].searchedLocation).focus().select().trigger("keyup")
                        //CT.widgets.placeholder.parseDomTree(this.$el);
                    } else {
                        if (CT.cache[CT.settings.currentTab].searchedLocation && (e.currentTarget.className != "button resetLink" && e.currentTarget.className != "resetLink")) {
                            //$("#showNearByBox").val(CT.cache[CT.settings.currentTab].searchedLocation).focus().select().trigger("keyup");
                            $("#ResultContainer_" + CT.settings.currentTab).find('#showNearByBox').val(CT.cache[CT.settings.currentTab].searchedLocation).focus().select().trigger("keyup")
                            this.$el.find(".googleWidget").removeClass("slideMeDown");
                        } else {
                            this.$el.find(".searchWidgetRow #showNearByBox").val('').focus().trigger("keyup");
                            this.$el.find(".googleWidget").removeClass("slideMeDown");
                        }

                    }
                    if (CT.cache[CT.settings.currentTab].plceselected == false && CT.cache[CT.settings.currentTab].searchParams.all.poi != undefined && CT.cache[CT.settings.currentTab].searchParams.all.poi[0] != "" && e.currentTarget.className == 'presetFilter locationChange') {
                        this.$el.find("#showNearByBox").val(CT.cache[CT.settings.currentTab].searchParams.all.poi[0]).focus().select()
                    } else {
                        this.$el.find("#showNearByBox").focus().select().trigger('keyup')
                    }
                    if ((e.currentTarget.className == "presetFilter locationChange" || e.currentTarget.className == "button resetLink" || e.currentTarget.className == "resetLink") && CT.cache[CT.settings.currentTab].searchedLocation) {
                        $("#ResultContainer_" + CT.settings.currentTab).find('#showNearByBox').val(CT.cache[CT.settings.currentTab].searchedLocation).focus().select()
                    }
                    if ((e.currentTarget.className == "presetFilter locationChange" || e.currentTarget.className == "button resetLink" || e.currentTarget.className == "resetLink") &&
                        !CT.cache[CT.settings.currentTab].searchedLocation && CT.cache[CT.settings.currentTab].pointOfIntrestValue) {
                        $("#ResultContainer_" + CT.settings.currentTab).find('#showNearByBox').val(CT.cache[CT.settings.currentTab].pointOfIntrestValue).focus().select()
                    }
                }
                /*  CT.cache[CT.settings.currentTab].mapDragged*/
                CT.cache[CT.settings.currentTab].filterClicked = true;
                e.preventDefault();
                if (CT.cache[CT.settings.currentTab].guidedNav && CT.cache[CT.settings.currentTab].guidedNav == true) {
                    //TODO-Check for guided navigation abhay
                    //this.$el.find(".closeGN").hide();
                    //this.$el.find(".openGN").show();
                    // this.$el.find(".pinPointBlockDone").hide();
                    // this.$el.find(".pinPointBlock").show();
                }
                if (!CT.isLocationEnabled || CT.isLocationEnabled == false) {
                    this.$el.find(".featuredSort").trigger("click");
                    this.$el.find('.filtersForm').trigger('filters_reset');
                } //reset the sorter back to feature
                if (CT.isLocationEnabled == true && ($element.hasClass("resetLink") || $element.attr("data-flt") == "allHotels")) {
                    var areadistance = ""
                    if (CT.masterJson.get().clni &&
                        CT.masterJson.get().clni.clat &&
                        CT.masterJson.get().clni.clng &&
                        CT.isLocationEnabled == true &&
                        (CT.cache[CT.settings.currentTab].autoCompleteLatitude != "" && CT.cache[CT.settings.currentTab].autoCompleteLatitude != undefined)) {
                        var cityLat = CT.masterJson.get().clni.clat
                        var cityLng = CT.masterJson.get().clni.clng
                        var areadistance = CT.utils.helperFunctions.getDistanceFromLatLonInKm(CT.cache[CT.settings.currentTab].autoCompleteLatitude, CT.cache[CT.settings.currentTab].autoCompleteLangitude, cityLat, cityLng)
                    }
                    $.each(CT.masterJson.get().ht, function(index, hotel) {
                        if (hotel.hasSpriteIcon && hotel.classToarea) {
                            delete hotel.hasSpriteIcon;
                            delete hotel.classToarea;
                        }
                        if (hotel.distanceFromAreaString)
                            delete hotel.distanceFromAreaString;
                        if (hotel.distanceFromLocation)
                            delete hotel.distanceFromLocation;
                        if (hotel.areaSearch || hotel.poiSearch || hotel.isgoogleSearch) {
                            hotel.areaSearch = false
                            hotel.poiSearch = false
                            hotel.isgoogleSearch = false
                        }

                    });

                    if (areadistance != "" && areadistance > 50) {
                        if ($("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters a.current").hasClass("location")) {
                            $('#ResultContainer_' + CT.settings.currentTab).find(".propertySection").remove();
                            this.$el.find(".googleWidget").show();
                            $('nav.sorters .location').text("");
                            $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', false)
                            $("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters .location").removeClass("current");
                            $("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters .featuredSort").addClass("current");
                            CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal = false
                            CT.cache[CT.settings.currentTab].plceselected = false
                        } else if (e.currentTarget.classList.contains("locationChange")) {
                            $('nav.sorters .location').text("");
                            CT.cache[CT.settings.currentTab].arealDistancegreater = false
                            $("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters .featuredSort").addClass("current");
                        }
                    }

                    if (CT.isLocationEnabled == true && e.currentTarget.classList.contains('button') == true) {
                        this.showAllHotelsForPoi()
                    }
                    if (CT.isLocationEnabled == true && e.currentTarget.className == "resetLink") {
                        this.showAllHotelsForPoi()
                    }

                    // if(CT.isLocationEnabled==true && $("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters a.location").is(':visible')==true){
                    //  this.$el.find(".googleWidget").hide()
                    // }
                    CT.cache[CT.settings.currentTab].searchParams.all.area = "";
                    CT.cache[CT.settings.currentTab].searchParams.all.poi = "";
                    CT.cache[CT.settings.currentTab].googleSortedArea = "";
                    CT.cache[CT.settings.currentTab].googleSortedPoi = "";
                    if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == false) {
                        this.$el.find("nav.sorters .location").css({
                            'display': 'none'
                        });
                    } else if (e.currentTarget.classList.contains("locationChange")) {
                        this.$el.find("nav.sorters .location").css({
                            'display': 'none'
                        });
                    }
                    if (this.$el.find(".guidedNav").length >= 1) {
                        this.$el.find(".guidedNav").remove()
                    }
                    if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == false || (areadistance != "" && areadistance > 50)) {
                        $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', false)
                        this.$el.find(".featuredSort").trigger("click");
                        //this.$el.find('.filtersForm').trigger('filters_reset');
                    }
                    this.$el.find('.filtersForm').trigger('filters_reset');
                }

                CT.utils.helperFunctions.updateHideShowMessage(e);
                CT.cache[CT.settings.currentTab].srpCollection = undefined;
                //CT.cache[CT.settings.currentTab].srpUpsell = undefined;
                CT.cache[CT.settings.currentTab].searchParams.all.area = CT.cache[CT.settings.currentTab].searchParams.all.poi = "";
                CT.masterJson.get().clusterMapItems = undefined;
                // if ($('#ResultContainer_' + CT.settings.currentTab).find(".searchWidgetRow").find("#locationBasedHotels").length)
                //For Retain Filters PRM
                if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                    localStorage.setItem("recentFilters", null);
                }
            },
            triggerTagsFilter: function(e, fromFilter) {
                console.warn("triggerTagsFilter");
                this.$el = this.$el || $('#ResultContainer_' + CT.settings.currentTab);
                var $thisTag = $(e.currentTarget);
                var tagName = $thisTag.attr('tagname');
                if (fromFilter) {
                    tagName = $thisTag.attr("value")
                    $thisTag = this.$el.find(".tagContainer ul.tagList").find(".tagItem." + tagName);
                }
                if ($thisTag.hasClass("promoTag")) {
                    return;
                }
                CT.numTagsClicked = CT.numTagsClicked ? CT.numTagsClicked : 0;
                CT.tagsSelected = CT.tagsSelected ? CT.tagsSelected : [];
                var tagStatus = "On";
                if (CT.cache[CT.settings.currentTab].recentFilterData && CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle != undefined) {
                    if (CT.cache[CT.settings.currentTab].recentFilterData.currentFilterele == [] &&
                        this.$el.find(".tagList li.active").length > 0) {
                        CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle.push(this.$el.find(".tagList li.active").attr("data-tagid"))
                    }
                    var currentFilterEle = CT.cache[CT.settings.currentTab].recentFilterData.currentFilterEle
                } else {
                    var currentFilterEle = [];
                }
                //CT.settings.currentTab].recentFilterData.currentFilterEle
                currentFilterEle.push($thisTag.attr("data-tagid"));
                CT.cache[CT.settings.currentTab].recentFilterData = {
                    "prevFilterEle": [],
                    "currentFilterEle": currentFilterEle,
                    "prevSerializedData": [],
                    "currentSerializedData": []
                }
                if (!$thisTag.hasClass("active")) {
                    $thisTag.addClass('active');
                    CT.numTagsClicked += 1;
                    CT.tagsSelected.push(tagName);
                    CT.utils.trackers.mixpanelTrackingData.numTagsClicked = String(CT.numTagsClicked);
                    CT.utils.trackers.mixpanelTrackingData.tagsSelected = CT.tagsSelected.length > 0 ? CT.tagsSelected.toString() : "N/A"
                    tagStatus = "On";
                    this.$el.find(".filtersForm .tagsFilter ." + $thisTag.attr("data-flt") + "_tag input").attr("checked", true);
                } else {
                    $thisTag.removeClass('active');
                    tagStatus = "Off";
                    this.$el.find(".filtersForm .tagsFilter ." + $thisTag.attr("data-flt") + "_tag input").attr("checked", false);
                    CT.numTagsClicked -= 1;
                    if (CT.numTagsClicked == 0) {
                        CT.utils.trackers.mixpanelTrackingData.numTagsClicked = "0";
                    } else {
                        CT.utils.trackers.mixpanelTrackingData.numTagsClicked = String(CT.numTagsClicked);
                    }
                    var index = CT.tagsSelected.indexOf(tagName);
                    if (index != -1) {
                        CT.tagsSelected.splice(index, true)
                    }
                    CT.utils.trackers.mixpanelTrackingData.tagsSelected = CT.tagsSelected.length > 0 ? CT.tagsSelected.toString() : "N/A"
                }
                var activeTags = this.$el.find(".tagList li.active");
                if (activeTags.length > 0) {
                    this.$el.find(".tagBoxClear").show();
                } else {
                    this.$el.find(".tagBoxClear").hide();
                }
                // $('#ResultContainer_' + CT.settings.currentTab).find("section.secondaryBar nav.sorters a").removeClass("current sortAsc sortDes");
                if (activeTags.length > 0) {
                    this.$el.find("section.secondaryBar nav.sorters a[data-sort='tags']").addClass("current");
                    CT.fire('sorterUrlParams.set', [{
                        sort: "tags"
                    }]);
                } else {
                    this.$el.find("section.secondaryBar nav.sorters a[data-sort="+window.secondarySort+"]").addClass("current");
                    CT.fire('sorterUrlParams.set', [{
                        sort: "featured"
                    }]);
                }

                CT.fire('filters.apply');
                CT.tagsInteracted = true;

                CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_Tags_Clicked', {
                    'source': "TopBanner",
                    "tagName": tagName,
                    "tagValue": tagStatus,
                    "tagsSelected": CT.tagsSelected.join('+')
                });
                if (window.showTags && CT.tagsData) {
                    store("skippedTagPopCityCnt").remove(CT.cache[CT.settings.currentTab].searchParams.all.city);
                }
            },

            toggleActiveState: function(evt) {
                var $target = $(evt.currentTarget);
                $target.toggleClass("active");
                var tagsSelectedCount = 0,
                    tagsSelected = "";
                var tagValue = $target.hasClass("active") ? "On" : "Off";
                var selectedFilterTagsName = [];
                $(".tagList li.promoTag.active").each(function(idx, ele) {
                    selectedFilterTagsName.push($(ele).attr("tagname"));
                });

                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_TagsHint_Clicked", {
                    'source': "Loader",
                    'Type': "Tag",
                    'TagName': $target.attr("tagname"),
                    'TagsSelected': selectedFilterTagsName.join('+'),
                    'TagsSelectedCount': selectedFilterTagsName.length,
                    'TagValue': tagValue
                });
            },

            promoTagBtnDone: function(evt) {
                var $target = $(evt.currentTarget);
                var slectedFilterTagId = [];
                var selectedFilterTagsName = [];
                $(".tagList li.promoTag.active").each(function(idx, ele) {
                    slectedFilterTagId.push($(ele).attr("data-tagid"));
                    selectedFilterTagsName.push($(ele).attr("tagname"));
                });
                CT.tagsSelected = selectedFilterTagsName;
                $(".filtersForm .tagsFilter").find("input[name='tagsFilter']").attr("checked", false);
                $(".tagContainer .tagList li.tagItem:not(.promoTag)").removeClass("active");
                slectedFilterTagId.forEach(function(ele) {
                    $(".tagContainer .tagList li.tagItem[data-tagid='" + ele + "']:not(.promoTag)").addClass("active");
                    $(".filtersForm .tagsFilter").find("input[name='tagsFilter'][value='" + ele + "']").attr("checked", true);
                });
                if (slectedFilterTagId.length > 0) {
                    this.$el.find(".tagBoxClear").show();
                } else {
                    this.$el.find(".tagBoxClear").hide();
                }
                $('#ResultContainer_' + CT.settings.currentTab).find("section.secondaryBar nav.sorters a").removeClass("current sortAsc sortDes");
                if (slectedFilterTagId.length > 0) {
                    $('#ResultContainer_' + CT.settings.currentTab).find("section.secondaryBar nav.sorters a[data-sort='tags']").addClass("current");
                    CT.fire('sorterUrlParams.set', [{
                        sort: "tags"
                    }]);
                } else {
                    $('#ResultContainer_' + CT.settings.currentTab).find("section.secondaryBar nav.sorters a[data-sort='featured']").addClass("current");
                    CT.fire('sorterUrlParams.set', [{
                        sort: "featured"
                    }]);
                }
                CT.cache[CT.settings.currentTab].recentFilterData = {
                    "prevFilterEle": [],
                    "currentFilterEle": slectedFilterTagId,
                    "prevSerializedData": [],
                    "currentSerializedData": []
                }
                $(document).scrollTop(0);
                CT.fire('filters.apply');

                CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_Tags_Clicked', {
                    'source': fromFilter ? "Tags filter" : "Loader",
                    "tagName": "Done",
                    "tagValue": "N/A",
                    "tagsSelected": selectedFilterTagsName.join('+')
                });
            },

            showMoreTags: function(evt) {
                var $parent = $(evt.currentTarget.parentNode);
                $parent.find(".metaTags__more").hide();
                $parent.find(".metaTags__item").show();
            },

            triggerBadgeFilter: function(e) {
                var $thisTag = $(e.currentTarget);
                var currentFilterEle = [];
                var that = this,
                    tmp;

                if ($thisTag.hasClass('dealsFilter')) {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_SmartDeals', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                } else if ($thisTag.hasClass('ctBookPercentage')) {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_SmartBestsellers', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                } else if ($thisTag.hasClass('quickKeysFilter')) {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_SmartQuickeys', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                } else if ($thisTag.hasClass('weSleepHereFilter')) {
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_SmartWSH', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                } else if ($thisTag.hasClass('allHotels')) {
                    // create variable called viaToolBarControls
                    CT.cache[CT.settings.currentTab].viaToolBarControls = true;
                    // send a tracking event.
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Filter_SmartAll', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                }

                //hide nearby cities notification
                this.$el.trigger('nearByNotification.hide');

                currentFilterEle.push($thisTag.parents('.badgeFilter').attr("class"));

                CT.cache[CT.settings.currentTab].recentFilterData = {
                    "prevFilterEle": [],
                    "currentFilterEle": currentFilterEle,
                    "prevSerializedData": [],
                    "currentSerializedData": []
                }
                $thisTag.closest('.badgeFilter').find('li').removeClass('current');
                $thisTag.parent().addClass('current');
                this.$el.find('.filtersForm input[name="badgeFilter"]').val($thisTag.attr('data-flt'));

                //update sorters based on the badge type
                function changeCurrentSort(sortType) {
                    var sorterActiveClassesMap = {
                        dealSort: {
                            cls: 'current sortDes',
                            type: 'deal',
                            order: 'desc'
                        },
                        taSort: {
                            cls: 'current sortDes',
                            type: 'ta',
                            order: 'desc'
                        },
                        featuredSort: {
                            cls: 'current',
                            type: 'featured',
                            order: 'asc'
                        }
                    };
                    var sorterRemoveClasses = 'current sortDes sortAsc';

                    that.$el.find('.sorters li a').removeClass(sorterRemoveClasses);
                    tmp = sorterActiveClassesMap[sortType];
                    that.$el.find('.sorters li .' + sortType).addClass(tmp.cls);
                    CT.fire('sorterUrlParams.set', [{
                        sort: tmp.type,
                        sort_order: tmp.order
                    }]);
                }

                tmp = '';

                if ($thisTag.hasClass('quickKeysFilter') || $thisTag.hasClass('dealsFilter')) {
                    tmp = 'dealSort';
                } else if ($thisTag.hasClass('ctBookPercentage') || $thisTag.hasClass('weSleepHereFilter')) {
                    tmp = 'taSort';
                } else if ($thisTag.hasClass('allHotels')) {
                    tmp = 'featuredSort';
                }
                if (!$thisTag.hasClass('allHotels')) {
                    if (tmp != '')
                        changeCurrentSort(tmp);

                    //trigger apply filters
                    CT.fire('filters.apply');
                } else {
                    this.triggerResetFilter(e);
                }
                var filterArrShown = CT.cache[CT.settings.currentTab].filtersShown;
                var hideSorters = CT.settings[CT.app].airBnbSortersToHide;
                var airBnbFilters = CT.settings[CT.app].airBnbFilters
                if ($thisTag.hasClass('onlyAirBnb')) {
                    for (var k = 0; k < filterArrShown.length; k++) {
                        $("." + filterArrShown[k]).closest(".sideBlock").hide()
                    }
                    for (var k = 0; k < airBnbFilters.length; k++) {
                        $("." + airBnbFilters[k]).closest(".sideBlock").show()
                    }
                    for (var k = 0; k < hideSorters.length; k++) {
                        $("." + hideSorters[k]).closest("li").hide()
                    }
                    this.$el.find(".airbnbListUnitLogo").hide();
                } else {

                    for (var k = 0; k < airBnbFilters.length; k++) {
                        $("." + airBnbFilters[k]).closest(".sideBlock").hide()
                    }
                    for (var k = 0; k < filterArrShown.length; k++) {
                        $("." + filterArrShown[k]).closest(".sideBlock").show()
                    }
                    for (var k = 0; k < hideSorters.length; k++) {
                        $("." + hideSorters[k]).closest("li").show()
                    }
                    this.$el.find(".airbnbListUnitLogo").show();
                }
            },

            /*
             * @DESC : to remove the hidden fields added when a search for hotel or locality is done in sort bar
             */
            removeSearchFilter: function(e) {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                    $filtersForm = $currentTab.find('.filtersForm'),
                    $thisTag = $(e.target),
                    tmp;
                CT.cache[CT.settings.currentTab].filterClicked = true
                CT.cache[CT.settings.currentTab].mapDragged = false;
                $filtersForm.find('input.hotelName').val('');
                if ((tmp = $thisTag.prev('input').attr('data-checkboxid'))) {
                    $filtersForm.find('input#' + CT.settings.currentTab + tmp).removeAttr('checked');
                }
                CT.fire('filters.apply');
            },

            /*
             * @DESC : removes parent div of the element on which event occured.
             */
            removeContainerElement: function(e) {
                var $element = $(e.currentTarget),
                    tmp;
                e.preventDefault();

                CT.utils.helperFunctions.updateHideShowMessage(e);

                if ($element.tipsy) {
                    $element.tipsy('hide');
                }

                if ((tmp = $element.attr('data-close')))
                    $element.parents(tmp).remove();
                else
                    $element.parent().remove();
            },



            redirectToHomePage: function(e) {
                e.preventDefault();
                window.location.href = window.location.protocol + '//' + window.location.host + '/packages';
            },


            showTooPickyMessage: function(e, count, name, checked) {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                    dispObj = CT.messages[CT.app].blockMsgs.tooPicky,
                    html;

                count = parseInt(count);

                if (checked) {
                    tmp = {};
                    if (count == 1) {
                        tmp.single = true;
                    }
                    tmp.count = count;
                    if (name == 'Amenities') {
                        tmp['with'] = true;
                    }
                    tmp.name = name;

                    dispObj.msg = CT.to_html(dispObj.msg, tmp);
                    html = CT.to_html('BlockMessageTpl', dispObj);
                    this.addSeparator(null, html, 'bottom');
                } else {
                    $currentTab.find('.viewController .' + dispObj.cls).remove();
                }
            },



            /*
             * @desc : show or hide amenities in DP when amenities filter is checked or unchecked
             * @param : show - value can be true or false
             */
            showAmenities: function(e, show) {
                var $amDivs = $('li.listItem .showAmenities');
                if (show) {
                    $amDivs.show();
                } else {
                    $amDivs.hide();
                }
            },



            /*
             * @desc : it is a dynamic package specific function. used to update price difference when a room is changed on a modal window.
             * @param : hotelId - id of the hotel
             * @param : rmIndex - index of the room inside the hotel which was choosen in the modal window
             */
            updateHtRmRatesDiff: function(e, hotelId, rmIndex, pkgSaving) {
                if (CT.roomTypeChanged) {
                    var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                        $hotelLi = $currentTab.find('li#' + hotelId),
                        hotelJson = CT.masterJson.getHotel(hotelId),
                        priceInfo = hotelJson.priceInfo,
                        selectedRoom = priceInfo.rms[rmIndex],
                        $totalSpan = $hotelLi.find('.price h4 span.orgPrice'),
                        priceDiff, html, hotelPriceInfo, oldPrice, cashObj;

                    CT.roomTypeChanged = false;
                    CT.utils.showLoader("hotel");

                    pkgSaving = parseInt(pkgSaving);

                    priceDiff = selectedRoom.tot;
                    oldPrice = priceInfo.pf;
                    priceInfo.pf = priceInfo.pf + priceDiff;
                    priceInfo.ps = pkgSaving;
                    priceInfo.hotelpf = priceInfo.hotelpf + priceDiff;
                    priceInfo.hotelps = pkgSaving;
                    _.forEach(priceInfo.rms, function(eachRms) {
                        eachRms.tot = eachRms.tot - priceDiff;
                    });


                    //update masterjson with changes
                    hotelJson = $.extend(true, hotelJson, CT.FlightSolution.calFormatPrice(hotelJson, priceInfo.pf, priceInfo.ps, priceInfo.airpf, priceInfo.airps, priceInfo.hotelpf, priceInfo.hotelps, hotelJson.sfsfd));

                    hotelJson.rmtp = selectedRoom.rm;
                    hotelJson.rmtc = selectedRoom.rmtc;
                    hotelJson.rtc = selectedRoom.rtc;
                    hotelJson.pf = hotelJson.priceInfo.pf;
                    hotelJson.ps = "" + hotelJson.priceInfo.ps + "";

                    //update price and saving in the view
                    hotelPriceInfo = CT.FlightSolution.calFormatPrice(undefined, priceInfo.pf, priceInfo.ps, priceInfo.airpf, priceInfo.airps, priceInfo.hotelpf, priceInfo.hotelps, hotelJson.sfsfd);

                    //change formatted price to old price temporarily just to give cash register effect.
                    $totalSpan.html(CT.utils.formatForCurrency(oldPrice, false, null, true).fmtPrice);

                    html = Mustache.to_html($('#DpTotalPriceTpl').html(), hotelPriceInfo);
                    setTimeout(function() {
                        $('body,html').scrollTop($hotelLi.offset().top);
                        $hotelLi.addClass('highlightMe');
                        $hotelLi.find('.summary h3').html(selectedRoom.rm);
                        $hotelLi.find('.price').html(html);
                        $totalSpan.html(oldPrice);
                        cashObj = new CashRegister($totalSpan.get(0));
                        cashObj.start(priceInfo.pf);
                        //update markup attributes
                        $hotelLi.attr('data-price', priceInfo.pf);
                        $hotelLi.attr('data-ps', priceInfo.ps);
                        $hotelLi.attr('data-roomtypecode', selectedRoom.rmtc);
                        $hotelLi.attr('data-bookingcode', selectedRoom.rtc);
                        $hotelLi.attr('data-savper', hotelPriceInfo.discPerc);
                    }, 3000);
                    setTimeout(function() {
                        $hotelLi.removeClass('highlightMe');
                    }, 7000);
                } else {
                    if (CT.utils.hideModalDialog) {
                        CT.utils.hideModalDialog();
                    }
                }
            },



            openChangeFlightsModal: function(evt) {
                $lItem = $(evt.target).closest(".listItem");
                $lItem.addClass("selChangeFlight");
                var callback = function() {
                    $lItem.removeClass("selChangeFlight");
                }
                CT.utils.showModalDialog('/dp/includes/flight-srp.shtml?tripType=on&from=BLR&to=BOM&ret_date=12+Nov%2C+2012&adults=1&childs=0&infants=0&class=Economy&prefAirline=&dep_time=0', '90%', '90%', false, false, callback, undefined, undefined, undefined, undefined, CT.FlightSolution.confirmUserForClose);
            },



            handleScroll: function(e) {
                var tabCache = CT.cache[CT.settings.currentTab];
                var isCTUser = unescape(CT.utils.cookies.read('userid')).indexOf('@cleartrip.com');
                var gnTriggered = false;

                CT.lastScroll = $(window).scrollTop();

                if (CT.settings.currentTab !== 0) {

                    var newScroll = $(window).scrollTop(),
                        scrollCount, $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                        itemId, lastItem, tmp;
                    //console.log(newScroll - lastScroll);
                    CT.lastScroll = newScroll;
                    var isIpad = navigator.userAgent.match(/iPad/i) != null;
                    var dontTriggerSticky = true
                    var badgeCnt = CT.cache[CT.settings.currentTab].badgeCnt
                    if (CT.cache[CT.settings.currentTab].budgetHotelShown == undefined) {
                        dontTriggerSticky = false;
                    }
                    if (window.isMobileUA == true || isIpad == true || $.browser.msie == true) {
                        dontTriggerSticky = false;
                    }
                    if ($currentTab.find("#modifySearchLink").closest("li").hasClass("current")) {
                        dontTriggerSticky = false;
                    }
                    if (dontTriggerSticky == true) {
                        if (CT.subProd == "wg") {
                            var scrollChk = $currentTab.find("#modifySearchLink").closest("li").hasClass("current") ? 420 : 71;
                        } else {
                            var scrollChk = $currentTab.find("#modifySearchLink").closest("li").hasClass("current") ? 420 : 45;
                        }

                        if (CT.lastScroll > scrollChk) {
                            //if(CT.lastScroll >= $currentTab.find(".primaryFilter").offset().top && CT.lastScroll != 0){
                            if (CT.subProd != "wg") {
                                $currentTab.find(".primaryBar").addClass("stickyPrimaryBar");
                            }
                            $currentTab.find(".primaryFilter").addClass("stickyPrimaryBar");
                            $currentTab.find(".viewContainer").addClass("paddedViewContainer");
                        } else {
                            if (CT.subProd != "wg") {
                                $currentTab.find(".primaryBar").removeClass("stickyPrimaryBar");
                            }
                            $currentTab.find(".primaryFilter").removeClass("stickyPrimaryBar");
                            $currentTab.find(".viewContainer").removeClass("paddedViewContainer");
                        }
                    }
                    var secondaryBarClass = "stickySecondaryBar smaller";
                    if (CT.tagsData && window.showTags) {
                        if ((CT.lastScroll > 171 && $currentTab.find(".resultsCont").offset().top - $(window).scrollTop() < 3) && this.$el.find("#modifySearchLink i").hasClass("rArrow")) {
                            $currentTab.find(".searchWidgetRow").addClass("stickySearchWidgetRow");
                            $currentTab.find(".secondaryBar").addClass(secondaryBarClass);
                            $currentTab.find(".secondaryBar").addClass("withLocation");

                        } else if ((CT.lastScroll > 471 && $currentTab.find(".resultsCont").offset().top - $(window).scrollTop() < 5) && this.$el.find("#modifySearchLink i").hasClass("dArrow")) {
                            $currentTab.find(".searchWidgetRow").addClass("stickySearchWidgetRow");
                            $currentTab.find(".secondaryBar").addClass(secondaryBarClass);
                        } else {
                            $currentTab.find(".resultsCont").css({
                                'margin-top': ''
                            });
                            $currentTab.find(".searchWidgetRow").removeClass("stickySearchWidgetRow");
                            $currentTab.find(".secondaryBar").removeClass(secondaryBarClass);
                        }
                    } else {
                        if (CT.lastScroll > 121 && this.$el.find("#modifySearchLink i").hasClass("rArrow")) {
                            if (CT.subProd != 'wg') {
                                if (this.$el.find(".googleWidget").length > 0) {
                                    $currentTab.find(".searchWidgetRow").addClass("stickySearchWidgetRow");
                                    $currentTab.find(".secondaryBar").addClass(secondaryBarClass);
                                    $currentTab.find(".secondaryBar").addClass("withLocation");
                                } else {
                                    $currentTab.find(".searchWidgetRow").addClass("stickySearchWidgetRow");
                                    $currentTab.find(".secondaryBar").addClass(secondaryBarClass);
                                }
                            }
                        } else if ((CT.lastScroll > 420 && $currentTab.find(".resultsCont").offset().top - $(window).scrollTop() < 3) && this.$el.find("#modifySearchLink i").hasClass("dArrow")) {
                            if (CT.subProd != 'wg') {
                                if (this.$el.find(".googleWidget").length > 0) {
                                    $currentTab.find(".searchWidgetRow").addClass("stickySearchWidgetRow");
                                    $currentTab.find(".secondaryBar").addClass(secondaryBarClass);
                                    $currentTab.find(".secondaryBar").addClass("withLocation");
                                }
                            }
                        } else {
                            $currentTab.find(".searchWidgetRow").removeClass("stickySearchWidgetRow");
                            $currentTab.find(".secondaryBar").removeClass(secondaryBarClass);
                        }

                    }
                    /* if(!$currentTab.find(".filters").hasClass("is_stuck")){
                          $currentTab.find(".filters").stick_in_parent({offset_top:$currentTab.find(".primaryBar").outerHeight()});
                      
                        }*/
                    if (CT.settings[CT.app].guidedNavEnabled && CT.lastScroll >= CT.settings.hotel.guidedNavScrollThreshold && !tabCache.dontShowGNonScroll) {
                        if (CT.settings[CT.app].guidedNavForCTUsers) {
                            if (isCTUser != -1) {
                                gnTriggered = true;
                                tabCache.guidedNavScrollShown = true;
                                CT.fire('guidedNavScrollTrigger')
                            }
                        } else {
                            tabCache.guidedNavScrollShown = true;
                            CT.fire('guidedNavScrollTrigger')
                            // CT.fire('guidedNavTrigger')
                        }
                        /*if(gnTriggered === false && (CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "34600" || CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "32550")){
                          tabCache.guidedNavScrollShown = true;
                          CT.fire('guidedNavScrollTrigger') 
                        }*/
                    }
                    /*else if(CT.lastScroll < 200 && tabCache.guidedNavScrollShown != undefined && tabCache.guidedNavScrollShown === true && !tabCache.dontShowGNonScroll){
                                              CT.fire('guidedNavTrigger')
                                            }*/

                    if (CT.infScrollLast != undefined && (newScroll + $(window).height()) >= ($(document).height() - 50) && !$('body').hasClass('mapView')) {
                        scrollCount = CT.settings[CT.app].infScrollCount;
                        itemId = this.getDisplayItemId();
                        if (itemId != undefined) {
                            tmp = $currentTab.find(itemId).length;
                            if (CT.infScrollLast + scrollCount >= tmp) {
                                lastItem = tmp;
                            } else {
                                lastItem = CT.infScrollLast + 10;
                            }
                            $currentTab.find(itemId + ":gt(" + (CT.infScrollLast - 1) + "):lt(" + (lastItem - 1) + ")").show();
                            CT.infScrollLast = lastItem;
                        }
                        CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_Scrolled", {
                            "noOfPagesScrolled": String(parseInt(CT.infScrollLast / 10)),
                            "noOfHotelsScrolled": String(CT.infScrollLast),
                            "scroll direction": "down"
                        });
                        if (CT.subProd == "wg") {
                            // $(document.body).trigger("sticky_kit:recalc");
                            //  $currentTab.find(".filters").parent().css('height',$(document).height() +"px");
                        }
                    }
                } else {
                    CT.lastScroll = 0;
                }
            },



            initUndoFilter: function(e) {
                CT.fire("undolastfilter.init");
                return false;
            },



            initHotelPicModalWindow: function(e) {
                //CT.utils.showModalDialog('/dpjs/includes/flight-srp.shtml?tripType=on&from=BLR&to=BOM&ret_date=12+Nov%2C+2012&adults=1&childs=0&infants=0&class=Economy&prefAirline=&dep_time=0','90%','90%', false, false);
                return false;
            },



            initHotelModalWindow: function(e) {

                var $thisTag = $(e.currentTarget),
                    baseUrl = '',
                    tmp;
                var hotelV2 = window.hotelModalV2;
                if($thisTag.attr('data-hotelslugid')){
                    var hotelSlugId = $thisTag.attr('data-hotelslugid');
                }
                if ($thisTag.attr('data-hotelId')) {
                    var hotelId = $thisTag.attr('data-hotelId');
                } else {
                    var $listItem = $thisTag.parents('li.listItem'),
                        hotelId = $listItem.attr('id'),
                        hotelSlugId = $listItem.attr('data-hotelslugid');
                }
                // event.stopPropagation();
                $("#ResultContainer_" + CT.settings.currentTab).find(".filters").css({
                    "z-index": "1"
                })
                this.taxesMarkup(hotelId);
                if (CT.app === "dp") {
                    CT.roomTypeChanged = false;
                    baseUrl = CT.utils.helperFunctions.getHotelModalUrl(hotelId);
                    CT.utils.showModalDialog(baseUrl + '&pkg=y' + $thisTag.data('hash'), '90%', '90%', false, false, undefined, undefined, undefined, undefined, undefined, CT.FlightSolution.confirmUserForClose);
                } else {
                    // baseUrl = CT.utils.helperFunctions.getHotelModalUrl(hotelId);
                    //CT.utils.showModalDialog(baseUrl + $thisTag.data('hash'),'90%','570',true,false,function(yPos) { window.scrollTo(0, yPos); },undefined,undefined,undefined,true);
                    if (CT.subProd !== "wg" && hotelV2) {
                    var hotelModelURL = CT.utils.helperFunctions.openHotelModalV2(hotelId, undefined, $thisTag.data('hash'),hotelSlugId);
                        var metaRef = (new URL(document.location)).searchParams.get("meta_ref") || null;
                        var tagFliterStr = (CT.cache[CT.settings.currentTab].searchParams.all && CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) ? CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter : "";
                        tagFliterStr = tagFliterStr.replace(/_tag/g, "");
                        hotelModelURL = CT.utils.helperFunctions.addQueryParamsToURL(hotelModelURL, "tags", tagFliterStr)
                        window.open(hotelModelURL, "_blank");
                        
                        //window.location.href =  "http:" + '//' + window.location.hostname + hotelModelURL
                    } else {
                        if (window.isMobileUA && window.isMobileUA == true) {
                            CT.utils.helperFunctions.openHotelModalWindow(hotelId, "#highlights");
                        } else {
                            CT.utils.helperFunctions.openHotelModalWindow(hotelId, $thisTag.data('hash'));
                        }
                    }
                }

                
                // send a trackingGA event.
                var action = '',
                    rank = CT.masterJson.getHotel($(e.target).parents("li.listItem").attr("id")).p,
                    label = CT.cache[CT.settings.currentTab].paramsForGA + "&rank=" + rank,
                    category = "Hotels_TR",
                    _e = $(e.target);
                if ($thisTag.text() === "Map")
                    action = "H_Details_Map";
                else if ($thisTag.data("hash") === '#highlights')
                    action = 'H_Details_Name';
                else if ($thisTag.data("hash") === '#photos')
                    action = 'H_Details_Photos';
                else if ($thisTag.data("hash") === '#location')
                    action = 'H_Details_Location';
                else if ($thisTag.data("hash") === "#taReviews")
                    action = "H_Details_Reviews";
                else if (_e.parents("ul.thumbnails").length > 0) {
                    action = 'H_Details_Thumbnails';
                    label = 'index=' + $.inArray(_e.parents('a.hotelDetails')[0], _e.parents('ul.thumbnails').find('li a.hotelDetails'));
                }

                if (CT.subProd && CT.subProd == "wg") {
                    if ($thisTag.data("hash") === '#roomsRates') {
                        action = 'H_Details_RoomRates';
                    }
                    //  category = "Hotels_GR";
                }
                var hotelDetails = CT.masterJson.getHotel(hotelId);
                var idInUrl;
                if (CT.cache[CT.settings.currentTab].searchParams.all.meta_ref) {
                    idInUrl = CT.cache[CT.settings.currentTab].searchParams.all.meta_ref.split('|')[0]
                }
                CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_resultWidget_linkClick", {
                    "linkName": action,
                    "hotelDetails": hotelDetails.nm + " + " + hotelId,
                    "featuredRank": String(hotelDetails.p),
                    "userRank": $("#ResultContainer_" + CT.settings.currentTab).find("#" + hotelId).index() + 1,
                    "minPricePerNight": String(hotelDetails.priceInfo ? (hotelDetails.priceInfo.rms[0].agvo - hotelDetails.priceInfo.rms[0].d) : "NA"),
                    "discountValueShown": String(hotelDetails.priceInfo ? hotelDetails.priceInfo.rms[0].d : "NA"),
                    "taRating": String(hotelDetails.tar ? hotelDetails.tar : "N/A"),
                    "numTAReviews": String(hotelDetails.tarev ? hotelDetails.tarev : "N/A"),
                    "freeCancelationState": String(hotelDetails.fc ? hotelDetails.fc : "N/A"),
                    "starRating": String(hotelDetails.sr ? hotelDetails.sr : "N/A"),
                    "ctaName": CT.utils.getAbTestCookie("hotels_srp_cta") == 'b' && window.countryCode == 'in' ? "View details" : "Select room",
                    "HighlightedTuple": (idInUrl == hotelDetails.id) ? 'True' : 'False'
                });
                
                if (window.twoCol == true && ($thisTag.data("hash") === '#photos' || $thisTag.data("hash") === '#highlights'))
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR_2col', action, label, '100');
                else
                    CT.utils.helperFunctions.trackGAEventWrapper(category, action, label, '100');
                return false;
            },



            /*
             * remove all the separators - class name separatorMessage
             */
            removeAllSeparator: function(e) {
                var $viewController = $('#ResultContainer_' + CT.settings.currentTab + ' .viewController');

                $viewController.find('.separatorMessage').remove();
            },



            /*
             * adds separator to the .viewcontroller container
             * @param : contentObj - object that is going to populate the messages
             * @param : location - where to add the separator message - top, bottom, before, after
             * @param : tagId - it is the id of the tag (content will be added before or after this tag) without # - this is used only in case of "location" before or after
             */
            addSeparator: function(e, html, location, tagId, container) {
                console.warn("addSeparator");
                var $listContainer = container || this.$el.find('.viewController .listView'),
                    tmp;

                if (location == 'top') {
                    $listContainer.prepend(html);
                } else if (location == 'bottom') {
                    $listContainer.append(html);
                } else if (location == 'before') {
                    $(html).insertBefore($listContainer.find(tagId));
                } else if (location == 'after') {
                    $listContainer.find(tagId).after(html);
                }
            },



            /*
              triggerPTFilter: function(e) {
                  var val = $(e.target).data("pt"),
                    $filtersDiv = $(".filters"),
                    $filterInput = $filtersDiv.find(".propertyType input[value='" + val + "']"),
                    tmp;

                  $filtersDiv.find(".moreFilters").show();
                  if(!($filterInput.is(":checked"))) {
                      $filterInput.attr('checked', 'checked').trigger('click').attr('checked', 'checked');

                      tmp = $.extend(true, {}, CT.messages[CT.app].separatorMsgs.ptypeFilter);
                      tmp.msg = Mustache.to_html(tmp.msg, { ptype: CT.settings.general.ptypeMap[val] });
                      this.addSeparator('', Mustache.to_html($('#SeparatorMessageTpl').html(), tmp), 'top');
                  }
                  return false;
              },
              */



            undoLastFilter: function() {
                window.localities = []
                window.resetSelectedLocalites ? window.resetSelectedLocalites() : console.log("resetSelectedLocalites not defined");
                CT.fire("undolastfilter.init");
            },



            triggerSorter: function(e) {
                var $selectTag = $(e.target),
                    selectVal = $selectTag.val();
                $('nav.sorters').find("li a[data-sort='" + selectVal + "']").trigger('click');
                //HACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACK
                $selectTag.val(selectVal);
                //HACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACKHACK
            },



            triggerOptionChange: function(e) {
                var anchorTag = $(e.target),
                    anchorAlt = anchorTag.attr('alt');
                anchorTag.parents('nav.sorters').next('select.selectSortersClick').val(anchorAlt);
            },



            /*
             * this function returns the class name of li on which pagination or infinite scroll has to be applied
             * returns '.listItem' if filtered elements are zero, which means no filter is applied
             * returns '.filtered' if filter is applied
             * returns 'undefined' if filters are applied and zero elements were found
             */
            getDisplayItemId: function() {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                if ($currentTab.find('li.filtered').length > 0) {
                    return 'li.filtered';
                } else if (CT.filteredCount == undefined || CT.filteredCount > 0) {
                    return 'li.listItem';
                }
                return undefined;
            },



            toggleMapListView: function(e) {
                var $ele = $(e.target),
                    anchorTag;
                $('.mapAutocomplete:last').attr('value', '')
                $('.mapAutocomplete:last').attr('placeholder', 'Enter an address or location')
                if ($ele.hasClass("viewLocation")) {
                    $ele = $("ul.viewSwitcher a:last");
                }
                if (CT.isLocationEnabled) {
                    if ($ele.attr("data-view") == "mapView") {
                        this.$el.find(".propertySection a.presetFilter").show();
                        this.$el.find(".propertySection a.viewLocation").hide();
                    } else {
                        this.$el.find(".propertySection a.presetFilter").show();
                        this.$el.find(".propertySection a.viewLocation").show();
                    }
                    CT.cache.tabsMap[CT.settings.currentTab].view = "map";
                }

                if ($ele.prop('tagName') == 'A') {
                    anchorTag = $ele
                } else {
                    anchorTag = $ele.parent();
                }
                var currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                    allDisplayEle,
                    $mapCanvas = currentTab.find(".mapCanvas"),
                    $staticMap = currentTab.find(".staticMap"),
                    $hotSpot = currentTab.find(".hotSpot"),
                    $elem = currentTab.find("aside.left");

                if ($elem.hasClass("disabled")) {
                    CT.fire("disableLhrFilter", [false]);
                    $elem.removeClass("disabled")
                }
                CT.fire("preRenderMap");
                anchorTag.parents('ul.viewSwitcher').find('li').removeClass('current');
                anchorTag.parent().addClass('current');
                if (anchorTag.data("view") == "listView") {
                    CT.cache[CT.settings.currentTab].viewType = "list";
                    //copy find bar value from smallsearch to mapview specific input tag
                    //this.$el.find('.smallSearch input').val(this.$el.find('.mapViewSearch input').val());
                    $staticMap.show();
                    $hotSpot.show();
                    $mapCanvas.hide();
                    CT.cache.tabsMap[CT.settings.currentTab].view = "list";
                } else {
                    CT.cache.tabsMap[CT.settings.currentTab].view = "map";
                    CT.cache[CT.settings.currentTab].viewType = "map";
                    //copy find bar value from smallsearch to mapview specific input tag
                    // this.$el.find('.mapViewSearch input').val(_.titleize(this.$el.find('.smallSearch input').val()));
                    $staticMap.hide();
                    $hotSpot.hide(); // HOTSPOT Disabled
                    $mapCanvas.show();
                }


                if (e) { // trigger only when the links are clicked and not on onload.
                    CT.fire("changeView", [{
                        view: anchorTag.data("view")
                    }])
                    //                  if(($('.mapAutocomplete:last').val() =="Enter an address or location" || $('.mapAutocomplete:last').val()=="")  && $('#showNearByBox').val()!="Enter an address or location"){
                    //      $('#showNearByBox').val(CT.cache[CT.settings.currentTab].searchedLocation).select()

                    // }                        
                }
                return false;
            },



            showCandyBar: function() {
                if (!CT.cachedElements) {
                    CT.cachedElements = {};
                }
                if (!CT.cachedElements.$candyBar) {
                    CT.cachedElements.$candyBar = $('<div class="candyBar relative"> <div class="filled"></div> </div>');
                }
                if (!CT.cachedElements.$centerCol) {
                    CT.cachedElements.$centerCol = this.$(".viewController");
                }
                CT.cachedElements.$candyBar.children().first().removeClass("completed").addClass("halfway");
                CT.cachedElements.$centerCol.prepend(CT.cachedElements.$candyBar);
                return this
            },



            preRenderMap: function() {
                this.$("#mapViewLink").parent().addClass('current');
                this.$("#listViewLink").parent().removeClass('current');
                $('body').addClass('mapView disablePageScroll');
                $('html').addClass('disablePageScroll');
            },



            getFlightSummaryMarkup: function(onwardIndex, returnIndex, mJson) {
                // ====================== QA SHIT! ======================
                var onwardReturnFl = [],
                    sfsfd = (_.deserialize(location.search)).sfsfd ? true : false;

                var con = mJson.fl.con,
                    cheapestOnwardMapping = parseInt(con.substring(0, con.indexOf('-'))),
                    cheapestOnwardFlt = mJson.fl.mapping.onward[cheapestOnwardMapping]
                cheapestOnwardFare = mJson.fl.fare[cheapestOnwardFlt.f],
                    cheapestOnwardSummary = cheapestOnwardFlt.summary;

                cheapestOnwardSummary.fb = CT.FlightSolution.getFb(cheapestOnwardFare, CT.FlightSolution.areSelectedFlightsACombo());
                cheapestOnwardSummary.fc = CT.FlightSolution.getFc(cheapestOnwardFare, CT.FlightSolution.areSelectedFlightsACombo());
                cheapestOnwardSummary.supp = CT.FlightSolution.getSupp(cheapestOnwardFare, CT.FlightSolution.areSelectedFlightsACombo());
                cheapestOnwardSummary.sfsfd = sfsfd;

                onwardReturnFl.push(cheapestOnwardSummary);

                var crt = mJson.fl.crt,
                    cheapestReturnMapping = parseInt(crt.substring(0, crt.indexOf('-'))),
                    cheapestReturnFlt = mJson.fl.mapping['return'][cheapestReturnMapping]
                cheapestReturnFare = mJson.fl.fare[cheapestReturnFlt.f],
                    cheapestReturnSummary = cheapestReturnFlt.summary;

                cheapestReturnSummary.fb = CT.FlightSolution.getFb(cheapestReturnFare);
                cheapestReturnSummary.fc = CT.FlightSolution.getFc(cheapestReturnFare);
                cheapestReturnSummary.supp = CT.FlightSolution.getSupp(cheapestReturnFare);
                cheapestReturnSummary.sfsfd = sfsfd;

                onwardReturnFl.push(cheapestReturnSummary);
                // ====================== QA SHIT! ======================

                return Mustache.to_html($('#DpAirTpl').html(), {
                    content: onwardReturnFl
                });
            },



            setPageTitle: function(paramsHash) {
                var city, title;
                city = paramsHash.city ? paramsHash.city : paramsHash.from;
                if (paramsHash.chk_in != "" && paramsHash.chk_out != "") {
                    chkIn = moment(paramsHash.chk_in, "DD/MM/YYYY").format("D MMM");
                    chkOut = moment(paramsHash.chk_out, "DD/MM/YYYY").format("D MMM");
                    title = city + "\x20" + chkIn + " \u2013 " + chkOut;
                } else {
                    title = city
                }

                if (window.isWL && window.companyConfig && window.companyConfig.name) {
                    document.title = _.capitalize(companyConfig.name) + " | " + title;
                } else {
                    document.title = "Cleartrip | " + title;
                }
            },



            hotelPricingAb: function() {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                //  $currentTab.find(".sorters").removeClass("col16").addClass("col14");
                //  $currentTab.find(".starSort").closest("li").hide();
                $currentTab.find(".priceDispHeader").show();
                $currentTab.find(".smallSearch").hide();
            },
            renderGetawayPrimaryBar: function(paramsHash) {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);

                if (window.altFilters == "false") {
                    var distSliderEle = $currentTab.find(".distanceSlider .rangeSlider");
                    distSliderHeader = $currentTab.find(".distanceSlider h3").html("<span></span>");
                    distSliderEle.priceslider(CT.settings[CT.app][CT.subProd].hrsSliderOptions)
                    // var distSliderEle = $currentTab.find(".distanceSlider .rangeSlider"),
                    //distSliderHeader = $currentTab.find(".distanceSlider h3").html("<span></span>");
                    //$currentTab.find(".taSort").closest("li").hide();
                    //  $currentTab.find(".starSort").closest("li").hide();

                    $currentTab.find("#hotelsViewSwitcher").hide();
                    //$currentTab.find("#distanceFilter").show();
                    //  distSliderEle.priceslider(CT.settings[CT.app][CT.subProd].hrsSliderOptions)
                } else {
                    var distSliderEle = $currentTab.find(".distanceSliderSec .rangeSlider");
                    //distSliderHeader = $currentTab.find(".distanceSlider h5").html("<span></span>");
                    distSliderEle.priceslider(CT.settings[CT.app][CT.subProd].hrsSliderOptions)
                    $currentTab.find(".hCount .resetLink").html("Clear all filters");

                }

            },

            renderSkeleton: function( /* url params hash */ paramsHash, tabId) {
                //try{
                var tmp, $currentTab, mapClass;
                CT.utils.trackers.eventData = CT.utils.trackers.eventData || {};
                CT.utils.trackers.eventData.searchedString = CT.utils.trackers.eventData.searchedString || "";
                CT.utils.trackers.eventData.userSessionStart = Date.now();
                $('#homeUpsellBanner').hide();
                $('#Home').hide();
                $('#HomeLongForm').hide();
                $(".city_seo_content").hide();
                if (CT.app !== 'dp') {
                    $("#Result").show();
                    this.showCandyBar();
                }

                $('.resultTemplate').hide();
                this.$el.append(hotelsSkeleton)
                
                this.setPageTitle(paramsHash)
                if (window.prDispUnit === "true") {
                    this.hotelPricingAb();
                }
                //$currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                $currentTab = this.$el;
                if (CT.subProd == "wg") {
                    this.renderGetawayPrimaryBar(paramsHash);
                } else {
                    //if(!(CT.masterJSON && CT.masterJSON.get().ht.pils && CT.masterJSON.get().ht.pils.length > 1))
                    //$currentTab.find(".distanceSort").closest("li").hide();
                    if(window.showMapView === "true"){
                        $currentTab.find(".viewSwitchers").show();
                    }
                    $currentTab.find(".mapHotel").show()
                }

                //this is necessary here as sorters.init is using this
                this.updateTripSummary(paramsHash, CT.app == 'dp' ? true : false);

                // initialize the filters
                CT.fire('filters.init', [this, paramsHash]);



                if (CT.subProd == "wg") {
                    $("#GlobalNav").find(".fillCityName").html("Gateways from " + CT.cache[CT.settings.currentTab].searchParams.processed.from);
                    var isIpad = navigator.userAgent.match(/iPad/i) != null;
                    var dontTriggerSticky = true
                    if (window.isMobileUA == true || isIpad == true || $.browser.msie == true) {
                        dontTriggerSticky = false;
                    }
                    if (dontTriggerSticky == true) {
                    // here
                        $($currentTab.find(".filters")).theiaStickySidebar({
                            additionalMarginTop: 81
                        });
                        $($currentTab).find(".filters").css({
                            "z-index": "10"
                        });
                    }

                } else {
                    $currentTab.find(".fillCityName").html(CT.cache[CT.settings.currentTab].searchParams.processed.city);
                    if (window.chunkyFiltersEnabled)
                    // here
                        $($currentTab.find(".filters")).theiaStickySidebar({
                            additionalMarginTop: 0
                        });
                    // $($currentTab).find(".filters").css({
                    //     "z-index": "10"
                    // });
                }

                if (_.has(CT.settings.general.staticMapToCityId, paramsHash.dest_code) === true) {
                    mapClass = CT.settings.general.staticMapToCityId[paramsHash.dest_code];
                } else {
                    mapClass = CT.settings.general.staticMapToCityId["generic"];
                }
                $currentTab.find(".cityMap").addClass(mapClass);

                if ((tmp = this.$('input[data-autocomplete-ui]')).length > 0)
                    tmp.unbind().autocomplete();

                $('.viewController').css('min-height', CT.utils.setElementSize(['#PrimaryIconNavigation', 'footer', '.modify', '.primaryBar', '.secondaryBar'], 'height'));

                if (paramsHash.view === "map") // enable map view if mentioned in the url.
                    this.preRenderMap()
                //} catch(e){ console.log('in prerender') }

                //set loading bar width
                this.setLoadingBar(CT.messages.hotel.LookingHotels, '10%', 'show');

                CT.utils.modifySearch.openLabel(CT.cache[CT.settings.currentTab].searchParams.processed);
                CT.utils.modifySearch.close();

                return this;
            },



            runAjax: function(url, data) {
                
                //var stData = _.serialize(data);
                var xhr = $.ajax({
                    url: url,
                    type: 'GET',
                    //serialization is necessary for converting child age into normal param instead of array
                    data: _.serialize(data)
                });

                //xhr.onreadystatechange = function() { console.log("Listen to Ajax", xhr.readyState); };

                return xhr;
            },



            initSeparator: function( /* Array */ hotelsList, startIndex, endIndex) {
                
                var separators = CT.cache[CT.settings.currentTab].separators,
                    html;
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                _.forEach(separators, function(separatorIndex, name) {
                    switch (name) {
                        case 'unavailIndex':
                            if (CT.subProd && CT.subProd == "wg" && $currentTab.find(".destinations input:checked").length > 0 && window.curationTool == "false") {
                                $currentTab.find(".hotelCard.disabled").removeClass("listItem").hide();
                                if ($currentTab.find(".getawaysNoHotels").length > 0) {
                                    $currentTab.find("#loadMore").hide();
                                }
                                var destCheckedList = $currentTab.find(".destinations input:checked");
                                var shwAllCardObj = [],
                                    tmp = {};
                                var fieldToDel = ['wg', 'wg_rs', 'destinations', 'destinationsTheme', 'hotelsTheme', 'from'];


                                var searchParams = _.deserialize(window.location.search.split("?")[1]);
                                for (var k in searchParams) {
                                    if (fieldToDel.indexOf(k) == -1) {
                                        tmp[k] = searchParams[k]
                                    }
                                }

                                for (var i = 0; i < destCheckedList.length; i++) {
                                    var obj = {};
                                    var tmpDestObj = _.filter(CT.masterJson.get().wd.d, {
                                        "i": Int($(destCheckedList[i]).val())
                                    })
                                    var tmpHotelObj = _.filter(hotelsList, function(obj) {
                                        return (obj.c == Int($(destCheckedList[i]).val()) && obj.totfmt == undefined);
                                    });
                                    if (tmpHotelObj.length > 0) {
                                        var drTime = Math.ceil(tmpHotelObj[0].tt / (60));
                                        tmp.city = tmpDestObj[0].n;
                                        tmp.state = "";
                                        obj.city = tmpDestObj[0].n;
                                        obj.id = tmpHotelObj[0].id;
                                        obj.shortID = CT.utils.shortenID(tmpHotelObj[0].id);
                                        obj.im = tmpHotelObj[0].replacedimg;
                                        obj.urlParams = _.serialize(tmp);
                                        obj.driveTime = drTime > 0 ? drTime : false;
                                        shwAllCardObj.push(obj);
                                    }

                                }
                                html = CT.to_html('ShwAllHotelsTpl', {
                                    shwAllCardObj: shwAllCardObj
                                });
                            } else if (hotelsList.length > 0 && (separatorIndex >= startIndex && separatorIndex < endIndex)) {
                                html = CT.to_html('SeparatorMessageTpl', {
                                    msg: CT.messages[CT.app].separatorMsgs.unavailableSeparator,
                                    subMsg: CT.cache[CT.settings.currentTab].fewResultsMsg
                                });
                            }
                            if (separatorIndex >= startIndex && separatorIndex < endIndex) {
                                this.addSeparator(null, html, 'before', '#' + hotelsList[separatorIndex - startIndex].id);
                            } else if (CT.subProd && CT.subProd == "wg" && html != undefined && html.replace(/\s/g, "") != "") {
                                if ($currentTab.find(".getawaysNoHotels").length > 0) {
                                    $currentTab.find(".getawaysNoHotels").remove();
                                }
                                this.$el.find(".listView").append(html);
                            }

                            break;

                        case 'radialIndex':
                            if (CT.isLocationEnabled && !CT.cache[CT.settings.currentTab].searchParams.all.SearchTag ) {
                                var areaForSepMsg = CT.cache[CT.settings.currentTab].searchParams.all.area && CT.cache[CT.settings.currentTab].searchParams.all.area[0] != "" ? CT.cache[CT.settings.currentTab].searchParams.all.area[0] : (CT.cache[CT.settings.currentTab].googleSortedArea ? CT.cache[CT.settings.currentTab].googleSortedArea[0] : "");
                                var hotelsCountForSepMsg = CT.cache[CT.settings.currentTab].filteredHt["exact"].length;
                                if (CT.cache[CT.settings.currentTab].searchParams.all.poi && CT.cache[CT.settings.currentTab].searchParams.all.poi[0] != "" || CT.cache[CT.settings.currentTab].googleSortedPoi)
                                    break;
                                else {
                                    if (hotelsList.length > 0 && (separatorIndex >= startIndex && separatorIndex < endIndex)) {
                                        html = CT.to_html('SeparatorMessageTpl', {
                                            msg: hotelsCountForSepMsg > 0 ? "Uh-oh these are all the hotels in " + areaForSepMsg : "There are no hotels in " + areaForSepMsg,
                                            subMsg: "However, we found other hotels in nearby areas"
                                        });
                                        this.addSeparator(null, html, 'before', '#' + hotelsList[separatorIndex - startIndex].id);
                                    }
                                }
                            } else {
                                if (hotelsList.length > 0 && (separatorIndex >= startIndex && separatorIndex < endIndex)) {
                                    html = CT.to_html('SeparatorMessageTpl', {
                                        msg: CT.messages[CT.app].separatorMsgs.radialSeparator
                                    });
                                    this.addSeparator(null, html, 'before', '#' + hotelsList[separatorIndex - startIndex].id);
                                }
                            }
                            break;
                    }
                }, this);
            },

            getCollection: function($elem, startIndex, endIndex) {
                var cityname = CT.cache[CT.settings.currentTab].searchParams.all.city;
                var countryname = CT.cache[CT.settings.currentTab].searchParams.all.country;
                CT.cache[CT.settings.currentTab].srpCollection = {};
                var self = this;
                $.ajax({
                    url: '/smallworld/get_collections?city=' + cityname.toLowerCase() + '&countryname=' + countryname.toLowerCase(),
                    method: 'GET',
                    success: function(results) {
                        if (typeof results === "string" && JSON.parse(results).length > 0) {
                            CT.cache[CT.settings.currentTab].srpCollection = {
                                'results': JSON.parse(results),
                                'elemCount': 10,
                                'collectionCount': 0
                            };
                        }
                        self.showCollectionInHotelsList($elem, startIndex, endIndex)
                    },
                    error: function() {

                    }
                });
            },

            findPosOflastCollectionAdded: function($elem) {

            },

            showCollectionInHotelsList: function($elem, startIndex, endIndex) {

                var filterHtCount = (CT.cache[CT.settings.currentTab].filteredHt.exact.length || 0) + (CT.cache[CT.settings.currentTab].filteredHt.others.length || 0);
                if (CT.cache[CT.settings.currentTab].hotelsTotalCount == filterHtCount && !$('body').hasClass('mapView')) {

                    //if(CT.cache[CT.settings.currentTab].filteredHt.others.length === 0) {
                    var collectionLimit = 10;
                    var collectionResults = CT.cache[CT.settings.currentTab].srpCollection.results;
                    var firstCollection = CT.cache[CT.settings.currentTab].srpCollection.elemCount;
                    var loopCount = CT.cache[CT.settings.currentTab].srpCollection.collectionCount;
                    var $liElems = $elem.find(".listItem");

                    for (var i = firstCollection; i < endIndex; i += collectionLimit) {
                        if (collectionResults[loopCount]) {
                            var html = CT.to_html('HotelCollectionTpl', collectionResults[loopCount]);
                            loopCount++;
                            if (loopCount <= collectionResults.length) {
                                $($liElems[(i - 1)]).after(html);
                            }
                            CT.cache[CT.settings.currentTab].srpCollection.collectionCount = loopCount;
                            CT.cache[CT.settings.currentTab].srpCollection.elemCount = (i + loopCount + collectionLimit);
                        }
                    }
                }
            },
            showDodInHotelsList: function() {

                var dodHotelsList = CT.cache[CT.settings.currentTab].dodHotelList,
                    dealsObjArr = [];
                var $liElems = this.$el.find(".listItem");
                if (dodHotelsList.length > 0) {
                    dodHotelsList = _.uniq(dodHotelsList)
                    if (dodHotelsList.length >= 3) {
                        dodHotelsList = _.first(dodHotelsList, 3);
                        for (var i = 0; i < dodHotelsList.length; i++) {
                            var obj = {},
                                hotelObj = CT.masterJson.getHotel(dodHotelsList[i]);
                            for (var k = 0; k < hotelObj.priceInfo.rms.length; k++) {
                                var rms = hotelObj.priceInfo.rms[k];
                                if (rms.dod && rms.dod == true) {
                                    var perTmp = (((parseInt(rms.d)) / (parseInt(rms.tot) + parseInt(rms.d))) * 100).toFixed();
                                    obj['tot'] = hotelObj.totfmt;
                                    obj['sav'] = hotelObj.sav;
                                    obj['percent'] = perTmp;
                                    obj['discount'] = rms.d;
                                    obj['hotelName'] = hotelObj.nm;
                                    obj['sr'] = hotelObj.sr;
                                    obj['replacedimg'] = hotelObj.replacedimg;
                                    obj['id'] = hotelObj.id;
                                    obj['shortID'] = hotelObj.shortID;
                                    obj['hotelBaseLink'] = hotelObj.hotelBaseLink;
                                    obj['modalV2Url'] = hotelObj.modalV2Url;
                                }
                            }
                            dealsObjArr.push(obj);
                        }
                        var html = CT.to_html('DealOfTheDayTpl', {
                            'dealsObj': dealsObjArr
                        });
                        $($liElems[2]).after(html);
                    }
                }
            },
            //      showUpsellInHotelsList : function($elem, startIndex, endIndex) {
            //          if(CT.settings.showUpsellBanner){
            //              var filterHtCount = (CT.cache[CT.settings.currentTab].filteredHt.exact.length || 0) + (CT.cache[CT.settings.currentTab].filteredHt.others.length || 0);
            //              if(CT.cache[CT.settings.currentTab].hotelsTotalCount == filterHtCount && !$('body').hasClass('mapView')){
            //                  
            //                  //if(CT.cache[CT.settings.currentTab].filteredHt.others.length === 0) {
            //                  var collectionLimit = 10;
            //                  var collectionResults = CT.cache[CT.settings.currentTab].srpUpsell.results;
            //                  var firstCollection = CT.cache[CT.settings.currentTab].srpUpsell.elemCount;
            //                  var loopCount = CT.cache[CT.settings.currentTab].srpUpsell.collectionCount;
            //                  var $liElems = $elem.find(".listItem");
            //              
            //                  for(var i= firstCollection; i< endIndex; i += collectionLimit) {
            //                      if(collectionResults[loopCount]) {
            //                          var html = CT.to_html('upsellBanner', {"upsellBanner":true,'product':"Hotels","upselltext":"Book last minute hotels on the go with the Cleartrip app"});
            //                          loopCount++;
            //                          if(loopCount <= collectionResults.length) {
            //                              if(!$($liElems[(i)]).hasClass('flightHotelSRPUpsells'))
            //                                  $($liElems[(i-1)]).after(html);
            //                          }
            //                          CT.cache[CT.settings.currentTab].srpUpsell.collectionCount = loopCount;
            //                          CT.cache[CT.settings.currentTab].srpUpsell.elemCount = (i + loopCount + collectionLimit);
            //                      }
            //                  }
            //              }
            //          }
            //      },

            showTagsInHotelList: function($ele, idx) {
                var appendAfterIdx = idx;
                var shuoldTagPromoDisplay = false,
                    $tagLoadMoreCont = $("#tagLoadMoreCont");

                shuoldTagPromoDisplay = (window.showTags && CT.tagsData && !CT.tagsInteracted) && ($tagLoadMoreCont.length == 0);
                if (shuoldTagPromoDisplay) {
                    var liElems = $ele.find(".listItem");
                    if (liElems && liElems.length >= appendAfterIdx) {
                        var data = {
                            tagsData: CT.tagsData
                        }
                        var partialsTobesent = {
                            tagsHtml: CT.to_html("tagListPromoTpl", data)
                        }
                        var html = CT.to_html('tagsPromoTpl', {}, partialsTobesent);
                        $(liElems[appendAfterIdx - 1]).after(html);
                        CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_TagsHint_Viewed", {
                            'Source': "Loader"
                        });
                    }
                }
            },

            scrollTimerId: undefined,

            update: CT.app !== 'dp' ? function( /*Event */ e, /* Hash */ data, /* Hash */ options) {
                
                //INIT
                // console.log("In update");
                // 'data' is the filtered and sorted hotels array
                // Reset all the exact match hotel partials
                
                _.forEach(data.exact, function (hotel, index) {
                    hotel.showPartialMatch = false;
                    hotel.showOtherHotels = false;
                });
                
                if (CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) {
                    var firstExactHotelTags = -1, lastExactHotelTags = 0, firstpartialTagindex = 0, firstNoMatchIndex = 0, index = 0
                        , numOfSelectedTags = CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter.split("tag").length - 1;
                    if (data.exact.length && data.exact[0].selectedTags) {
                        firstExactHotelTags = data.exact[0].selectedTags.length
                        var lastHotelSelectedTags = data.exact[data.exact.length - 1].selectedTags;
                        if (lastHotelSelectedTags) {
                            lastExactHotelTags = data.exact[data.exact.length - 1].selectedTags.length;
                        }
                        //console.log("firstpartialTagindex", firstpartialTagindex);
                        while (data.exact[firstpartialTagindex] && data.exact[firstpartialTagindex].selectedTags && data.exact[firstpartialTagindex].selectedTags.length == numOfSelectedTags) {
                            firstpartialTagindex++;
                        }
                        firstNoMatchIndex = firstpartialTagindex;
                        var lastIndex = data.exact.length - 1;
                        if (firstNoMatchIndex > lastIndex) {
                            // meaning all hotels are 100% matching!
                            // no partial or others!
                            firstNoMatchIndex = -1;
                            firstpartialTagindex = -1;
                        } else {
                            if (data.exact[firstpartialTagindex].selectedTags) {
                                while (data.exact[firstNoMatchIndex] && data.exact[firstNoMatchIndex].selectedTags && data.exact[firstNoMatchIndex].selectedTags.length) {
                                    firstNoMatchIndex++;
                                }
                                if (firstpartialTagindex < firstNoMatchIndex) {
                                    data.exact[firstpartialTagindex].showPartialMatch = true;
                                }
                            }
                            if (data.exact[firstNoMatchIndex]) {
                                data.exact[firstNoMatchIndex].showOtherHotels = true;
                            }
                        }
                    }
                    // console.log("firstpartialTagindex", firstpartialTagindex);
                    window.hasHundredPercentMatch = firstExactHotelTags == numOfSelectedTags || lastExactHotelTags == numOfSelectedTags;
                }
                //Get all the availabe filters list in a local variables 
                var filterToMatch = CT.utils.helperFunctions.getAllAvailFilterLists();
                //Copy object in a local variable 
                var currentActiveTabObjects = $.extend(true, {}, CT.cache.tabsMap[CT.settings.currentTab]);

                var filteredValues = {};

                filterToMatch.filter(function(obj) {
                    if (currentActiveTabObjects.hasOwnProperty(obj)) {
                        filteredValues[obj] = currentActiveTabObjects[obj];
                    }
                });
                
                //construct the url params
                var newUrlParams = _.serialize(filteredValues);
                //store url parms inside a util variables 

                CT.cache.tabsMap[CT.settings.currentTab].appliedFiltersParmas = newUrlParams;
                CT.utils.appliedFiltersParmas = newUrlParams;


                options = options || {}
                this.$el = this.$el || $(e.target)
                var resultView = this
                var /* master json */ mJson = CT.masterJson.get()
                firstHotel = firstHotel || CT.masterJson.getHotel(firstHotelId);
                var /* Number */ startIdx = typeof options.idx !== 'undefined' ? options.idx : (CT.cache[CT.settings.currentTab].startIndex || 0)
                var /* Array */ areaList = data.exact
                var /* Array */ radialList = data.radial
                if (data.radial == "") {
                    radialList = []
                }
                if (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == true && $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked') && CT.isLocationEnabled == true) {
                    var /* Array */ unavailList = []
                } else {
                    var /* Array */ unavailList = data.unAvail
                }
                if (CT.cache[CT.settings.currentTab].arealDistancegreater == true) {
                    var /* Array */ unavailList = data.unAvail
                }
                var /* Array */ toRenderData = []
                var /* Object */ tmplData = _.clone(mJson)
                var /* String */ html = ''
                var /* Number */ pageEleCount = (CT.cache[CT.settings.currentTab].viewType === "map") ? CT.settings[CT.app].mapElePerPage : CT.settings[CT.app].infScrollCount; //pageEleCount is the number of listItems shown for the initial render of the list.
                var /* Array */ hotelsList
                var tmp
                var hotelsRenderData;
                var tabCache = CT.cache[CT.settings.currentTab];
                var diff = CT.utils.diffDates(CT.utils.getTodayDate(), CT.cache[CT.settings.currentTab].searchParams.all.chk_in)
                
                var locationUrldata = _.deserialize(window.location.search)
                if (locationUrldata.poi != "" &&
                    CT.cache[CT.settings.currentTab].latitude == "" &&
                    CT.cache[CT.settings.currentTab].longitude == "" &&
                    CT.isLocationEnabled == true) {
                    $('#ResultContainer_' + CT.settings.currentTab).find('nav.sorters a.location').hide()
                    $('#ResultContainer_' + CT.settings.currentTab).find('nav.sorters a.location').removeClass('sortAsc')
                    $('#ResultContainer_' + CT.settings.currentTab).find('nav.sorters a.location').removeClass('sortDes')
                    $('#ResultContainer_' + CT.settings.currentTab).find('nav.sorters a.featured').addClass('current')
                }
                //store radial and unavailable hotel index and create a master list - hotelsRenderData
                tmp = CT.cache[CT.settings.currentTab]
                tmp = tmp.separators = {};
                if (CT.isLocationEnabled == true && areaList.length > 0)
                    CT.cache[CT.settings.currentTab].exactAreaHotelsCount = areaList.length;
                if (radialList.length > 0)
                    tmp.radialIndex = areaList.length;

                hotelsRenderData = areaList.concat(radialList);
                CT.cache[CT.settings.currentTab].filteredCount = hotelsRenderData.length;
                if (unavailList.length > 0)
                    tmp.unavailIndex = hotelsRenderData.length;
                hotelsRenderData = hotelsRenderData.concat(unavailList)
                //to display no. of rooms and nights in quick look table header
                tmp = tabCache.searchParams.processed;
                tmplData.num_rooms = tmp.num_rooms;
                tmplData.num_nights = tmp.num_nights;

                // Updating tmplate data
                tmplData.hasAm = options.hasAmenities
                hotelsRenderData = _.filter(hotelsRenderData, function(item) {
                    if (item != "") {
                        return true
                    }
                });
                var metaRef = (new URL(document.location)).searchParams.get("meta_ref") || null;
                var shortType = (new URL(document.location)).searchParams.get("sort") || null;
                
                var filterOptions = CT.settings.hotel.srpFilterMap;
                window.matchedElFromFilter = []
                for (var iDx = 0 ; iDx < filterOptions.length; iDx++ ){
                    var matchedValue = (new URL(document.location)).searchParams.get(filterOptions[iDx]);
                    if ( matchedValue !== null 
                            && matchedValue !== "" 
                            && matchedValue !== 'featured'  ) {
                        window.matchedElFromFilter.push(matchedValue)
                    }   
                }
                
                if( (metaRef && window.matchedElFromFilter.length === 0)){
                    window.metaData = [];
                    //If user is coming form meta 
                    for( var iDx = 0; iDx < hotelsRenderData.length; iDx++){ 
                        if ( hotelsRenderData[iDx].id === metaRef.split('|')[0] ) {
                            window.metaData = Object.assign({}, hotelsRenderData[iDx]);
                            hotelsRenderData.splice(iDx, 1); 
                            //break;
                        }
                    }
                } else {
                    hotelsRenderData.concat(window.metaData);
                }
                
                Mustache.clearCache();
                //console.log('HOTEL RENDERDAT', hotelsRenderData)
                if (hotelsRenderData.length > 0) {
                    var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                        hotelList = $currentTab.find('.listViewResults');
                    toRenderData = hotelsRenderData.slice(startIdx, pageEleCount)

                    
                    // tmplData.ht = toRenderData.concat(window.metaData);
                    tmplData.ht = toRenderData;
                    if (window.twoCol != true) {
                        tmplData.ht[0].arrowForFirst = '<i class="upsellSprite lPointer"></i>'
                    }
                    tmplData.checkAvail = CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch;

                    window.topHotelIdsArr = [];
                    if (tmplData.ht && tmplData.ht.length > 0) {
                        for (var i = 0; i < 4; i++) {
                            if (tmplData.ht[i] && tmplData.ht[i].sav == "") {
                                tmplData.ht[i].showsaveText = false
                            }
                            if (tmplData.ht[i] && tmplData.ht[i].sav != "") {
                                tmplData.ht[i].showsaveText = true
                            }
                            if (tmplData.ht[i] && tmplData.ht[i].id && tmplData.ht[i].id.length > 0) window.topHotelIdsArr.push(tmplData.ht[i].id);
                        }
                    }
                    tmplData = CT.masterJson.removeHotel(firstHotelId, tmplData);
                    
                    if( (metaRef && matchedElFromFilter.length === 0)){
                        window.metaData.isFromMeta = true;
                        window.metaData.metaSource = metaRef.split('|')[1].charAt(0).toUpperCase() + metaRef.split('|')[1].slice(1);
                        //window.metaData.modalV2Url = window.metaData.modalV2Url +"&meta_ref="+ window.metaData.id +"|"+ window.metaData.metaSource;
                        tmplData.ht.unshift(window.metaData);
                    } else {
                        // window.metaData.isFromMeta = false;
                        // window.metaData.metaSource = false;
                        // tmplData.ht.push(window.metaData);
                    }
                    //console.log('tmplData in side update',tmplData);
                    if (CT.subProd != "wg") {
                        html = CT.to_html(window.twoCol ? window.wgTplForHt ? 'HotelCardTpl' : window.mainTemplate : 'HotelListTpl', tmplData, {
                            HotelPricePartialTpl: CT.to_html('HotelPricePartialTpl')
                        });
                    } else {
                        html = CT.to_html('HotelCardTpl', tmplData, {
                            HotelPricePartialTpl: CT.to_html('HotelPricePartialTpl')
                        });
                    }
                    
                    //this.$el.find('.hotelsList ul.listView').html('').append(html);
                    // update per room, per night toltip.
                    // read abtest cookie.
                    if (window.taxAbTest === 'a') {
                        var $li = $($($('.priceDispHeader')[1]).find('li')[1]);
                        if ($li.attr('original-title') === 'Per-room-per-night rate includes taxes<br></li>and service fees.') {
                            $li.attr('original-title', 'Per-room-per-night rate excludes taxes<br></li>and service fees.');
                            if (window.taxAbTest_A == 'a') {
                                $($('.priceDispHeader').find('.totPriceDispHeader').get(1)).parent().attr('original-title', 'The complete price of your trip<br>excluding taxes and service fees.');
                            }
                        }
                    }
                    // Three templates to changed:
                    // HotelTwoColListTpl Done
                    // HotelCardTpl
                    // HotelListTpl
                    // The declaration needs to stay outside for reset
                    var hundredPrecentMatchPartition = '';
                    if (CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) {
                        if (window.hasHundredPercentMatch) {
                            hundredPrecentMatchPartition = '<div class="matching-tag-container flex flex-start"><img class="tag-img" src="' + window.staticBaseDomain + '/images/hotel-srp/100.svg" alt="100% match"><div class="text-wrapper"><p class="title">100% match</p><p class="caption">Hotels matching all your preferences</p></div></div>'
                        }
                        hundredPrecentMatchPartition = $.parseHTML(hundredPrecentMatchPartition);
                    }
                    window.hasHundredPercentMatch = false;
                    this.$el.find('.hotelsList ul.listView').html(hundredPrecentMatchPartition).append(html);
                    var isLoggedIn = CT.utils.readCTAuthCookie();
                    // show lol banner only in b2c
                    if (window.showLolBanner && !(window.product === "B2B" || window.companyConfig) && countryCode === "in") {
                        if (mJson.cnm === "Goa") {
                            var lolBanner = CT.to_html("LolBannerTpl", {});
                            $(lolBanner).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice(4,5));
                        }
                        $(".image-content").css("background-image","url('" + window.staticBaseDomain + "/images/lol-banner/shopping.svg')");
                    }
                    $('.cfw-in-deals-wrapper').remove()
                    if (!(window.product === "B2B" || window.companyConfig) && countryCode === "in") {
                        if (!isLoggedIn && (!window.product && window.product != "B2B") && !window.isWL) {
                            if ((hotelsRenderData.length) && CT.cache[CT.settings.currentTab].viewType !== "map") {
                                var unlockCFWLoggedOut = CT.to_html("CFWwrapperLoggedOut", {});
                                if (window.showTags) {
                                    $(unlockCFWLoggedOut).insertBefore(this.$el.find('.tagContainer'));
                                } else {
                                    $(unlockCFWLoggedOut).insertBefore(this.$el.find('.resultsCont'));
                                }
                            }
                        } else if (isLoggedIn && (!window.product && window.product != "B2B") && !window.isWL) {
                            if ((hotelsRenderData.length) && CT.cache[CT.settings.currentTab].viewType !== "map") {
                                var self = this;
                                this.getWorkPlusUserState(function () { 
                                    if (workPlusUserDetails.status !== 'TRIAL' &&
                                        workPlusUserDetails.status !== 'TRIAL_NCB' &&
                                        workPlusUserDetails.status !== 'VERIFIED') {   
                                            $('.cfw-in-deals-wrapper').remove()                                      
                                            var unlockCFWLoggedIn = CT.to_html("CFWwrapperLoggedIn", {});
                                            if (window.showTags) {
                                                $(unlockCFWLoggedIn).insertBefore(self.$el.find('.tagContainer'));
                                            } else {
                                                $(unlockCFWLoggedIn).insertBefore(self.$el.find('.resultsCont'));
                                            }
                                            if (workPlusUserDetails.gst_number) {
                                                $('input[name ="srpBannerGstin"]')[0].value = workPlusUserDetails.gst_number
                                                workPlusUserDetails.status = 'SIGNED_IN'
                                            } else {
                                                workPlusUserDetails.status = 'SIGNED_IN_NON_GST'                                        
                                            }
                                        }
                                });
                                
                            }
                        }
                    }
                    var that = this

                    $('.resultContainer').on('click', '#cfwKnowMore', function () {
                        CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_CFW_Action', {
                            cta_name: 'Know more'
                        });
                    })
                    
                    $('.resultContainer').on('click', '#cfwBannerClose', function () {
                        $('.cfw-in-deals-wrapper').hide()
                    })
                    $('.resultContainer').on('submit', '#cfwGstInputForm', function (event) {
                        event.preventDefault();
                        var formInput = $(this).find('#cfwGstInputBox')[0]
                        var cfwGstIn = formInput.value
                        var gstRegex = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/
                        if (!gstRegex.test(cfwGstIn)) {
                            formInput.classList.add('ugly')
                            return
                        }
                        CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_CFW_Action', {
                            cta_name: 'Get Started'
                        });
                        that.postGstForWPUser(workPlusUserDetails.status, cfwGstIn)
                    })
                    $('.resultContainer').on('keydown', '#cfwGstInputBox', function () {
                        $('#cfwGstInputBox')[0].classList.remove('ugly')
                    })
                    if ( !isLoggedIn && (!window.product && window.product != "B2B") && !window.isWL && window.isModEnabledFormUI ) { 
                        if( mJson.isModEnabled && ( (hotelsRenderData.length - unavailList.length) > 10 )  && CT.cache[CT.settings.currentTab].viewType !== "map" ) {
                            var unlockSpecialDeals = CT.to_html("UnlockSpecialDeals", {});
                            var countLi = this.$el.find('.hotelsList ul.listView>li.listItem')
                            if(window.showTags){
                                if( firstpartialTagindex && firstpartialTagindex > 2 ){
                                    $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 1, 2));    
                                } else if(firstpartialTagindex && firstpartialTagindex == 2){
                                    $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 0, 1));    
                                } else if( firstpartialTagindex <= 1 && firstNoMatchIndex > 2 ){
                                    $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 1, 2));    
                                } else if( firstpartialTagindex <= 1 && firstNoMatchIndex == 2 ){
                                    $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 0, 1));    
                                } else if( firstpartialTagindex <= 1 && firstNoMatchIndex <= 1 &&  hotelsRenderData.length > firstNoMatchIndex + 1 ){
                                    $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 1, 2));    
                                } else {
                                    if((hotelsRenderData.length - unavailList.length) > 3){
                                        $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 1, 2));    
                                    } else if((hotelsRenderData.length - unavailList.length) <= 2) {
                                        $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 0, 1));    
                                    } 
                                }
                            } else {
                                if((hotelsRenderData.length - unavailList.length) > 3){
                                    $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 1, 2));    
                                } else if((hotelsRenderData.length - unavailList.length) <= 2) {
                                    $(  unlockSpecialDeals  ).insertAfter( this.$el.find('.hotelsList ul.listView li.listItem').slice( 0, 1));    
                                }
                            }

                            CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotels_SRP_SignIn_Strip_Viewed', {
                                'isPageMOD':'Hotle MOD SignIn Strip Viewed On List Page',
                                'pageURL':window.location.pathname
                            });
                        }
                    }

                    if (firstHotel && utmSource) {
                        firstHotel.utmSource = utmSource.toLowerCase();
                        CT.utils.cookies.create("utm_source", utmSource, window.affiliateutmExpiryDays || 1);
                        CT.utils.cookies.create("metaPah", utmSource);
                        if (CT.utils.helperFunctions.paidChannelTracker) {
                            CT.utils.helperFunctions.paidChannelTracker(_.deserialize(window.location.search.substring(1)));
                        }
                        var metaHotelHtml = CT.to_html("MetaHotelListTpl", {'ht': firstHotel});
                        var firstHotelListElement = this.$el.find('li.listItem.listUnit').first();
                        $(metaHotelHtml).insertBefore(firstHotelListElement);
                    }
                    var wallet = CT.masterJson.get().wallet;
                    if (wallet.enableCreativePricing) {
                        CT.utils.wallet.createWalletMarkup(wallet, true);
                    }

                    var hotelsRenderedLength = hotelsRenderData ? hotelsRenderData.length : 0
                    var tmplDataToPoi = {}
                    // console.log("place 1");
                    // Commented out to disable 'see other hotels' CTA and Separator
                    // if (hotelsRenderedLength > 0 && hotelsRenderedLength == this.$el.find('.hotelsList ul.listView').children().length && (CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" && CT.cache[CT.settings.currentTab].arealDistancegreater != true && $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked'))) {
                    //     tmplDataToPoi.showingDistance = CT.cache[CT.settings.currentTab].showFewHotelsDistance
                    //     tmplDataToPoi.showingLocationpoi = CT.cache[CT.settings.currentTab].pointOfIntrestValue
                    //     var appendTemplate = CT.to_html('HotelLocationSorterPoiTpl', tmplDataToPoi)
                    //     this.$el.find('.hotelsList ul.listView').append(appendTemplate)
                    // }


                    
                    this.$el.find(".dotDotDot").remove();
                    this.$el.find('li.listItem .royalSlider').royalSlider(CT.settings[CT.app].royalSliderAttrObj).css('visibility', 'visible');

                    if (CT.subProd != 'wg' && window.twoCol == true) {
                        CT.utils.helperFunctions.createSliders();
                    }
                    if (CT.cache[CT.settings.currentTab].viewType === "map") {
                        hotelList.find('.pagination').empty();
                        CT.fire('mapchangeplot', [hotelsRenderData]);
                    }
                    this.initSeparator(toRenderData, startIdx, pageEleCount);
                    //startIdx = CT.cache[CT.settings.currentTab].startIndex = pageEleCount;
                    this.updateCallback();
                    //console.log($(".photoMask").find("img").length);
                    //this.$el.find(".filters").stick_in_parent();
                    //this.$el.find(".filters").stick_in_parent({parent:this.$el.find(".filters"),offset_top:55});
                    if (false) {
                        //ASC-394 - Tags update on Desktop --- Add seperator html when tags selected
                        var totalHotelsWithTags = $(".listItem:not(.NA) .metaTags").find(".metaTags__item:visible:first");
                        var lastLiWithTags = $(".listItem:not(.NA) .metaTags .metaTags__item:last").parents(".listItem");
                        if ($(lastLiWithTags).next("li.listItem").length > 0) {
                            var tagsMessageHtml = CT.to_html('HotelTagsSeperatorMessageTpl', {
                                cityName: window.masterJSON.cnm,
                                onlyOneHotelWithTag: totalHotelsWithTags.length <= 1
                            });
                            $(lastLiWithTags).after(tagsMessageHtml);
                        }
                    }
                }

                //update messages display in srp page
                this.updateMessages();

                /*
                        if(radialList.length > 0) {
                            toRenderData = radialList.slice(startIdx, pageEleCount)
                            tmplData.ht = toRenderData
                            html = Mustache.to_html($('#HotelListTpl').html(), tmplData);
                            this.$el.find('.hotelsList ul.listView').append(CT.settings.listSeparator).append(html)
                        }
                        */
                CT.fire('initChkavail', []); //checkavail
                this.afterRenderCallback();
                if (CT.subProd && CT.subProd == "wg" && this.$el.find(".destinations input:checked").length > 0) {
                    this.updateShowCount(hotelsRenderData.length - unavailList.length)
                } else {
                    if (CT.isLocationEnabled == true) {
                        if (window.location.search.split("&")[3].indexOf("area") > -1 && window.location.search.split("&")[4].indexOf("poi") > -1 && localStorage.getItem("recentFilters") == null)
                            this.updateShowCount(CT.cache[CT.settings.currentTab].hotelsTotalCount);
                        else
                            this.updateShowCount(hotelsRenderData.length);
                    } else
                        this.updateShowCount(hotelsRenderData.length)
                }
                if ($('nav.showFewFilter input').attr('checked')) {
                    this.updateShowCount(areaList.length, CT.cache[CT.settings.currentTab].hotelsTotalCount)
                }
                if (CT.cache[CT.settings.currentTab].showAllPoiClicked == true || CT.cache[CT.settings.currentTab].arealDistancegreater == true) {
                    this.updateShowCount(hotelsRenderData.length, CT.cache[CT.settings.currentTab].hotelsTotalCount)
                }

                // =========== Clearing timer if there is any that is previously created while rendering the result=========== //
                clearTimeout(resultView.scrollTimerId);
                resultView.scrollTimerId = undefined;
                if (resultView.$el.find(".loadingModal").length > 0) {
                    resultView.$el.find(".loadingModal").remove();
                }

                //Resetiing sroll event on each srp repaint.
                $(window).unbind('.infiList');
                $(window).unbind('.infiniteScroll');
                $(window).bind('scroll.infiniteScroll', function() {
                    resultView.$el.trigger('updateOnScroll')
                });
                resultView.$el.unbind('updateOnScroll');
                CT.fire('shortListedHotelCount.update')

                if (hotelsRenderData.length > 10 && CT.cache[CT.settings.currentTab].viewType !== "map") {
                    resultView.$el.find('.hotelsList ul.listView').after('<div class="pad loadingModal" id="loadMore"><h3>Hang on, fetching more results...</h3></div>');
                    if (CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter) {
                        CT.tagsInteracted = true;
                    }
                    //Binding scroll event again if there are more than 10 results for the city.
                    resultView.$el.bind('updateOnScroll', (function() {
                        var timer = 10; //Defualt delay between subsequent result append on scroll
                        var allowScroll = true,
                            isAllResultsDiplayed = false;

                        function append(tmplData) {
                            tmplData = CT.masterJson.removeHotel(firstHotelId, tmplData);
                            //console.log('tmplData', tmplData)
                            if (CT.subProd != "wg") {
                                html = CT.to_html(window.twoCol ? window.wgTplForHt ? 'HotelCardTpl' : window.mainTemplate : 'HotelListTpl', tmplData, {
                                    HotelPricePartialTpl: CT.to_html('HotelPricePartialTpl')
                                });
                            } else {
                                html = CT.to_html('HotelCardTpl', tmplData, {
                                    HotelPricePartialTpl: CT.to_html('HotelPricePartialTpl')
                                });
                            }

                            resultView.$el.find('.hotelsList ul.listView').append(html);
                        }

                        //This method is responsible for rendering/appending ore result in srp on sroll event
                        function renderResult() {
                            // console.log("renderResult")
                            resultView.$el.find(".loadingModal").remove();
                            var endIdx, tmp, tmplData = {},
                                appendTagsPromoIdx = 20; // this value should be multiple of 10;

                            startIdx = CT.cache[CT.settings.currentTab].startIndex;
                            endIdx = startIdx + pageEleCount;

                            if (window.showTags && !CT.tagsInteracted && endIdx > (appendTagsPromoIdx - 10) && endIdx <= appendTagsPromoIdx) {
                                timer = 2000; //If tags is there and user hasn't interacted on any tags
                            } else {
                                timer = 0; //Defualt delay between subsequent result append on scroll
                            }
                            
                            tmplData.ht = hotelsRenderData.slice(startIdx, endIdx);
                            if (tmplData.ht.length == 0) {
                                isAllResultsDiplayed = true;
                            }
                            append(tmplData)
                            if (tmplData.ht.length == 10) {
                                resultView.$el.find('.hotelsList ul.listView').after('<div class="pad loadingModal" id="loadMore"><h3>Hang on, fetching more results...</h3></div>');
                            }
                            
                            resultView.$el.find(".dotDotDot").remove();
                            var hotelsRenderedLength = hotelsRenderData ? hotelsRenderData.length : 0
                            var tmplDataToPoi = {}
                            console.log("place 3");
                            // if (hotelsRenderedLength > 0 && hotelsRenderedLength == resultView.$el.find('.hotelsList ul.listView').children().length && (CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" && CT.cache[CT.settings.currentTab].arealDistancegreater != true && resultView.$el.find('nav.showFewFilter input').attr('checked'))) {
                            //     tmplDataToPoi.showingDistance = CT.cache[CT.settings.currentTab].showFewHotelsDistance
                            //     tmplDataToPoi.showingLocationpoi = CT.cache[CT.settings.currentTab].pointOfIntrestValue
                            //     var appendTemplate = CT.to_html('HotelLocationSorterPoiTpl', tmplDataToPoi)
                            //     resultView.$el.find('.hotelsList ul.listView').append(appendTemplate)
                            // }

                            resultView.$el.find('li.listItem .royalSlider').royalSlider(CT.settings[CT.app].royalSliderAttrObj).css('visibility', 'visible');
                            resultView.initSeparator(tmplData.ht, startIdx, endIdx);
                            CT.cache[CT.settings.currentTab].startIndex = endIdx
                            resultView.updateCallback();
                            resultView.showTagsInHotelList(resultView.$el.find('.hotelsList ul.listView'), appendTagsPromoIdx);
                            if (CT.subProd != 'wg' && window.twoCol == true) {
                                CT.utils.helperFunctions.createSliders();
                            }
                            CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_InfiniteScroll', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                            // Attach inview event to all hotels loded seprately after page load
                            $("li.listItem:visible").one('inview', function(event, isInView) {
                                if (isInView) {
                                    inViewHotelIds.push($(event.currentTarget).attr('id'))
                                }
                            });
                        }

                        //This methos will return if we should append more result or not on page scroll 
                        function isAllowScroll() {
                            var $last_result = resultView.$el.find('.listItem').last();
                            var bottom_of_results = $last_result.outerHeight() + $last_result.offset().top;
                            var vis_bottom = $(document).scrollTop() + $(window).height();
                            if (bottom_of_results - vis_bottom < 500) {
                                return true;
                            }
                            return false;
                        }
                        /*  
                            This closure function will be called each time when there is a scroll and 
                            whenever there is no previous operation it will try to append more results
                            after all results displyed this will not call render result method
                        */
                        return function() {
                            allowScroll = isAllowScroll();
                            if (!resultView.scrollTimerId && allowScroll && !isAllResultsDiplayed) {
                                if (window.showTags && !CT.tagsInteracted && timer != 0) {
                                    resultView.scrollTimerId = setTimeout(function() {
                                        renderResult();
                                        clearTimeout(resultView.scrollTimerId);
                                        resultView.scrollTimerId = undefined;
                                    }, timer);
                                }
                                else {
                                    renderResult();
                                }                                
                            }
                        }
                    })());
                }
                 
                else if (hotelsRenderData.length > 10 && CT.cache[CT.settings.currentTab].viewType === "map") {
                    // set map pagination.
                    var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                        hotelList = $currentTab.find('.listViewResults'),
                        listViewUl = hotelList.find('.listView'),
                        isMapsAlreadyRendered = true;


                    hotelList.find('.pagination').empty();
                    hotelList.pajinate({
                        dataList: hotelsRenderData,
                        dataType: "json",
                        item_container_id: '.listView',
                        num_page_links_to_display: 5,
                        items_per_page: pageEleCount,
                        start_page: 1,
                        abort_on_small_lists: true,
                        nav_label_prev: '',
                        nav_label_next: '',
                        nav_panel_id: '.pagination',
                        callback: function(start_from, end_on, list) {
                            if (isMapsAlreadyRendered == true) { // initially the list is already rendered, only the creation of the pagination links has to be done, reset this flag in the first callback.
                                isMapsAlreadyRendered = false
                            } else {
                                tmplData.ht = list
                                tmplData = CT.masterJson.removeHotel(firstHotelId, tmplData);
                                listViewUl.empty().html(CT.to_html(window.twoCol ? window.wgTplForHt ? 'HotelCardTpl' : window.mainTemplate : 'HotelListTpl', tmplData, {
                                    HotelPricePartialTpl: CT.to_html('HotelPricePartialTpl')
                                }));
                                resultView.updateCallback();
                                tmplDataToPoi = {}
                                // console.log("place 2");
                                // if (list.length < end_on - start_from) {
                                //     if (CT.cache[CT.settings.currentTab].showFewHotelsDistance != "" && CT.cache[CT.settings.currentTab].arealDistancegreater != true && $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked')) {
                                //         tmplDataToPoi.showingDistance = CT.cache[CT.settings.currentTab].showFewHotelsDistance
                                //         tmplDataToPoi.showingLocationpoi = CT.cache[CT.settings.currentTab].pointOfIntrestValue
                                //         var appendTemplate = CT.to_html('HotelLocationSorterPoiTpl', tmplDataToPoi)
                                //         $("#ResultContainer_" + CT.settings.currentTab).find('.hotelsList ul.listView').append(appendTemplate)
                                //     }
                                // }
                                //upon page change
                                CT.cache[CT.settings.currentTab].mapDragged = false
                                CT.fire('mapchangeplot', [hotelsRenderData]);
                            }
                            //resultView.$el.find('li.listItem img').setLoad(CT.utils.imgAdjust);
                            
                            resultView.$el.find('li.listItem .royalSlider').royalSlider(CT.settings[CT.app].royalSliderAttrObj).css('visibility', 'visible');
                            resultView.$el.find(".dotDotDot").remove();
                        }
                    });
                    $currentTab.find('.listViewResults .pagination').show();
                    // $currentTab.find('.listViewResults .pagination').get(0).filters = CT.applyTheseFilters;

                }

                if (CT.isLocationEnabled == true && CT.cache[CT.settings.currentTab].removeGoogleSearch == true) {
                    $("#ResultContainer_" + CT.settings.currentTab).find('.googleWidget').hide()
                }
                if (CT.isLocationEnabled == true && !$("#ResultContainer_" + CT.settings.currentTab).find('div.googleWidget').is(':visible') &&
                    !$("#ResultContainer_" + CT.settings.currentTab).find('div.propertySection').is(':visible')) {
                    $("#ResultContainer_" + CT.settings.currentTab).find('div.googleWidget').show()
                }
                //Added for Mixpanel srpRanks
                setTimeout(function() {
                    if ((hotelsRenderData.length == 0 && CT.cache[CT.settings.currentTab].autocompleteValSelected == true) ||
                        (CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal == true &&
                            $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked') &&
                            CT.isLocationEnabled == true && hotelsRenderData.length == 0)) {
                        $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked', false)
                        //CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal=false
                        CT.cache[CT.settings.currentTab].showFewHotelsDistance = ""
                        CT.cache[CT.settings.currentTab].plceselected = false
                        CT.cache[CT.settings.currentTab].showAllPoiClicked = true
                        CT.cache[CT.settings.currentTab].autocompleteValSelected = false
                        CT.fire('filters.apply')
                    }
                }, 1)



                mixpanelsrpRanks(hotelsRenderData);
                // ===========
                CT.cache[CT.settings.currentTab].startIndex = startIdx + pageEleCount

                /*
                        // rendering flights in dp
                        var html = Mustache.to_html($('#DpAirTpl').html(), { content: onwardReturnFl });
                        delete jsonCopy.fl;

                        // rendering hotels in dp
                        var tmp = $('#DpTotalPriceTpl').html();
                        var startIdx = typeof idx !== 'undefined'? idx  : (CT.cache[CT.settings.currentTab].startIndex || 0)
                        var toRenderData = data.slice(startIdx, 30)
                        html = Mustache.to_html($('#DpHotelsListTpl').html(), CT.masterJson.get(), { fl: html, pt: tmp });
                        this.$el.find('.dpList ul.listView').html(html);

                        this.afterRenderCallback();
                        //this.initInfScroll(undefined);
                        CT.cache[CT.settings.currentTab].startIndex = startIdx + 30
                        */
                //}
                //catch(e){
                //  _errs.push(e);
                //throw e;

                //}        
                if ($.isLoaded) {
                    CT.utils.loadTrackers('results'); //trackers
                    CT.utils.helperFunctions.includeGATagManager();
                } else {
                    $(window).load(function() {
                        CT.utils.loadTrackers('results');
                        CT.utils.helperFunctions.includeGATagManager();
                    });
                }
                // Attach inview event to all hotels loded initialy during page load
                $("li.listItem:visible").one('inview', function(event, isInView) {
                    if (isInView) {
                        inViewHotelIds.push($(event.currentTarget).attr('id'))
                    }
                });

                window.localStorage && window.localStorage.removeItem("__ismod__diff__msg");

				
            } : function( /*Event */ e, /* Hash */ data, /* Hash */ options) { //data is the hash of filteered and sorted hotels - {exact : [], others : []}


                try {
                    options = options || {}
                    this.$el = this.$el || $(e.target)
                    var resultView = this
                    var /* master json */ mJson = CT.masterJson.get()
                    var /* Number */ onwardIndex = mJson.fl.con.split('-')[0]
                    var /* Number */ returnIndex = mJson.fl.crt.split('-')[0]
                    var /* String */ flHtml = this.getFlightSummaryMarkup(onwardIndex, returnIndex, mJson)
                    var /* String */ priceTmpl = $('#DpTotalPriceTpl').html();
                    var /* Number */ startIdx = typeof options.idx !== 'undefined' ? options.idx : (CT.cache[CT.settings.currentTab].startIndex || 0)
                    var /* Array */ areaList = data.exact
                    var /* Array */ radialList = data.others
                    var /* Array */ toRenderData = []
                    var /* Object */ tmplData = _.clone(mJson)
                    var /* String */ html = ''

                    // Updating tmplate data
                    tmplData.hasAm = options.hasAmenities
                    Mustache.clearCache();
                    if (areaList.length > 0) {
                        toRenderData = areaList.slice(startIdx, 10)
                        tmplData.ht = toRenderData
                        html = Mustache.to_html($('#DpHotelsListTpl').html(), tmplData, {
                            fl: flHtml,
                            pt: priceTmpl
                        });
                        this.$el.find('.dpList ul.listView').html(html)
                    }

                    if (radialList.length > 0) {
                        toRenderData = radialList.slice(startIdx, 10)
                        tmplData.ht = toRenderData
                        html = Mustache.to_html($('#DpHotelsListTpl').html(), tmplData, {
                            fl: flHtml,
                            pt: priceTmpl
                        });
                        this.$el.find('.dpList ul.listView').append(CT.settings.listSeparator).append(html)
                    }
                    this.afterRenderCallback();
                    this.updateShowCount(areaList.length + radialList.length)

                    // ===========
                    $(window).unbind('.infiList')
                    $('.loadingModal').hide()
                    if (areaList.length > 10)
                        this.setInfiScroll({
                            delay: 1,
                            partial: {
                                fl: flHtml,
                                pt: priceTmpl
                            },
                            threshold: 400,
                            allowScroll: function(data) {
                                return data.ht.length === 0 ? false : true
                            },
                            spinner: '.loadingModal',
                            positionSpinner: 'after'
                        }, function() {
                            startIdx = CT.cache[CT.settings.currentTab].startIndex
                            toRenderData = areaList.slice(startIdx, startIdx + 10)
                            tmplData.ht = toRenderData
                            this.append(tmplData)
                            CT.cache[CT.settings.currentTab].startIndex = startIdx + 10
                        })

                    // ===========
                    CT.cache[CT.settings.currentTab].startIndex = startIdx + 10;


                } catch (e) {

                    _errs.push(e);
                    throw e;

                }


            },



            setInfiScroll: function( /* Hash */ options, /* Function */ onScroll) {
                var hotelList;
                if (CT.app == 'dp')
                    hotelList = new InfiList( /* jQuery List*/ this.$el.find('.dpList ul.listView'), /* Template */ $('#DpHotelsListTpl').html(), /* Options */ options)
                else if (CT.subProd == "wg") {
                    hotelList = new InfiList( /* jQuery List*/ this.$el.find('.hotelsList ul.listView'), /* Template */ CT.cache.templates.HotelCardTpl, /* Options */ options)
                } else {
                    hotelList = new InfiList( /* jQuery List*/ this.$el.find('.hotelsList ul.listView'), /* Template */ window.twoCol ? window.wgTplForHt ? CT.cache.templates.HotelCardTpl : CT.cache.templates.HotelTwoColListTpl : CT.cache.templates.HotelListTpl, /* Options */ options)
                }
                hotelList.stop().onScroll(onScroll)
                return hotelList
            },



            // Called when the "shortlist" link is clicked
            shortListHotel: function(evt) {
                var hotelId = $(evt.target).closest('li').attr("id");
                var data = [{
                    "ids": hotelId,
                    "operation": "add",
                    "callerEvt": evt.type
                }];
                CT.fire('shortlistParam.update', data)
                this.$('.shortlistContainer').trigger("list.update", data);
                return this
            },



            openCompareHotelWindow: function(evt) {
                if (CT.shortListHotels[CT.settings.currentTab].length < 2) {
                    return false;
                }
                $("#ResultContainer_" + CT.settings.currentTab).find(".shortlistContainer").hide();
                var cbfunc = function() {
                    $("#ResultContainer_" + CT.settings.currentTab).find(".shortlistContainer").show();
                }
                CT.utils.showModalDialog('/hotelstatic/includes/shortlist-modal.shtml', '700px', '480px', false, false, cbfunc);

            },



            viewShortlistHotels: function(e) {
                if (CT.shortListHotels[CT.settings.currentTab].length == 0) {
                    return false;
                }

                $("#ResultContainer_" + CT.settings.currentTab).find("#shortListed").click();
            },



            removeShortListHotel: function(evt) {
                var hotelId = $(evt.target).closest('li').attr("id");
                var data = [{
                    "ids": hotelId,
                    "operation": "delete"
                }]
                CT.fire('shortlistParam.update', data)
                this.$('.shortlistContainer').trigger("list.update", data);
            },



            bookHotel: function(evt) {
                if (window.productCode == "CP" && $(evt.target).hasClass('disabled')) return false;

                var $currentElem, $hBlock, bookingCode, i = 0,
                    dataItem = null,
                    featuredRank, uiRank, uiRankType;
                $currentElem = $(evt.target), $hBlock = $currentElem.closest('li');
                $currentElem.addClass('loading');

                //TODO : make glass shield as a util
                $('.glassShield').show();

                function initBooking() {
                    bookingCode = $currentElem.attr("data-bookingcode");
                    roomTypeCode = $currentElem.attr("data-roomtypecode");

                    hotelId = $hBlock.attr("id");
                    /* not necessary remove it if nothing breaks - karthik
                            tripAdviseRating = $hBlock.attr("data-tastar");
                            var hotelJson = CT.masterJson.get();
                            var hotelList = hotelJson.ht;
                            while (i < hotelList.length) {
                                if (hotelList[i].id === hotelId) {
                                    dataItem = hotelList[i];
                                    break;
                                }
                                i++;

                            }
                            */
                    dataItem = CT.masterJson.getHotel(hotelId);
                    if (window.companyId) {
                        dataItem.companyId = window.companyId;
                    }
                    tripAdviseRating = dataItem.tar || "";
                    featuredRank = dataItem.p;
                    uiRank = $("#" + hotelId).index() + 1;
                    uiRankType = $("#ResultContainer_" + CT.settings.currentTab).find(".sorters").find(".current").text();
                    CT.utils.postHotelForm(hotelId, tripAdviseRating, bookingCode, roomTypeCode, true, dataItem, featuredRank, uiRank, uiRankType);
                }

                initBooking();

            },



            floatToClass: function(tar) {
                return (("" + tar).replace(".", ""));
            },



            dpRender: function( /* masterJson */ mJson, paramsHash) {
                //modify all flights information
                CT.FlightSolution.modifier(mJson.fl);
                mJson.fl.orgCon = mJson.fl.con;
                mJson.fl.orgCrt = mJson.fl.crt;

                //caching flight content
                var flMapping = mJson.fl.mapping;
                var flContent = mJson.fl.content;
                var sfsfd = (_.deserialize(location.search)).sfsfd ? true : false;
                _.forEach(mJson.ht, function(hotel, index) {
                    this.hotelMinorUpdates(hotel);
                    //console.log('after minor updates', hotel)

                    //hotel index used to refer a hotel upon clicking change flight or change hotel
                    hotel.inx = index;
                    hotel.sfsfd = sfsfd;
                    if (hotel.priceInfo) {

                        //other hotel details
                        firstRms = hotel.priceInfo.rms[0];
                        //this function modifies hotel details based on firstRms
                        hotel = $.extend(true, hotel, CT.FlightSolution.calFormatPrice(hotel, hotel.priceInfo.pf, hotel.priceInfo.ps));


                        hotel.rmtp = firstRms.rm;
                        hotel.rmtc = firstRms.rmtc;
                        hotel.rtc = firstRms.rtc;
                        hotel.pf = hotel.priceInfo.pf;
                        hotel.ps = "" + hotel.priceInfo.ps + "";

                        hotel.airpf = hotel.priceInfo.airpf;
                        hotel.airps = hotel.priceInfo.airps;
                        hotel.hotelpf = hotel.priceInfo.hotelpf;
                        hotel.hotelps = CT.utils.formatForCurrency(hotel.priceInfo.hotelps, false, null, true).fmtPrice;

                        //rate rule information
                        if (hotel.priceInfo.oi !== '') {
                            hotel.rrule = mJson.of[hotel.priceInfo.oi].hd;
                        }

                        //delete hotel.priceInfo;
                    }
                    hotel.amenities = CT.to_html('AmenitiesTpl', {
                        amIcons: CT.utils.helperFunctions.getHotelAmenities(hotel.amn)
                    });
                }, this); //TODO rename this method



                //update showing count
                this.updateShowCount(mJson.ht.length, mJson.ht.length);



                //dp init   -   @todo - move to common place
                //CT.fire('changeFlights.ready',[]);
                CT.fire('filters.init', [mJson, paramsHash, this]);
                //CT.fire('sorters.init', [mJson, paramsHash, this]);

                $(".listView").delegate("li.listItem", "mouseover", function() {
                    $(this).find("a.pop").addClass("popped");
                });

                $(".listView").delegate("li.listItem", "mouseout", function() {
                    $(this).find("a.pop").removeClass("popped");
                });

            },



            afterRenderCallback: function() {
                var tmp;

                $("#Interstitial").hide();
                //add image lazy load
                //this.$el.find('li.listItem img').setLoad(CT.utils.imgAdjust);

                //init tipsy tooltip
                this.$("[rel=bTooltip]").tipsy({
                    gravity: 'N'
                });
                this.$("ul.hotelBadges li").tipsy({
                    gravity: 'N'
                });
                $(".mapView .hotelsList .listItem.locNA").tipsy({
                    gravity: 'W',
                    live: true,
                    className: 'popOver light noLocationContent',
                    opacity: 1,
                    fallback: CT.messages.hotel.HotelLocNotFound
                });
                CT.widgets.placeholder.parseDomTree();
                /*
                this.$('.badgeFilter li a').tipsy({
                    gravity : 'N',
                    html : true,
                    className : 'popOver light',
                    opacity: 1
                });
                */
            },



            setShortListView: CT.app === "dp" ? CT.noop : function() {
                shortListViewSettings.$el = this.$('.shortlistContainer');
                shortListViewSettings.tpl = shortListViewSettings.tpl || $('#ShortlistItemTpl');
                View(shortListViewSettings);
            },



            /*
             * common function between dp and hotel
             * this function modifies hotel object
             */
            hotelMinorUpdates: function(hotel) {

                hotel.shortID = CT.utils.shortenID(hotel.id);

                //remove area attribute if empty
                if (!(hotel.ar))
                    hotel.ar = '';
                else
                    hotel.ar = $.trim(hotel.ar);

                //hotel star rating
                if (hotel.sr == 0) {
                    delete hotel.sr;
                }

                //hotel tarating
                if (hotel.tar != undefined) {
                    if (hotel.tar == 0 || hotel.tarev < 1) {
                        delete hotel.tar;
                    } else {
                        taRatingClass = this.floatToClass(hotel.tar);
                        hotel.taClass = taRatingClass;
                    }
                }

            },



            triggerChangeCurrency: function(e) {
                var tmp;
                var settings = {};

                CT.fire('updateHotelObj', [CT.masterJson.get(), fetchHotelsJson.newResultView])
                //this.updateProperties(CT.masterJson.get());

                settings = CT.cache[CT.settings.currentTab].filterValues.priceMinMax;

                this.$el.find('.filtersForm').trigger('filter.repaint', ['price', settings, null, true]);
                CT.fire('filters.apply');
            },



            updateProperties: function(partialJson) {
                var fcFilterBlock = $("#ResultContainer_" + CT.settings.currentTab).find(".freeCancellation").closest(".sideBlock");
                var villaFilterBlock = $("#ResultContainer_" + CT.settings.currentTab).find(".tripVilla").closest(".sideBlock");

                if (CT.cache[CT.settings.currentTab].isPayAtHotel)
                    $(".payAtHotel").closest(".sideBlock").show();

                if (CT.cache[CT.settings.currentTab].isVillaProp)
                    villaFilterBlock.show().addClass('specialFilter');

                if (CT.cache[CT.settings.currentTab].isFc)
                    fcFilterBlock.show().addClass('specialFilter');

                if (CT.cache[CT.settings.currentTab].opaqueHotelsArr && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false && CT.cache[CT.settings.currentTab].opaqueHotelsArr.length > 0) {
                    var mJson = CT.masterJson.get();
                    var opaqueArr = CT.cache[CT.settings.currentTab].opaqueHotelsArr;
                    for (var k = 0; k < opaqueArr.length; k++) {
                        var hotelObj = CT.masterJson.getHotel(opaqueArr[k]);
                        var avgRate = ((hotelObj && mJson.avgrate[hotelObj.ar]) ? (mJson.avgrate[hotelObj.ar][hotelObj.sr] ? mJson.avgrate[hotelObj.ar][hotelObj.sr] : '') : '')
                        if (avgRate != '') {
                            hotelObj.shwOpAvg = true
                            hotelObj.opAvgFmt = CT.utils.formatForCurrency(avgRate)
                            if (hotelObj.priceInfo) {
                                if (avgRate < hotelObj.priceInfo.rms[0].tot)
                                    hotelObj.shwOpAvg = false
                            }
                        }

                    }
                }


                if (CT.subProd == "airBnb") {
                    this.$el.find('.instantBooking').closest(".sideBlock").show();
                }

                var airBnbUnavailList = _.filter(CT.masterJson.get().ht, function(obj) {
                    return (obj.priceInfo == undefined && obj.id.indexOf("ABNB") != -1)
                })
                //var airBnbUnavailList = _.unique(CT.cache[CT.settings.currentTab].airBnbUnavailList);

                for (var i = 0; i < airBnbUnavailList.length; i++) {
                    //CT.masterJson.deleteHotel(airBnbUnavailList[i])
                    CT.masterJson.get().ht = CT.masterJson.get().ht.filter(function(hotel) {
                        return hotel.id != airBnbUnavailList[i].id;
                    })
                }

                CT.cache[CT.settings.currentTab].hotelsTotalCount = CT.masterJson.get().ht.length;
                if (CT.subProd != "airBnb") {
                    CT.cache[CT.settings.currentTab].badgeCnt["abnb"] = _.filter(CT.masterJson.get().ht, function(hotel) {
                        if (hotel.id.indexOf("ABNB") != -1) {
                            return hotel
                        }
                    }).length;
                }

                for (var k in CT.cache[CT.settings.currentTab].badgesStat) {
                    if (k == "sdr" && CT.cache[CT.settings.currentTab].badgeCnt["sdr"] > 0) {
                        this.$el.find('.deals').closest(".sideBlock").hide();
                        this.$el.find('.quickeys').closest(".sideBlock").show();
                    }
                    if (k == "deals" && CT.cache[CT.settings.currentTab].badgeCnt["deals"] > 0) {
                        this.$el.find('.quickeys').closest(".sideBlock").hide();
                        this.$el.find('.deals').closest(".sideBlock").show();
                    }
                    if (k == "wsh" && CT.cache[CT.settings.currentTab].badgeCnt["wsh"] > 0) {
                        this.$el.find('.weSleep').closest(".sideBlock").show();
                    }
                    if (k == "bp" && CT.cache[CT.settings.currentTab].badgeCnt["bp"] > 0) {
                        this.$el.find('.popHotels').closest(".sideBlock").show();
                    }

                }

            },



            /*
             * Create the taxes markup html separately on click of any links while opening the modal
             * window
             *
             */

            taxesMarkup: function(hotelId, e) {

                var hotelObj = CT.masterJson.getHotel(hotelId);
                var totRoomNight = Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights) * Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms);

                // check priceInfo is undefined or not
                // required for hotels with no rooms available
                if (typeof hotelObj.priceInfo !== 'undefined') {
                    _.forEach(hotelObj.priceInfo.rms, function(rms, i) {
                        tmp = 'CurrencyFormatTpl';
                        rms.tdtfmt = CT.to_html(tmp, CT.utils.formatForCurrency(rms.tdt, false, null, true));
                        if (i == 0)
                            firstRoomTdt = rms.tdtfmt;
                        rms.ttdfmt = CT.to_html(tmp, CT.utils.formatForCurrency((rms.ttd + (rms.st + rms.sbc + rms.kkc) * totRoomNight), false, null, true));
                        rms.tfmt = CT.to_html(tmp, CT.utils.formatForCurrency((rms.t + (rms.st + rms.sbc + rms.kkc)), false, null, true));
                        if (rms.d > 0) {
                            rms.sav = CT.to_html(tmp, CT.utils.formatForCurrency(rms.d, false, null, true));
                        }
                        // read abtest cookie.
                        if (window.taxAbTest === 'a') {
                            var roomNights = Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights) * Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms);
                            rms.showTaxLink = false;
                            if (rms.t != undefined && rms.t >= 0) {
                                rms.showTaxLink = true;
                                if (window.taxAbTest_A == 'b') {
                                    rms.taxAbTest_A = true;
                                }
                                if (((rms.t || 0) + rms.st + rms.sbc + rms.kkc) > 0) {
                                    rms.taxMarkupPerRoom = CT.to_html(tmp, CT.utils.formatForCurrency((rms.t + rms.st + rms.sbc + rms.kkc), false, null, true));
                                    rms.taxMarkupTotal = CT.to_html(tmp, CT.utils.formatForCurrency((rms.t + rms.st + rms.sbc + rms.kkc) * roomNights, false, null, true));
                                } else {
                                    rms.showTaxLink = false;
                                    rms.taxAbTest_A = false;
                                }
                            }

                            rms.avgfmt = CT.to_html(tmp, CT.utils.formatForCurrency(rms.avg - ((rms.t || 0) + rms.st + rms.sbc + rms.kkc), false, null, true));
                            rms.totalWithoutTaxfmt = CT.to_html(tmp, CT.utils.formatForCurrency(rms.tot - ((rms.t || 0) + rms.st + rms.sbc + rms.kkc) * roomNights, false, null, true));

                            if (rms.d > 0) {
                                rms.oamtWithoutTaxfmt = CT.to_html(tmp, CT.utils.formatForCurrency((rms.tot + rms.d) - ((rms.t || 0) + rms.st + rms.sbc + rms.kkc) * roomNights, false, null, true));
                            } else {
                                rms.oamtWithoutTaxfmt = ""
                            }
                        } else {
                            if (window.productCode == "AG") {
                                var agmMarkup = parseInt(rms.agm)
                                var agmPerRoom = parseInt(agmMarkup / totRoomNight)
                                rms.avgfmt = CT.to_html(tmp, CT.utils.formatForCurrency(parseInt(rms.avg + agmPerRoom), false, null, true));
                            } else {
                                rms.avgfmt = CT.to_html(tmp, CT.utils.formatForCurrency(rms.avg, false, null, true));
                            }
                        }
                        if (window.productCode == "AG") {
                            var agmMarkup = parseInt(rms.agm)
                            var agmPerRoom = parseInt(agmMarkup / totRoomNight)
                            rms.avgMinusTFmt = CT.to_html(tmp, CT.utils.formatForCurrency(parseInt(rms.avg + agmPerRoom - rms.t - rms.st - rms.sbc - rms.kkc), false, null, true));
                        } else {
                            rms.avgMinusTFmt = CT.to_html(tmp, CT.utils.formatForCurrency(rms.avg - rms.t - rms.st - rms.sbc - rms.kkc, false, null, true));
                        }
                        //rms.avgMinusTFmt = CT.to_html(tmp, CT.utils.formatForCurrency(rms.avg - rms.t, false, null, true));
                    }, this);
                }

                if (e) {
                    var hotelTag = $(e.target).parents('li.listItem'),
                        hotelId = hotelTag.attr('id'),
                        quickLookDiv = hotelTag.find('.quickLook')

                    if (hotelObj.viw)
                        html = this.getVillasRmsMarkup(hotelObj.priceInfo.rms, false, (hotelObj.pt && hotelObj.pt.length !== 0 ? hotelObj.pt[0].name : ""));
                    else
                        html = this.getRmsMarkup(hotelObj.priceInfo.rms, undefined, hotelObj);

                    quickLookDiv.find('table tbody').html(html);
                    if (window.taxAbTest === 'a' || window.productCode == "CP") {
                        $('.moreRooms').find('small:first-child').hide();
                    }
                }
            },



            /*
             * update showing number in the view
             * @param : showing - number of items currently shown
             * @param : total - total number of items - optional field
             */
            updateShowCount: function(showing, total) {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                    cookieSetBanner = CT.utils.cookies.read('srpPageBanner');
                CT.cache[CT.settings.currentTab].prevFltCount = (CT.cache[CT.settings.currentTab].crntFilCount === showing) ? CT.cache[CT.settings.currentTab].prevFltCount : (CT.cache[CT.settings.currentTab].crntFilCount ? CT.cache[CT.settings.currentTab].crntFilCount : total);
                CT.cache[CT.settings.currentTab].crntFilCount = Int(showing)
                showing = Int(showing);
                total = total || CT.cache[CT.settings.currentTab].hotelsTotalCount;


                CT.utils.CTLogger.storeDRTR(showing, total);

                //update showingCount and totalCount
                if (window.altFilters == "false") {
                    this.$('.filters .hCount span, .primaryBar .hCount span').show();
                    this.$('.filters .showingCount, .primaryBar .showingCount').html(showing);
                    this.$('.filters .totalCount, .primaryBar .totalCount').html(total);
                } else {
                    this.$('.primaryFilter .hCountText').show();
                    this.$('.primaryFilterContent .hCount span').show();
                    this.$('.primaryFilterContent .showingCount').html(showing);
                    this.$('.primaryFilterContent .totalCount').html(total);
                }

                if (showing == 0 && CT.subProd != "wg") {
                    $currentTab.find('.listView').html('');
                    $currentTab.find('.instHeader').hide();
                    var locationSearch = _.deserialize(window.location.search)
                    if (CT.isLocationEnabled == true && locationSearch.poi != "" &&
                        $("#ResultContainer_" + CT.settings.currentTab).find('nav.showFewFilter input').attr('checked')) {
                        CT.cache[CT.settings.currentTab].removeGoogleSearch = true
                    }
                    if (CT.cache[CT.settings.currentTab].autocompleteValSelected == false) {
                        this.showZeroOrFewResultNote(undefined, CT.messages[CT.app].zeroResults['filter']);
                    }
                } else {
                    if (cookieSetBanner != 1)
                        $currentTab.find('.instHeader').show();
                    $currentTab.find('.zeroResults').remove();
                }
                if (window.altFilters == "false") {
                    if (total == showing) {
                        if (window.isMobileUA && window.isMobileUA == true) {} else {
                            this.$('.filters .hCount .resetLink, .primaryBar .hCount .resetLink').hide();
                        }
                        this.$('.curate').hide();
                    } else {
                        this.$('.filters .hCount .resetLink, .primaryBar .hCount .resetLink').show();
                        this.$('.curate').show();
                    }
                } else {
                    if (total == showing) {
                        if (window.isMobileUA && window.isMobileUA == true) {} else {
                            this.$('.primaryFilterContent .hCount .resetLink').hide();
                        }
                        this.$('.curate').hide();
                    } else {
                        this.$('.primaryFilterContent .hCount .resetLink').show();
                        this.$('.curate').show();
                    }
                }
                // var lengthOfCheckedInputs = $('#ResultContainer_' + CT.settings.currentTab).find('.filtersForm input:checked').length
                // if (lengthOfCheckedInputs == 1 && $('#ResultContainer_' + CT.settings.currentTab).find('.filtersForm input:checked').attr('name') == 'showFewFilter') {
                //     $('#ResultContainer_' + CT.settings.currentTab).find('a.resetLink').hide()
                // }
                // if (lengthOfCheckedInputs == 0) {
                //     $('#ResultContainer_' + CT.settings.currentTab).find('a.resetLink').hide()
                // }
            },


            showZeroOrFewResultNote: function(e, msgObj, tplName, position, afterBeforeTag, container) {
                var msg = $.extend(true, {}, msgObj),
                    html, $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                    hotelList;

                tplName = tplName || "ZeroResultsTpl";

                if (msg.call) {
                    msg.callm = CT.to_html(CT.messages[CT.app].zeroResults.call, {
                        phoneSales: CT.settings[CT.app].phoneNo.phoneSales

                    });
                }

                ///Change the logic -abhay
                if (tplName === "ZeroResultsTpl" && CT.cache[CT.settings.currentTab].recentFilterData &&
                    CT.cache[CT.settings.currentTab].recentFilterData.prevSerializedData == undefined) {
                    msg.btnL = "";
                }
                if (CT.cache[CT.settings.currentTab].recentFilterData && CT.cache[CT.settings.currentTab].recentFilterData.prevSerializedData && CT.cache[CT.settings.currentTab].recentFilterData.prevSerializedData.length <= 1) {
                    msg.btnL = "";
                }
                if (CT.cache[CT.settings.currentTab].removeUndo === true) {
                    msg.btnL = "";

                } else {

                    msg.btnL = "Undo last filter";
                }
                if ($('body').hasClass('mapView')) {
                    msg.title = CT.messages.hotel.UnableToFindHotel;
                    msg.btnL = "";
                    msg.btnR = "";
                    hotelList = $currentTab.find('.listViewResults');
                    hotelList.find('.pagination').empty();
                    CT.fire("removeMarkers");
                }
                html = CT.to_html(tplName, msg);
                //$currentTab.find('.listView').find('.zeroResults').remove().end().prepend(html);
                $('.loadingModal').hide()
                this.addSeparator(null, html, position || 'top', afterBeforeTag, container);
            },



            showNearByCitiesMsg: function(ncm) {
                var localities = '',
                    citiesCount = _.size(ncm),
                    i = 0,
                    renderObj, tmp;

                _.forEach(ncm, function(name) {
                    if (i != 0)
                        localities += ', ';

                    if (i != 0 && i == citiesCount - 1)
                        localities += ' and ';

                    localities += name;
                    i++;
                });

                tmp = CT.messages[CT.app].separatorMsgs.nearByCities;
                renderObj = $.extend(true, {}, tmp);
                renderObj.mainMsg = CT.to_html(renderObj.mainMsg, {
                    localities: localities
                });

                /* using create filter instead of this - karthik
                        tmp = this.$el.find('.filtersForm');
                        if(tmp.find('input[name="nearByCities"]').length == 0)
                            tmp.prepend('<label for="NearByCities' + CT.settings.currentTab + '"><input id="NearByCities' + CT.settings.currentTab + '" type="checkbox" name="nearByCities" class="nearByCities" checked="checked">Show Near By Cities</label>');
                        */

                tmp = this.$el.find('.filtersForm');
                if (tmp.find('.nearByCities').length == 0)
                    tmp.trigger('filters.create', ['nearByCities', 'checkbox']);

                html = CT.to_html('InPageMessage', renderObj);
                this.addSeparator(null, html, 'top', null, this.$el.find('.viewController .pageMessageHolder'));
                //CT.fire('filters.apply');
            },



            showLocalitySearchMsg: function(locality, isArea) {
                if (CT.isLocationEnabled == true) {
                    if ((CT.cache[CT.settings.currentTab].searchParams.all.area && CT.cache[CT.settings.currentTab].searchParams.all.area[0] !== "") || (locality.type && locality.type == "area")) {
                        var availHotelscount = locality.count ? locality.count : parseInt(CT.cache[CT.settings.currentTab].exactAreaHotelsCount);
                        var otherHotelscount = parseInt(CT.cache[CT.settings.currentTab].filteredHt['others'].length);
                        if (availHotelscount > 0) {
                            locationSearchobj = {
                                "hotelsCount": availHotelscount,
                                "locality": locality.type ? locality.name : locality + ", " + CT.cache[CT.settings.currentTab].searchParams.all.city,
                                "hasProperties": true
                            };
                        } else {
                            locationSearchobj = {
                                "msgForUnavail": "Hotels for your travel dates are sold out in " + locality + ", " + CT.cache[CT.settings.currentTab].searchParams.all.city
                            }
                        }
                    } else if (CT.cache[CT.settings.currentTab].searchParams.all.poi && CT.cache[CT.settings.currentTab].searchParams.all.poi[0] !== "" || locality.type == "poi") {
                        locationSearchobj = {
                            "hasProperties": true,
                            'poi': locality.name ? locality.name : CT.cache[CT.settings.currentTab].searchParams.all.poi[0]
                        };
                    }
                    locationSearchobj.isLocationEnabled = true;
                    if(window.showMapView === "false"){
                        locationSearchobj.showMapView = false; 
                    }else{
                        locationSearchobj.showMapView = true; 
                    }
                    if ($(".propertySection").length !== 0)
                        $(".propertySection").remove();
                    html = CT.to_html('NotificationTpl', locationSearchobj);
                    this.addSeparator(null, html, 'top', null, this.$el.find('.viewController .secondaryBar'));
                    // if(locality.name)
                    this.$el.find(".propertySection").removeClass("slideMeDown");
                    //  this.$el.find(".propertySection .viewLocation").hide()
                    if (CT.cache[CT.settings.currentTab].viewType == 'map') {
                        this.$el.find(".propertySection .viewLocation").hide()
                    }
                } else {
                    isArea = isArea || false;
                    tmp = $.extend(true, {}, CT.messages[CT.app].separatorMsgs.localitySpecificSearch);
                    tmp.mainMsg = locality;

                    tmp.btnText = CT.to_html(tmp.btnText, {
                        city: CT.cache[CT.settings.currentTab].searchParams.all.city
                    });
                    if (isArea)
                        tmp.msg = CT.messages.hotel.ShowingHotelsIn;
                    else
                        tmp.msg = CT.messages.hotel.ShowingHotelsArnd;

                    html = CT.to_html('NotificationTpl', tmp);
                    this.addSeparator(null, html, 'top', null, this.$el.find('.viewController .pageMessageHolder'));
                }
                CT.fire('shortListedHotelCount.update')

                var locationUrldata = _.deserialize(window.location.search)
                if (locationUrldata.poi != "" &&
                    CT.cache[CT.settings.currentTab].latitude == "" &&
                    CT.cache[CT.settings.currentTab].longitude == "" &&
                    CT.isLocationEnabled == true) {
                    $('#ResultContainer_' + CT.settings.currentTab).find(".propertySection").remove();
                    $('#ResultContainer_' + CT.settings.currentTab).find(".googleWidget").show()
                    // console.log('noLatLng')
                }
            },



            showHotelSearchMsg: function() {
                var tabCache = CT.cache[CT.settings.currentTab],
                    tmp;

                tmp = CT.messages[CT.app].separatorMsgs.hotelSpecificSearch;
                //this has to be mustache as tmp.btn is a string
                tmp.btn = Mustache.to_html(tmp.btn, {
                    cityName: tabCache.searchParams.all.city
                });
                html = CT.to_html('SeparatorMessageTpl', tmp);
                this.addSeparator(null, html, 'bottom');
            },



            initInfScroll: function(e) {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                    itemId;

                itemId = this.getDisplayItemId();

                if (itemId != undefined) {
                    CT.infScrollLast = CT.settings[CT.app].infScrollCount;
                    $currentTab.find(itemId + ":lt(" + (CT.infScrollLast + 1) + ")").show();
                    $currentTab.find(itemId + ":gt(" + (CT.infScrollLast - 1) + ")").hide();
                }
            },



            /*
             * @DESC : show offer banners
             */
            showBanner: function() {
                var html;
                if (true) {
                    html = $('#QuickeysBannerTpl').html();
                    this.addSeparator(null, html, 'top', null, this.$el.find('.viewController'));
                }
            },



            /**
             * @param searchJson - the final master json after all modifications
             */
            renderStatic: function(searchJson, paramsHash) {
                var queryparams = allQueryParams || CT.cache[CT.settings.currentTab].searchParams.all
                srpRedirectionFromUtm = srpRedirectionFromUtm || queryparams.srp_redirection_from_utm
                firstHotelId = firstHotelId || queryparams.hotel_id
                utmSource = utmSource || queryparams.utm_source
                firstHotel = firstHotel || CT.masterJson.getHotel(firstHotelId);
                // console.log("queryparams", queryparams);
                // console.log("srpRedirectionFromUtm", srpRedirectionFromUtm);
                // console.log("firstHotelId", firstHotelId);
                // console.log("utmSource", utmSource);
                // console.log("firstHotel", firstHotel);
                var html;
                var firstFewHotels = {};
                CT.cache[CT.settings.currentTab].dodHotelList = [];
                CT.cache[CT.settings.currentTab].badgesStat = {};
                CT.cache[CT.settings.currentTab].latitude = ""
                CT.cache[CT.settings.currentTab].longitude = ""
                CT.cache[CT.settings.currentTab].plceselected = false
                CT.cache[CT.settings.currentTab].showAllPoiClicked = false
                CT.cache[CT.settings.currentTab].locationUrlSearch = false
                CT.cache[CT.settings.currentTab].arealDistancegreater = false
                CT.cache[CT.settings.currentTab].firsTimePlaceSelected = false
                CT.cache[CT.settings.currentTab].autocompleteValSelected = false
                CT.cache[CT.settings.currentTab].removeGoogleSearch = false

                var locationUrl = _.deserialize(window.location.search)
                CT.cache[CT.settings.currentTab].badgeCnt = {
                    deals: 0,
                    wsh: 0,
                    bp: 0,
                    lbt: 0,
                    sdr: 0,
                    abnb: 0,
                    budgetHotelCnt: 0
                };
                CT.cache[CT.settings.currentTab].airBnbUnavailList = [];
                //remove noscroll if it is already there
                $('body, html').removeClass('noScroll');
                if (CT.isLocationEnabled == true) {
                    if (locationUrl.poi == "" || locationUrl.poi == undefined) {
                        CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal = false
                        CT.cache[CT.settings.currentTab].pointOfIntrestValue = ""
                        CT.cache[CT.settings.currentTab].showFewHotels = false
                        CT.cache[CT.settings.currentTab].locationUrlSearch = true

                    } else {
                        CT.cache[CT.settings.currentTab].homePageAutoCompleteSelectedVal = true
                        CT.cache[CT.settings.currentTab].pointOfIntrestValue = locationUrl.poi
                        CT.cache[CT.settings.currentTab].showFewHotels = true
                        CT.cache[CT.settings.currentTab].locationUrlSearch = true
                        CT.cache[CT.settings.currentTab].autoCompleteLatitude = ""
                    }
                }
                firstFewHotels.ht = _.first(searchJson.ht, CT.settings[CT.app].infScrollCount);
                if (CT.masterJson.get().hdfmn != "") {
                    // CT.cache[CT.settings.currentTab].showFewHotelsDistance = parseInt(CT.masterJson.get().hdfmn)
                    CT.cache[CT.settings.currentTab].showFewHotelsDistance = 99999999;
                }
                if (firstFewHotels.ht && firstFewHotels.ht.length > 0 && CT.isLocationEnabled == true) {
                    _.each(firstFewHotels.ht, function(item) {
                        if (item.hasSpriteIcon && item.classToarea) {
                            delete item.hasSpriteIcon;
                            delete item.classToarea;
                        } else {
                            if (item.distanceFromAreaString)
                                delete item.distanceFromAreaString;
                        }
                        if (item.areaSearch) {
                            item.areaSearch = false;
                        }
                        if (item.distanceFromLocation)
                            delete item.distanceFromLocation;
                    })
                }
                //add glass shield
                if ($('#ResultContainer_' + CT.settings.currentTab).find('#area').is(":visible")) {
                    $('.glassShield').show();
                }
                //cache the total count of hotels
                tmp = CT.cache[CT.settings.currentTab].hotelsTotalCount = searchJson.ht.length;

                this.updateShowCount(tmp);

                searchJson.checkAvail = CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch;
                //necessary to get the initial data fixes to properties
                CT.fire('updateHotelObj', [firstFewHotels, fetchHotelsJson.newResultView])
                //this.updateProperties(firstFewHotels);

                this.showBanner();

                firstFewHotels = CT.masterJson.removeHotel(firstHotelId, firstFewHotels);
                // Append the hotels list
                if (CT.subProd != "wg") {
                    html = CT.to_html(window.twoCol ? window.wgTplForHt ? 'HotelCardTpl' : window.mainTemplate : 'HotelListTpl', firstFewHotels, {
                        pricePartial: CT.to_html('HotelPricePartialTpl')
                    });
                } else {
                    html = CT.to_html('HotelCardTpl', firstFewHotels, {
                        pricePartial: CT.to_html('HotelPricePartialTpl')
                    });
                }
                if (CT.masterJson.get().tl && CT.masterJson.get().tl.length > 0 &&
                    CT.cache[CT.settings.currentTab].searchParams.all.poi &&
                    CT.isLocationEnabled == true && locationUrl.poi != "") {
                    var city = CT.cache[CT.settings.currentTab].searchParams.all.poi[0]
                    _.each(CT.masterJson.get().tl, function(hotel) {
                        if (_.include(hotel.localityName, city) && hotel.latitude) {
                            CT.cache[CT.settings.currentTab].latitude = hotel.latitude
                            CT.cache[CT.settings.currentTab].longitude = hotel.longitude
                        }
                    })
                }
                if ((CT.cache[CT.settings.currentTab].latitude == "" || CT.cache[CT.settings.currentTab].longitude == "") && CT.isLocationEnabled == true &&
                    CT.cache[CT.settings.currentTab].searchParams.all.poi && locationUrl.poi != "") {
                    var city = CT.cache[CT.settings.currentTab].searchParams.all.poi[0]
                    if (CT.masterJson.get().ar[CT.masterJson.get().city] && CT.masterJson.get().ar[CT.masterJson.get().city].length > 0 && CT.cache[CT.settings.currentTab].searchParams.all.poi != undefined) {
                        _.each(CT.masterJson.get().ar[CT.masterJson.get().city], function(hotel) {
                            if (_.include(hotel.nm, city) && hotel.latlng) {
                                CT.cache[CT.settings.currentTab].latitude = hotel.latlng[0]
                                CT.cache[CT.settings.currentTab].longitude = hotel.latlng[1]
                            }
                        })
                    }
                }
                // try {
                //     if ($('#placesApi').length == 0) {
                //         if ((CT.cache[CT.settings.currentTab].latitude == "" || CT.cache[CT.settings.currentTab].longitude == "") &&
                //             (CT.cache[CT.settings.currentTab].searchParams.all.poi != undefined &&
                //                 CT.cache[CT.settings.currentTab].searchParams.all.poi.length > 0 && locationUrl.poi != "" && CT.isLocationEnabled == true)) {
                //             var address = CT.cache[CT.settings.currentTab].searchParams.all.poi[0] + CT.cache[CT.settings.currentTab].searchParams.all.city + CT.cache[CT.settings.currentTab].searchParams.all.state
                //             $.ajax({
                //                 url: "//maps.googleapis.com/maps/api/geocode/json?address=" + address + "&sensor=false",
                //                 type: "POST",
                //                 success: function(res) {
                //                     if (res.status == "OK") {
                //                         CT.cache[CT.settings.currentTab].latitude = res.results[0].geometry.location.lat
                //                         CT.cache[CT.settings.currentTab].longitude = res.results[0].geometry.location.lng
                //                     }
                //                 }
                //             })
                //         }
                //     }
                // } catch (e) {}
                try {
                    if (CT.cache[CT.settings.currentTab].latitude == "" || CT.cache[CT.settings.currentTab].longitude == "") {
                        if (locationUrl.poi != "") {
                            if (CT.cache[CT.settings.currentTab].searchParams.all.poi != undefined && CT.cache[CT.settings.currentTab].searchParams.all.poi.length > 0) {
                                var address = CT.cache[CT.settings.currentTab].searchParams.all.poi[0] + CT.cache[CT.settings.currentTab].searchParams.all.city + CT.cache[CT.settings.currentTab].searchParams.all.state
                                if(CT.cache[CT.settings.currentTab].searchParams.all.poiLat && CT.cache[CT.settings.currentTab].searchParams.all.poiLng ){
                                    CT.cache[CT.settings.currentTab].latitude = CT.cache[CT.settings.currentTab].searchParams.all.poiLat
                                    CT.cache[CT.settings.currentTab].longitude = CT.cache[CT.settings.currentTab].searchParams.all.poiLng
                                } else {
                                    $.ajax({
                                        url: 'https://maps.googleapis.com/maps/api/geocode/json?address='+address+'&key=' + CT.settings.general.mapApiKey,
                                        type: "POST",
                                        success: function(res) {
                                            if (res.status == "OK") {
                                                CT.cache[CT.settings.currentTab].latitude = res.results[0].geometry.location.lat
                                                CT.cache[CT.settings.currentTab].longitude = res.results[0].geometry.location.lng
                                            }
                                        }
                                    });
                                }
                                // var geocoder = new google.maps.Geocoder()
                                // if (geocoder) {
                                //     geocoder.geocode({
                                //         'address': address
                                //     }, function(results, status) {
                                //         if (status == google.maps.GeocoderStatus.OK) {
                                //             CT.cache[CT.settings.currentTab].latitude = results[0].geometry.location.lat()
                                //             CT.cache[CT.settings.currentTab].longitude = results[0].geometry.location.lng()
                                //         } else {
                                //             console.log("Geocoding failed: " + status);
                                //         }
                                //     });
                            }
                        }
                    }
                } catch (e) {}

                this.$('.hotelsList ul.listView').html(html);
                //CT.utils.wallet.createWalletMarkup();
                this.$el.find(".totPriceDisp").hide();
                //set loading bar width
                this.setLoadingBar('Getting you the best rates...', '50%');
                this.$el.find('.pageLoader .meter').addClass('finishMe');

                //disable all clicks on hotel list
                this.$('li.listItem.disabled').find('a, button').attr('tabIndex', '-1');


                //add image lazy load
                //this.$('li.listItem img').setLoad(CT.utils.imgAdjust);
                this.$('li.listItem .royalSlider').royalSlider(CT.settings[CT.app].royalSliderAttrObj).css('visibility', 'visible');


                //initalizing shorlist view
                //this.setShortListView()

                //store NearByCityMap in cache - used in locality search api ( sort bar )
                CT.cache[CT.settings.currentTab].ncm = searchJson.ncm;

                // removing candy bar??
                CT.cachedElements.$candyBar.children().first().removeClass("halfway").addClass("completed");
            },



            getBadgesMarkup: function( /* Object */ badges) {
                if (badges) {
                    if (badges.bp) {
                        if (badges.bp >= 15) {
                            badges.bpCls = 15;
                        } else {
                            badges.bpCls = badges.bp;
                        }
                    }
                    /*if(window.twoCol == true){
                                            return $.trim(CT.to_html('HotelTwoLayBadgesTpl', badges));
                                        }else*/
                    return CT.to_html('HotelBadgesTpl', badges);
                } else {
                    return '';
                }

            },



            /*
             * @DESC : returns the room rates markup for a table - returns only tr
             * @PARAM : moreRooms - (defaults to 5 ) if set to an integer then more rooms link will appear if the count is exceeded
             */
            getRmsMarkup: function(rmsArr, moreRooms, hotelObj) {

                //hotel rms details display with number of deals
                var noToWordMap = {
                        "1": "one",
                        "2": "two",
                        "3": "three",
                        "4": "four",
                        "5": "five"
                    },
                    howManyMore = 0,
                    tmp, renderObj = {},
                    tmpRenderObj = {},
                    sortedRtid, shwRoomName = false;
                //hotelObj.rmn = {"330340":"Alpine Suite","330341":"Swiss Regalia","2675321":"swiss regalia 2"}
                if (hotelObj.modalV2 && hotelObj.rnm) {
                    shwRoomName = true;
                    sortedRtid = rmsArr[0].rtid;
                    tmpRenderObj = _.groupBy(rmsArr, function(obj) {
                        return obj.rtid
                    });
                    rmsArrObj = tmpRenderObj[sortedRtid];
                    if (rmsArrObj.length < 2) {
                        var tmpSorterId = rmsArr[rmsArrObj.length] ? rmsArr[rmsArrObj.length].rtid : "";
                        renderObj.rms = tmpRenderObj[sortedRtid];
                        renderObj.rms[0].rmn = hotelObj.rnm[sortedRtid];
                        if (tmpSorterId != "") {
                            tmpRenderObj[tmpSorterId][0].rmn = hotelObj.rnm[tmpSorterId]
                            renderObj.rms.push(tmpRenderObj[tmpSorterId][0])
                        }

                    } else {
                        renderObj.rms = _.first(tmpRenderObj[sortedRtid], 2);
                        renderObj.rms[0].rmn = hotelObj.rnm[sortedRtid];
                    }
                    moreRooms = 2;
                    tmp = rmsArr.length;
                    if (tmp > moreRooms) {
                        howManyMore = tmp - moreRooms;
                        renderObj.moreRooms = howManyMore + ' more ' + (howManyMore > 1 ? 'rates' : 'rate')
                    }

                } else {
                    moreRooms = Int(moreRooms) || 3;

                    //set the more rooms link
                    tmp = rmsArr.length;
                    if (tmp > moreRooms) {
                        howManyMore = tmp - moreRooms;
                        renderObj.moreRooms = howManyMore + ' more ' + (howManyMore > 1 ? 'rates' : 'rate')
                        renderObj.rms = _.first(rmsArr, moreRooms);
                    } else {
                        renderObj.rms = rmsArr;
                    }
                }

                _.forEach(renderObj.rms, function(rms) {

                    if (rms.oi) {
                        rms.oicount = noToWordMap[rms.oi.length];
                    }
                    rms.shwRoomName = shwRoomName;
                    rms.taxDisplayText = hotelObj.taxDisplayText;
                    rms.modalV2 = hotelObj.modalV2;
                    rms.modalV2Url = hotelObj.modalV2Url;
                    //format price display
                    //TODO: I dont think this line is needed. need to test and remove it - karthik
                    if (window.productCode == "AG") {
                        var costToCust = parseInt(rms.tot) + parseInt(rms.agm);
                        rms.totfmt = CT.utils.formatForCurrency(costToCust);
                    } else {
                        rms.totfmt = CT.utils.formatForCurrency(rms.tot);
                    }
                    if (window.productCode == "CP" && window.preventBooking == "true") rms.cphb = true;
                });



                //return markup
                return CT.to_html('HotelRmsRowTpl', renderObj);
            },

            /**
             * return room rate mark up for villas. returns tr
             */
            getVillasRmsMarkup: function(rmsArr, flag, pType) {
                return CT.utils.helperFunctions.getVillasRmsMarkup(rmsArr, true, pType);
            },

            /*
             * @desc : This function calculates the savings, original price and formats each for display
             * @param : tot - actual price in integer
             * @param : dis - discount price in integer
             * @param : hotel - json object - if hotel is passed then hotel will be modified and returned, else a new object will be created and returned
             */
            getDiscountMarkup: function(tot, dis, hotel, mJson) {
                var dis = parseInt(dis) || 0,
                    hotel = hotel || {};
                var totRoomNight = Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights) * Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms);
                var firstRms = hotel.priceInfo ? hotel.priceInfo.rms[0] : hotel;
                var stp = undefined;
                var stpPerRoom = undefined;
                var disPerRoom = parseInt(dis / totRoomNight) || 0;
                if (window.productCode == "AG") {
                    var agmMarkup = parseInt(firstRms.agm)
                    var tot = parseInt(tot) + agmMarkup;
                    var agmPerRoom = parseInt(agmMarkup / totRoomNight)
                    var totPerRoom = parseInt(firstRms.avg) + agmPerRoom;
                } else {
                    var tot = parseInt(tot);
                    if (window.showBundledPrice) {
                        var totPerRoom = parseInt(firstRms.avg);
                        if (firstRms.t) {
                            totPerRoom += firstRms.t;
                        }
                        if (window.enableNewStpFlow) {
                            stp = firstRms.stpd ? (firstRms.stpd.stp ? firstRms.stpd.stp : undefined) : undefined;
                            stpPerRoom = stp ? (stp / totRoomNight) : undefined;
                        }
                    } else {
                        var totPerRoom = parseInt(firstRms.avg - firstRms.st - firstRms.sbc - firstRms.kkc);
                        if (window.enableNewStpFlow) {
                            stp = firstRms.stpd ? (firstRms.stpd.stp ? firstRms.stpd.stp : undefined) : undefined;
                            stpPerRoom = stp ? (stp / totRoomNight - firstRms.st - firstRms.sbc - firstRms.kkc - (firstRms.t ? firstRms.t : 0)) : undefined;
                        }
                    }
                    //Debit total hotel price from Wallet balance
                    //var mJson = CT.masterJson.get();
                    if (mJson && mJson.wallet && mJson.wallet.hasBalance) {
                        //Total calculation
                        var wallatDebitObj = CT.utils.wallet.debitWalletBalance(tot, dis, mJson.wallet);
                        tot = wallatDebitObj.total;
                        dis = wallatDebitObj.discount;
                        mJson.wallet.remainingWalletBalance = wallatDebitObj.remainingWalletBalance;
                        //PerRoom calculation
                        wallatDebitObj = CT.utils.wallet.debitWalletBalance(totPerRoom, disPerRoom, mJson.wallet, true, totRoomNight);
                        totPerRoom = wallatDebitObj.total;
                        disPerRoom = wallatDebitObj.discount;
                        mJson.wallet.remainingWalletBalance = wallatDebitObj.remainingWalletBalance;
                        //Add amout to stp price
                        if (!stp) {
                            stp = firstRms.stpd ? (firstRms.stpd.stp ? firstRms.stpd.stp + tot : undefined) : undefined;
                        }
                        if (!stpPerRoom) {
                            stpPerRoom = stp ? (stp / totRoomNight) + totPerRoom : undefined;
                        }
                        hotel.walletEnabled = true;
                    }
                    // if(window.enableNewStpFlow){
                    //     var totPerRoom = parseInt(firstRms.avg);
                    //     if(firstRms.t){
                    //         totPerRoom += firstRms.t;
                    //     }
                    //     stp =  firstRms.stpd ? (firstRms.stpd.stp ? firstRms.stpd.stp : undefined) : undefined;
                    //     stpPerRoom = stp ? (stp/totRoomNight) : undefined;
                    // }else{
                    //     var totPerRoom = parseInt(firstRms.avg - firstRms.st - firstRms.sbc - firstRms.kkc);
                    // }
                }
                if (dis > 0) {
                    /*  hotel.discPercPerRoom = CT.utils.helperFunctions.calDiscountPercent(disPerRoom, totPerRoom);
                                            hotel.discPercIntPerRoom = Int(hotel.discPerc);
                                            hotel.oamtPerRoom = CT.to_html('CurrencyFormatTpl', CT.utils.formatForCurrency(totPerRoom + disPerRoom, false, null, true));
                                            hotel.savPerRoom = CT.to_html('CurrencyFormatTpl', CT.utils.formatForCurrency(disPerRoom, false, null, true));
                                            hotel.discPerc = CT.utils.helperFunctions.calDiscountPercent(dis, tot);
                                            hotel.discPercInt = Int(hotel.discPerc);
                                            hotel.oamt = CT.to_html('CurrencyFormatTpl', CT.utils.formatForCurrency(tot + dis, false, null, true));
                                            hotel.sav = CT.to_html('CurrencyFormatTpl', CT.utils.formatForCurrency(dis, false, null, true));
                                            */

                    hotel.discPercPerRoom = CT.utils.helperFunctions.calDiscountPercent(disPerRoom, totPerRoom);
                    hotel.discPercIntPerRoom = Int(hotel.discPerc);
                    hotel.oamtPerRoom = CT.utils.formatForCurrency(totPerRoom + disPerRoom, false, null, false);
                    if (window.enableNewStpFlow && stp != undefined) {
                        hotel.oamtPerRoom = CT.utils.formatForCurrency(stpPerRoom, false, null, false);
                    }
                    if (wallatDebitObj && wallatDebitObj.hideSaving) {
                        hotel.savPerRoom = "";
                        hotel.sav = "";
                    } else {
                        hotel.savPerRoom = CT.utils.formatForCurrency(disPerRoom, false, null, false);
                        hotel.sav = CT.utils.formatForCurrency(dis, false, null, false);
                        hotel.showsaveText = true;
                    }
                    hotel.discPerc = CT.utils.helperFunctions.calDiscountPercent(dis, tot);
                    hotel.discPercInt = Int(hotel.discPerc);
                    hotel.oamt = CT.utils.formatForCurrency(tot + dis, false, null, false);
                    hotel.stp = stp;
                    hotel.enableNewStpFlow = window.enableNewStpFlow;
                    hotel.showBundledPrice = window.showBundledPrice;
                } else {
                    hotel.oamt = "";
                    hotel.sav = "";
                    hotel.oamtPerRoom = "";
                    hotel.savPerRoom = "";
                    hotel.enableNewStpFlow = window.enableNewStpFlow;
                    hotel.showBundledPrice = window.showBundledPrice;
                }
                //hotel.totfmt = CT.to_html('CurrencyFormatTpl', CT.utils.formatForCurrency(tot, false, null, true));
                //hotel.totfmtPerRoom = CT.to_html('CurrencyFormatTpl', CT.utils.formatForCurrency(totPerRoom, false, null, true));
                //Wallet open question;
                if (hotel.bfo == 1) {
                    hotel.tdtfmt = CT.utils.formatForCurrency(hotel.priceInfo.rms[0].tdt, false, null, false);
                }

                hotel.totfmt = CT.utils.formatForCurrency(tot, false, null, false);
                hotel.totfmtPerRoom = CT.utils.formatForCurrency(totPerRoom, false, null, false);


                hotel.discPerc = "0";
                hotel.discPercInt = "0";
                return hotel;
            },
            updateItem: function(hotel, offer) {
                var discount, dataItem = $.extend(true, {}, hotel.priceInfo),
                    hotelTag = this.$el.find('#' + hotel.id),
                    html,
                    priceDiv,
                    firstRms,
                    temp;
                
                if (hotelTag) {
                    priceDiv = hotelTag.find('li.rate');
                    firstRms = dataItem.rms[0];
                    hotelTag.removeClass('disabled').attr({
                        'data-deal': firstRms.d,
                        'data-price': firstRms.tot,
                        'data-bookingcode': firstRms.rmtc,
                        'data-roomtypecode': firstRms.rtc
                    }).find('a, button').removeAttr('tabIndex');

                    //TODO: discount percent calculation - requirement changed - confirm and remove - karthik
                    //discount = this.calDiscount(firstRms.d, firstRms.tot);
                    priceDiv.find('.dotDotDot').remove();
                    priceDiv.find('.strikeOut').html(CT.utils.formatForCurrency(firstRms.tot + firstRms.d));
                    priceDiv.find('strong').html(CT.utils.formatForCurrency(firstRms.tot));
                    temp = CT.utils.formatForCurrency(firstRms.d);
                    html = CT.to_html(CT.messages[CT.app].youSave, {
                        d: temp
                    });
                    priceDiv.find('.special').html(html);

                    hotelTag.removeClass('disabled').attr({
                        'data-deal': firstRms.d,
                        'data-price': firstRms.tot
                    }).find('a, button').removeAttr('tabIndex');

                    //deal information display
                    if (dataItem.oi >= 0) {
                        hotelTag.find('p.deal').append(offer[dataItem.oi].hd);
                    }

                    //add badges
                    //this.getBadgesMarkup(hotel.sb);
                    if (window.productCode == "CP") {
                        if (hotel.priceInfo.pvs) hotel.sb.pvs = true;
                        if ((html = this.getBadgesMarkup(hotel.sb)) != '') {
                            hotelTag.find('li.trust ul.hotelBadges').html(html);
                        }
                        if (hotel.priceInfo.pvs) delete hotel.sb.pvs;
                    } else {
                        if ((html = this.getBadgesMarkup(hotel.sb)) != '') {
                            hotelTag.find('li.trust ul.hotelBadges').html(html);
                        }
                    }


                    //hotel rms update
                    if (hotel.viw)
                        html = this.getVillasRmsMarkup(hotel.priceInfo.rms, false, (hotel.pt ? hotel.pt[0].name : ""));
                    else
                        html = this.getRmsMarkup(hotel.priceInfo.rms, undefined, hotel);
                    hotelTag.find('.quickLook table tbody').html(html);

                    //handle trusted hotel case
                    if (hotel.priceInfo.tc) {
                        hotelTag.find('.quickLook').attr('data-tc', '1');
                    }
                }
            },
            // The following functions added by Vijay Krishna For PRM-14000 //Bases upon the Property CT.isLocationEnabled
            toggleTopPlaces: function(evt) { //Toggle handler for the topLocations suggestions box
                if (evt.target.value.length == 0) {
                    $(".topLocSuggest").show();
                } else {
                    $(".topLocSuggest").hide();
                }
            },
            checkPlaceSelected: function(e) {
                console.warn("checkPlaceSelected");
                if (!CT.cache[CT.settings.currentTab].autocompleteValSelected) {
                    var localitySearchString = e.target.value;
                    CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_locality_search", {
                        "searchQuery": localitySearchString,
                        "lenSearchedItem": String(localitySearchString.length),
                        "selectedLocation": "N/A",
                        "distanceFromCurrentSearch": "N/A",
                        "dropOff": "Yes"
                    });
                }
            },
            showTopPlaces: function(evt) { //Event handler for creating the TopLocSuggestionTpl
                evt.preventDefault();
                if (CT.isLocationEnabled == true && window.showTopLocationsInSrp == "true") {
                    if (($(evt.currentTarget).val() == $(evt.currentTarget).attr("placeholder") || $(evt.currentTarget).val() == "") && evt.type === 'focusin' && CT.masterJson.get().tl) {
                        //Top locations to the template
                        if (!this.$el.find(".topLocSuggest").length) {
                            var topPlaces = {};
                            var spoonForm = $(evt.target).closest("div .spoonForm");
                            var offset = spoonForm.offset();
                            var width = parseInt(spoonForm.width() - 5);
                            var top = parseInt(offset.top + 68),
                                left = parseInt(offset.left + 5);
                            topPlaces.placesArray = CT.masterJson.get().tl;
                            //Push Top ranked things into a array
                            var topRankArray = [];
                            var list = topPlaces.placesArray;
                            for (var i in list) {
                                if (list[i].rank == 1)
                                    topRankArray.push(list[i])
                            }
                            //Update the Obj array to show Custom messages for POI's
                            var item = topRankArray;
                            for (var i in item) {
                                if (item[i].type == "P" || item[i].type === "R" || item[i].type === "F") {
                                    if (item[i - 1]) {
                                        if (item[i - 1].type == 'A')
                                            item[i].showHR = true;
                                    } //Flag for indicating the end of locations in the Suggestions Box
                                    if (item[i].type == "R") {
                                        item[i].msgToTpl = "Railway Station";
                                        item[i].ep = true;
                                    } else if (item[i].type == "F") {
                                        item[i].msgToTpl = "Airport";
                                        item[i].ep = true
                                    }
                                    item[i].poi = "true"; //Flag for handling POI items,to maintain the POI flow
                                }
                            }
                            topPlaces.placesArray = item;
                            var html = CT.to_html("TopLocSuggestionTpl", topPlaces);
                            this.$el.find(".spoonForm").append(html);
                        } else
                            this.$el.find(".topLocSuggest").show();
                    } else
                        this.$el.find(".topLocSuggest").hide();
                    var handler = function(e) {
                        if ($(e.target).is(".topLocSuggest *,#showNearByBox,#clearLocationSort", "#mapAutocomplete")) {
                            $("#ResultContainer_" + CT.settings.currentTab).find(".topLocSuggest").show();
                            return;
                        }
                        $(document).off("click", handler);
                        $("#ResultContainer_" + CT.settings.currentTab).find(".topLocSuggest").hide();
                    }
                    $(document).on("click", handler);
                }
            },
            updateLocationSearch: function(evt) { //Function to handle sorting of near by places----Added for PRM-14000
                // console.log("updateLocationSearch");
                var locationText = $.trim($(evt.currentTarget).attr("data-name"));
                var city = CT.cache[CT.settings.currentTab].searchParams.all.city;
                var state = CT.cache[CT.settings.currentTab].searchParams.all.state;
                var formatted_address = locationText + "," + city + "," + state + ",India";
                if ($(evt.target).attr("data-entrypoint") != "") {
                    var typeOfArea = "entryPoint"
                } else {
                    var typeOfArea = $(evt.target).attr("location-type");
                }
                $(".showNearBy").val(formatted_address);
                var latLng = $(evt.currentTarget).attr("data-coordinates").split(",");
                var ele = this.$el.find("#locationBasedHotels");
                ele.find("button").addClass("loading");
                $(".topLocSuggest").hide();
                this.sortPlacesnearby(parseFloat(latLng[0]), parseFloat(latLng[1]), formatted_address, ele, true, "ctAutocomplete", typeOfArea);
            },
            showClearButton: function(evt) { //Handler for the clear button
                if ($(evt.currentTarget).find("#showNearByBox").val() == $(evt.currentTarget).find("#showNearByBox").attr("placeholder") || $(evt.currentTarget).find("#showNearByBox").val() == "")
                    $(evt.currentTarget).find(".clearFieldAuto").hide();
                else if ($(evt.currentTarget).find("#showNearByBox").val().length > 0)
                    $(evt.currentTarget).find(".clearFieldAuto").show();
            },
            hideClearButton: function(evt) {
                evt.preventDefault();
                $(evt.currentTarget).find(".clearFieldAuto").hide();
            },
            showClearButtonMap: function(evt) {
                if ($(evt.currentTarget).find("#mapAutocomplete").val() == $(evt.currentTarget).find("#mapAutocomplete").attr("placeholder") || $(evt.currentTarget).find("#mapAutocomplete").val() == "")
                    $(evt.currentTarget).find(".clearFieldAuto").hide();
                else if ($(evt.currentTarget).find("#mapAutocomplete").val().length > 0)
                    $(evt.currentTarget).find(".clearFieldAuto").show();
            },
            hideClearButtonMap: function(evt) {
                evt.preventDefault();
                $(evt.currentTarget).find(".clearFieldAuto").hide();
            },
            //PRM-14000 ends here



            updateCallback: function() {
                var mjson = CT.masterJson.get();
                if (!mjson || !CT.cache[CT.settings.currentTab].filterValues) {
                    return false;
                }
                var updateCallback = CT.settings.hotel.updateCallback,
                    tabCache = CT.cache[CT.settings.currentTab],
                    tmp, showGnBannerByDefault = false,
                    html;
                var isCTUser = unescape(CT.utils.cookies.read('userid')).indexOf('@cleartrip.com');
                var $currentTab = $("#ResultContainer_" + CT.settings.currentTab);
                var diff = CT.utils.diffDates(CT.utils.getTodayDate(), tabCache.searchParams.all.chk_in)
                var gnTriggered = false;
                var chkIn = "";
                var chkOut = "";
                //var pinPointSearchParams;
                //onload run functions
                if (tabCache.onLoad) {
                    this.$el.find(".propertySection").removeClass("slideMeDown");


                    /*
                    var famousPlaces = _.filter(_.sortBy(CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data, function(data){ return -data.cnt }), function(item,key) {
                        return key < 2
                        })
                    var topThreePlaces = {};
                    _.each(famousPlaces, function(item, key){
                            topThreePlaces[key] = item.loc;
                    });
                    */

                    if (CT.subProd !== "wg" && CT.isLocationEnabled ) {
                        // creating callback for after loading places autocomplete
                        var area = CT.cache[CT.settings.currentTab].searchParams.all.area;
                        var poi = CT.cache[CT.settings.currentTab].searchParams.all.poi;
                        window.placesAutoComplete = function(e) {
                            $('#ResultContainer_' + CT.settings.currentTab).trigger('loadPlacesAutocomplete')
                        }
                        var getLocationBar = CT.to_html('LocationSearchTpl', {
                            location: CT.cache[CT.settings.currentTab].searchParams.all.city
                        });
                        $('#ResultContainer_' + CT.settings.currentTab).find('.listViewSecondaryBar').prepend(getLocationBar);
                        this.$el.find(".googleWidget").hide();
                        //TO REMOVE LOCALITY SEARCH FROM SRP
                        // $('#localitySearchDiv').html('&nbsp;')
                        if ($("#placesApi").length == 0)
                            CT.getScript({
                                src: '//maps.googleapis.com/maps/api/js?libraries=places&callback=placesAutoComplete&key=' + ((window.productCode == "CP") ? CT.settings.general.mapApiKeyCP : CT.settings.general.mapApiKey),
                                id: 'placesApi'
                            });
                        else
                            window.placesAutoComplete();
                        // }
                        if (CT.isLocationEnabled == true) {
                            if (!area && !poi) {
                                this.$el.find(".googleWidget").show();
                            } else if ((area && area[0] == "") && (poi && poi[0] == ""))
                                this.$el.find(".googleWidget").show();

                        } else
                            this.$el.find(".googleWidget").show();
                        //::TODO Need to check the hide block
                        if ( !!window.enableLocalityFilter ) { 
                            this.$el.find(".locality").closest(".sideBlock").hide()
                        }
                        
                    }
                    //Hide the location filter if the area and Poi data are not 
                    if ($.isEmptyObject(mjson.ar))
                        this.$el.find(".locality").closest(".sideBlock").hide()
                    //TA Tracking Pixel
                    var taPixel = new Image();
                    taPixel.src = "http://www.tripadvisor.com/img/cdsi/partner/transparent_pixel-11376-1.gif";
                    document.body.appendChild(taPixel);

                    if (CT.subProd && CT.subProd == "wg") {
                        $("#Tags").val("");
                    } else if (CT.subProd == undefined && CT.settings[CT.app].weekendDestinations.indexOf(CT.cache[CT.settings.currentTab].searchParams.all.city) == -1) {
                        $("#wgSelectChoosen").val("");
                    }


                    var getCity = CT.cache[CT.settings.currentTab].searchParams.all.city;
                    var boldChatInit = getCity === 'Goa' || getCity === 'Munnar' || getCity === 'Ooty' || getCity === 'Bangalore';
                    if (CT.subProd !== "wg" && (window.countryCode == 'in' && boldChatInit && window.enableLiveEngage)) {
                        CT.utils.helperFunctions.setupBoldChatOnLoad();
                    }

                    if (tabCache.searchParams.all.chk_out != "" && tabCache.searchParams.all.chk_in != "") {
                        chkIn = tabCache.searchParams.all.chk_in.split("/")[0] + "-" + tabCache.searchParams.all.chk_in.split("/")[1] + "-" + tabCache.searchParams.all.chk_in.split("/")[2];
                        chkOut = tabCache.searchParams.all.chk_out.split("/")[0] + "-" + tabCache.searchParams.all.chk_out.split("/")[1] + "-" + tabCache.searchParams.all.chk_out.split("/")[2];
                    }
                    tabCache.pinPointSearchParams = {
                        "city": tabCache.searchParams.all.city,
                        "cc": tabCache.searchParams.all.country,
                        "co": chkOut,
                        "ci": chkIn,
                        "adt": tabCache.searchParams.all.adults,
                        "chd": tabCache.searchParams.all.childs,
                        "rms": tabCache.searchParams.all.num_rooms
                    }
                    if (tabCache.searchParams.all.hotelName && tabCache.searchParams.all.hotelName != '' && tabCache.searchParams.all.utm_source != "gosf") {
                        updateCallback.onload[0](tabCache.searchParams.all.hotelName, this.$el);
                    }
                    if (tabCache.searchParams.all.poi && tabCache.searchParams.all.poi[0] != "") {
                        tabCache.prevAddedLoc.push(tabCache.searchParams.all.poi[0]);
                    }
                    if (tabCache.searchParams.all.area && tabCache.searchParams.all.area[0] != "") {
                        tabCache.prevAddedLoc.push(tabCache.searchParams.all.area[0]);
                    }
                    if (CT.settings[CT.app].guidedNavEnabled && CT.cache[CT.settings.currentTab].isCitySearch === true && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
                        if (CT.settings[CT.app].guidedNavForCTUsers) {
                            if (isCTUser != -1) {
                                // $(".viewSwitchers ul").addClass("col col8");
                                $(".powerFilters ul").addClass("span span12");
                                $currentTab.find(".pinPointTab").show()
                                gnTriggered = true;
                                tabCache.pinPointCurrStep = 0;
                            }
                        }
                        /*else {
                              //$(".viewSwitchers ul").addClass("col col8");
                              $(".powerFilters ul").addClass("span span12"); 
                              $currentTab.find(".pinPointTab").show()
                              tabCache.pinPointCurrStep = 0;
                          }*/
                        if (gnTriggered === false && (CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "34600" || CT.cache[CT.settings.currentTab].searchParams.all.dest_code === "32550")) {
                            $(".powerFilters ul").addClass("span span12");
                            $currentTab.find(".pinPointTab").show()
                            tabCache.pinPointCurrStep = 0;
                        }

                    }
                    /*if(CT.settings[CT.app].guidedNavEnabled && !tabCache.dontShowGNonScroll) {
                                              if(CT.settings[CT.app].guidedNavForCTUsers) {
                                                  if(isCTUser != -1){
                                                      CT.fire('guidedNavTrigger');
                                                  }
                                              } else {
                                                  CT.fire('guidedNavTrigger')
                                                 
                                              }
                                            }*/

                    if (CT.settings.hotel.gnShowPerSession == true) {
                        var gnShownSession = sessionStorage.getItem("gnShownSession");
                        if (gnShownSession == null || gnShownSession == 'undefined') {
                            updateCallback.onload[3](this.$el);
                        }
                    } else {
                        if (CT.utils.cookies.read("gnLastShown")) {
                            var currTime = moment();
                            var timeDiffHr = currTime.diff(parseInt(CT.utils.cookies.read("gnLastShown")), 'hours');
                            if (timeDiffHr <= CT.settings.hotel.guidedNavDefaultShowCookieHrs) {
                                showGnBannerByDefault = true;
                            }
                        }
                        if (showGnBannerByDefault === true) {
                            updateCallback.onload[3](this.$el);
                        }
                    }

                    setTimeout(function() {
                        if (CT.subProd != "wg" && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false && window.prDispUnit === "true" && CT.utils.cookies.read("priceDispTipsyShown") === null) {
                            $currentTab.find(".priceDispHeader ul").attr("data-tipsytitle", CT.messages.hotel.ViewPricesInURWay).tipsy({
                                gravity: 'N',
                                trigger: 'manual',
                                className: 'popOver priceDispTipsy',
                                html: true,
                                opacity: 1,
                                title: "data-tipsytitle",
                                addCloseButton: true
                            }).tipsy('show');
                            $('.priceDispTipsy').find("a.close").click(function() {
                                $('.priceDispTipsy').fadeOut();
                                CT.utils.cookies.create("priceDispTipsyShown", true, 365);
                            })
                            setTimeout(function() {
                                $('.priceDispTipsy').fadeOut();
                                CT.utils.cookies.create("priceDispTipsyShown", true, 365);
                            }, 7000)



                        }
                        if (CT.subProd != "wg" && CT.cache[CT.settings.currentTab].lastBooked && CT.cache[CT.settings.currentTab].lastBooked == true && CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
                            var islastBookedAvail = CT.masterJson.getHotel(CT.cache[CT.settings.currentTab].lastBookedHotelId);
                            if (islastBookedAvail.priceInfo) {
                                $currentTab.find('.hotelsList ul.listView li:first .summary .info h2 a').attr("data-tipsytitle", "Your last booked hotel in " + tabCache.searchParams.all.city).tipsy({
                                    gravity: 'W',
                                    trigger: 'manual',
                                    className: 'popOver lastBookedHotel',
                                    html: true,
                                    opacity: 1,
                                    title: "data-tipsytitle",
                                    addCloseButton: false
                                }).tipsy('show');
                                $('.lastBookedHotel').find("a.close").click(function() {
                                    $('.lastBookedHotel').fadeOut();
                                })
                                setTimeout(function() {
                                    $('.lastBookedHotel').fadeOut();
                                }, 7000)
                            }

                        }

                    }, 1200);

                    if (CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch == true) {
                        $($currentTab.find(".priceDispHeader ul li")[0]).hide();
                        this.$el.find('.mapViewLocationSearch').css('display', 'none')
                        $currentTab.find(".perRoomPerNightDispHeader").closest("li").hide();
                        $currentTab.find(".totPriceDispHeader").trigger("click");
                    }

                    //open the first hotel quick look table
                    if (openFirstHotelQuickLook == true)
                        this.$el.find('.hotelsList ul.listView li:first .tools .booking.openQuickLook').trigger('click');

                    if (CT.subProd && CT.subProd == "wg" && window.altFilters == "true") {
                        var minPrice = CT.utils.formatForCurrency(CT.cache[CT.settings.currentTab].filterValues.priceMinMax.min, false, null, false);
                        var maxPrice = CT.utils.formatForCurrency(CT.cache[CT.settings.currentTab].filterValues.priceMinMax.max, false, null, false);
                        $currentTab.find(".priceFilterButton small").html(minPrice + " to " + maxPrice);
                        //$currentTab.find(".distanceFilterButton small").html("Time from "+CT.cache[CT.settings.currentTab].searchParams.processed.from)
                        $currentTab.find(".weekendFilterPopup").css({
                            "width": $currentTab.find(".filterCol").outerWidth()
                        })
                    }

                    if (CT.subProd && CT.subProd == "wg") {
                        //CT.utils.helperFunctions.inspectLetJsForHotels();
                    } else if (CT.settings[CT.app].inspectLetCity.indexOf(mjson.city.toString()) != -1) {
                        CT.utils.helperFunctions.inspectLetJsForHotels();
                    }
                    if (window.prDispUnit === "true") {
                        if (CT.utils.cookies.read("prDispUnitEle") === null) {
                            // read abtest cookie.
                            if (window.taxAbTest == 'a' || window.taxAbTest_A == 'b') {
                                CT.cache[CT.settings.currentTab].prDispUnitEle = "perRoomPerNightDispHeader";
                            } else {
                                CT.cache[CT.settings.currentTab].prDispUnitEle = "totPriceDispHeader";
                            }
                        } else {
                            CT.cache[CT.settings.currentTab].prDispUnitEle = CT.utils.cookies.read("prDispUnitEle")
                        }
                        if (CT.cache[CT.settings.currentTab].prDispUnitEle == "perRoomPerNightDispHeader") {
                            cf.updateFilter('price', {
                                min: CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax != undefined ? CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax.min : 0,
                                max: CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax != undefined ? CT.cache[CT.settings.currentTab].filterValues.avgPriceMinMax.max : 0,
                                name: 'price'
                            }, null, true)
                        } else {
                            cf.updateFilter('price', {
                                min: CT.cache[CT.settings.currentTab].filterValues.priceMinMax != undefined ? CT.cache[CT.settings.currentTab].filterValues.priceMinMax.min : 0,
                                max: CT.cache[CT.settings.currentTab].filterValues.priceMinMax != undefined ? CT.cache[CT.settings.currentTab].filterValues.priceMinMax.max : 0,
                                name: 'price'
                            }, null, true)
                        }
                    }

                    var filteredBlockEle = this.$el.find('.filtersForm').find("div.sideBlock:visible nav");
                    CT.cache[CT.settings.currentTab].filtersShown = ["price", "taStarRating", "smallSearch"];
                    for (var k = 0; k < filteredBlockEle.length; k++) {
                        CT.cache[CT.settings.currentTab].filtersShown.push($(filteredBlockEle[k]).attr("class"))
                    }
                    if (CT.subProd != "wg") {
                        // this.showDodInHotelsList();
                    }
                }
                if (window.prDispUnit === "true") {
                    if (this.$el.find('[name="badgeFilter"]').val() != "onlyAirBnb") {
                        this.$el.find("aside.filters .smallSearch").closest(".sideBlock").show();
                    }
                    if (CT.utils.cookies.read("prDispUnitEle") === null) {
                        // read abtest cookie.
                        if (window.taxAbTest == 'a' || window.taxAbTest_A == 'b') {
                            CT.cache[CT.settings.currentTab].prDispUnitEle = "perRoomPerNightDispHeader";
                        } else {
                            CT.cache[CT.settings.currentTab].prDispUnitEle = "totPriceDispHeader";
                        }

                        this.prDispUnitToggle(CT.cache[CT.settings.currentTab].prDispUnitEle);
                    } else {
                        CT.cache[CT.settings.currentTab].prDispUnitEle = CT.utils.cookies.read("prDispUnitEle")
                        this.prDispUnitToggle(CT.cache[CT.settings.currentTab].prDispUnitEle);
                    }
                    CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_' + CT.cache[CT.settings.currentTab].prDispUnitEle, CT.cache[CT.settings.currentTab].paramsForGA, '100');
                } else {
                    $currentTab.find(".perRoomPrDisp").hide();
                }

                if (CT.subProd != "wg") {
                    //CT.utils.cloneUpsellBanner();
                }



                /*if(CT.subProd != "wg"){
        //              if(diff > 2){
        //                  if(CT.settings.showCollection && CT.settings.showCollection === true && CT.cache[CT.settings.currentTab].srpCollection == undefined){
        //                      this.getCollection(this.$el.find('.hotelsList ul.listView'), 0,  20);
        //                  }
        //              }else{
        //                  if(CT.cache[CT.settings.currentTab].srpUpsell == undefined){
        //                      CT.cache[CT.settings.currentTab].srpUpsell = {'results' : CT.masterJson.get().ht, 'elemCount' : 5, 'collectionCount' : 0};
        //                      this.showUpsellInHotelsList(this.$el.find('.hotelsList ul.listView'), 0, 20)
        //                  }
                            
                            
                                var currentDiv = $('#ResultContainer_' + CT.settings.currentTab).find('.flightHotelSRPUpsells'),html;
                                if(currentDiv.length == 0){
                                    var $liElems = $('#ResultContainer_' + CT.settings.currentTab).find(".listItem");
                                    if($liElems.length > 0){
                                        if(CT.cache[CT.settings.currentTab].showUpsellBanner == undefined && diff < 2){
                                            html = CT.to_html('upsellBanner', {"upsellBanner":true,'product':"Hotels","upselltext":CT.messages.hotel.GetExclusiveDeals,"upsellhead":CT.messages.hotel.MakeLastMinPlan});
                                        }else{
                                            html = CT.to_html('upsellBanner', {"upsellBanner":true,'product':"Hotels","upselltext":CT.messages.hotel.getBestOfferDeals,"upsellhead":CT.messages.hotel.LookForDealHotel});
                                            if(CT.settings.showCollection && CT.settings.showCollection === true && CT.cache[CT.settings.currentTab].srpCollection == undefined){
                                                this.getCollection(this.$el.find('.hotelsList ul.listView'), 0,  20);
                                            }
                                        }
                                        $($liElems[4]).after(html);
                                        
                                        CT.utils.helperFunctions.trackGAEvent('Hotels','Render','srp_mobile_upsell_impression','100');
                                        CT.cache[CT.settings.currentTab].showUpsellBanner = false;
                                    }
                                }
                            //}
                        
                        }*/

                //always run functions
                if (CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
                    updateCallback.always[0](this.$el);
                }


                updateCallback.always[1](this.$el);
                // Author: Bhimsen S K
                var imgElements = $(".photoMask").find("img"),
                    parents = $(".photoMask").has("img");
                $(".photoMask").find("img").setLoad(CT.utils.imgAdjust);
                /*$.each(imgElements, function(index, value){
                                        //CT.utils.helperFunctions.imageToDiv(parents[index], value, ["tittle", "style"], ["position", "opacity", "width", "top"], {width:100, height:100});
                                    });*/
                tabCache.onLoad = false;
            },



            showOverlayWarning: function(e, msgObj) {
                var top = 0,
                    $srpOverlay = $('#SrpOverlay'),
                    $srpOverlayWarning = $('#SrpOverlayWarning'),
                    $warningMarkers = $('.warningMarkers'),
                    $currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                    html, tmp;

                /*
                                     * old code used to place the images(pointer images) with respect to the refElement in the messages object
                                    //add noscroll to body and html
                                    $('body, html').addClass('noScroll');
                                    if(msgObj.excludeHeader) {
                                        if(CT.app == 'hotel')
                                            top = $('#GlobalNav').outerHeight() + $('.modify').outerHeight();
                                    }

                                    //display overlay
                                    $srpOverlay.show().css({ top: top + 'px', height: $(window).height() - top + 'px'});

                                    //display center message
                                    html = Mustache.to_html($("#BlankSreenTemplate").html(), msgObj);
                                    $srpOverlayWarning.show().html(html);
                                    */

                //Below code needs to be generalized...
                if (window.productCode !== 'AG') {
                    var tempCache = CT.cache[CT.settings.currentTab].searchParams.processed;
                    var wgCites = CT.settings[CT.app].wgCitylist;

                    function findWgCity(cVal) {
                        var _city = false;
                        _.each(CT.settings[CT.app].wgCitylist, function(i, j) {
                            if (i[cVal])
                                _city = i[cVal];
                        });
                        return _city;
                    }
                    var _findWgCity = findWgCity(tempCache.city);

                    if (_findWgCity) {
                        msgObj = {
                            cls: "hotels",
                            wgMsg: true,
                            title: "Sorry, hotels in " + tempCache.city + " are completely booked on these dates.",
                            subTitle: "Why not try other weekend destinations around " + tempCache.city + "?",
                            wgBtntxt: "Search hotels around " + tempCache.city,
                            wgBtnlink: "/getaways/results?" + window.location.href.split('results?')[1].replace('city', 'from').replace(tempCache.city, _findWgCity.c).replace(tempCache.state.replace(' ', '+'), _findWgCity.s),
                            hrefLink: "/hotels"
                        }
                    }
                }

                $('body, html').addClass('noScroll');
                if (window.isMobileUA && window.isMobileUA == true) {
                    $currentTab.append(CT.to_html('BlankSreenMobileTemplate', msgObj));
                } else {
                    $currentTab.append(CT.to_html('BlankSreenTemplate', msgObj));
                }
                $currentTab.find(' section.viewContainer, section.primaryBar').hide();
                $currentTab.find('#area').hide();
                $currentTab.find('.messageScreen').css('min-height', CT.utils.setElementSize([".globalNav", ".globalFooter"], 'height')).css('min-height');
                $('.glassShield').hide();

                /* old code used to put tipsy on modify search bar fields
                                    if(msgObj.showThis)
                                        $(msgObj.showThis).show();

                                    //initialize tooltip
                                    tmp = $(msgObj.refElement).attr('data-tipsytitle', msgObj.tipsyTitle)

                                    tmp.tipsy({ trigger : 'manual', addCloseButton : true, title : 'data-tipsytitle'}).tipsy('show');


                                    //old code used to place the images(pointer images) with respect to the refElement in the messages object
                                    $srpOverlayWarning.css({
                                        left: (($srpOverlay.outerWidth() - $srpOverlayWarning.outerWidth())/2) + 'px',
                                        top: (($srpOverlay.outerHeight() - $srpOverlayWarning.outerHeight())/2) + 'px'
                                    });


                                    if(msgObj.errorType) {
                                        $warningMarkers.show().addClass(msgObj.errorType);
                                        tmp = $(msgObj.refElement).offset();
                                        $warningMarkers.css({
                                            top: tmp.top + msgObj.top + 'px',
                                            left: tmp.left + msgObj.left + 'px'
                                        });
                                    }
                                    */

            },



            setLoadingBar: function(status, width, showHide) {
                if (window.isMobileUA && window.isMobileUA == true) {
                    if (!this.$loadingBar) {
                        this.$loadingBar = this.$el.find('.loadingContainer');
                        this.$loaderContainer = this.$el.find('.loadingResults');
                    }
                    var $loadingBar = this.$loadingBar,
                        $loaderContainer = this.$loaderContainer;

                    if (status)
                        $loaderContainer.find('.loadState').html(status);

                    if (showHide) {
                        if (showHide == 'show') {
                            $loaderContainer.show();
                        } else {
                            $loaderContainer.hide();
                        }
                    }
                } else {
                    if (!this.$loadingBar) {
                        this.$loadingBar = this.$el.find('.pageLoader');
                        this.$meter = this.$loadingBar.find('.progress').children().first();
                        this.$loaderContainer = this.$el.find('.loaderContainer');
                    }

                    var $loadingBar = this.$loadingBar,
                        $meter = this.$meter,
                        $loaderContainer = this.$loaderContainer;

                    if (status)
                        $loadingBar.find('.loadState').html(status);

                    if (width)
                        $loadingBar.find('.meter').css('width', width);

                    if (showHide) {
                        if (showHide == 'show') {
                            $loadingBar.show();
                        } else {
                            $meter.css({
                                "-moz-transition": "all 0s ease-out 0s",
                                "-webkit-transition": "all 0s ease-out 0s",
                                "transition": "all 0s ease-out 0s"
                            });
                            $meter.css('width', "100%");
                            setTimeout(function() {
                                $loadingBar.addClass('squeezeMe');
                                setTimeout(function() {
                                    $loaderContainer.hide();
                                    $meter.removeAttr('style');
                                    var availCount = 0;
                                    var unAvailCount = 0;
                                    _.each(CT.masterJson.get().ht, function(item, ind) {
                                        if (item.priceInfo) {
                                            availCount += 1;
                                        } else {
                                            unAvailCount += 1;
                                        }
                                    })

                                    if (CT.cache[CT.settings.currentTab].dodHotelList && CT.cache[CT.settings.currentTab].dodHotelList.length > 0) {
                                        window.DoTd_count = CT.cache[CT.settings.currentTab].dodHotelList.length;
                                    }
                                    if ($("#Tags").length > 0 && $("#Tags").attr('locationSelected')) {
                                        // CT.utils.trackers.mixpanelTrackingData.destinationCity = $("#Tags").attr('locationSelected')
                                        CT.utils.trackers.clevertapGlobleData.selectedDestination = $("#Tags").attr('locationSelected')
                                    }
                                    //  else {
                                    //     CT.utils.trackers.mixpanelTrackingData.destinationCity = masterJSON.cnm
                                    // }
                                    // CT.utils.trackers.mixpanelTrackingData.destinationCountryCode = $('#Country').val() ? $('#Country').val() : "N/A"
                                    CT.utils.trackers.clevertapGlobleData.destinationCountry = $('#Country').val() ? $('#Country').val() : "N/A"
                                    CT.cache[CT.settings.currentTab].autocompleteValSelected = false
                                    CT.cache[CT.settings.currentTab].removeGoogleSearch = false
                                    CT.utils.trackers.clevertapGlobleData.marketNature = masterJSON.hmn ? masterJSON.hmn : "N/A";
                                    CT.utils.trackers.clevertapGlobleData.destinationCity = masterJSON.cnm ? masterJSON.cnm : "N/A";
                                    var shortlistedCount = CT.masterJson.getShortListedHotelCount();
                                    CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_Searched', {
                                        pageName: "SRP",
                                        hotelDetails: "NA",
                                        searchCategorySelected: String(CT.utils.trackers.eventData.categorySelected ? CT.utils.trackers.eventData.categorySelected : "NA"),
                                        searchType: String(CT.utils.trackers.eventData.searchType ? CT.utils.trackers.eventData.searchType : "NA"),
                                        searchedItem: String(CT.utils.trackers.eventData.searchedString ? CT.utils.trackers.eventData.searchedString : "NA"),
                                        selectedDestination: masterJSON.cnm ? masterJSON.cnm : "N/A",
                                        timeSpent: "NA",
                                        pageLoadTime: String(Date.now() - CT.utils.trackers.eventData.pageLoadStartTime),
                                        featuredRank: "NA",
                                        userRank: "NA",
                                        srpFeatures: "NA",
                                        starRating: "NA",
                                        taRating: "NA",
                                        taReviewsCount: "NA",
                                        hotelType: "NA",
                                        PAH: "NA",
                                        "checkin_date": CT.cache[CT.settings.currentTab].searchParams.processed.chk_in ? new Date(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, "DD/MM/YYYY").format("YYYY-MM-DD")) : "N/A",
                                        "checkout_date": CT.cache[CT.settings.currentTab].searchParams.processed.chk_out ? new Date(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_out, "DD/MM/YYYY").format("YYYY-MM-DD")) : "N/A"
                                    });
                                    console.warn("Hotel_SRP_Viewed");
                                    // The condition for layOfTheLandEnabled is quirky, as !undefined will give true, so check if city is goa sice lol is only for goa.
                                    CT.utils.helperFunctions.trackClaverTapEvtHotel('Hotel_SRP_Viewed', {
                                        "totalHotelsCount": CT.masterJson.get().ht.length > 0 ? CT.masterJson.get().ht.length : "N/A",
                                        "UnavailableHotelsCount": String((CT.cache[CT.settings.currentTab].searchParams.all.chk_in && CT.cache[CT.settings.currentTab].searchParams.all.chk_out) != "" ? unAvailCount : "N/A"),
                                        "PreviouslyBookedCount": CT.utils.cookies.read('hotelBookedCount') ? CT.utils.cookies.read('hotelBookedCount').split('|')[0] : 0,
                                        "shortlistedCount": shortlistedCount ? shortlistedCount : "N/A",
                                        "walletBalance": window.masterJSON.wallet.wallet_balance,
                                        // "hideTupleLevelMerchandising": CT.utils.getAbTestCookie("H_D_SRP_TLM") === 'b'  && !(window.product === "B2B" || window.companyConfig),
                                        // "tupleLinks": CT.utils.getAbTestCookie("H_D_SRP_TL") === 'a'  && !(window.product === "B2B" || window.companyConfig) && countryCode === "in",
                                        "layOfTheLandEnabled": !$($(".resultContainer")[$(".resultContainer").length - 1]).find(".lol__btn.disbalbed-state").length && masterJSON.cnm === "Goa",
                                        "lolFilterEnabled": CT.settings[CT.app].lolfilter[CT.cache[CT.settings.currentTab].searchParams.all.city] ? true : false,
                                        "layOfTheLand": CT.cache[CT.settings.currentTab].searchParams.all.city === "Goa" && !(window.product === "B2B" || window.companyConfig) && countryCode === "in",
                                        "UserCity": CT.utils.cookies.read("userHomeCity") || "Unavailable",
                                        "UserState": CT.utils.cookies.read("userHomeState") || "Unavailable",
                                        "utm_source": CT.utils.cookies.read("utm_source") || "Organic",
                                        "timeSinceSearchClicked": window.timeToSearchSRP ? Date.now() - window.timeToSearchSRP : "N/A",
                                        "ctaName": CT.utils.getAbTestCookie("hotels_srp_cta") == 'b' && window.countryCode =='in'? "View details" : "Select room",
                                        "PriceFilterType": CT.utils.getAbTestCookie("Hotels_Desktop_PriceFilter") == 'b' ? 'Checkbox' : 'Slider',
                                        "checkin_date": CT.cache[CT.settings.currentTab].searchParams.processed.chk_in ? new Date(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, "DD/MM/YYYY").format("YYYY-MM-DD")) : "N/A",
                                        "checkout_date": CT.cache[CT.settings.currentTab].searchParams.processed.chk_out ? new Date(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_out, "DD/MM/YYYY").format("YYYY-MM-DD")) : "N/A",
                                        "HasTags": CT.tagsData ? "True":"False",
                                        "SrpMetaModified": CT.cache[CT.settings.currentTab].searchParams.all.meta_ref ? "True" : "False",
                                        'cfw_banner': $('.cfw-in-deals-wrapper').length ? "True" : "False",
                                        'cfw_status': (window.workPlusUserDetails && workPlusUserDetails.status) ? workPlusUserDetails.status: (CT.utils.readCTAuthCookie() ? 'Logged In': 'Not Logged In'),
                                        "LS_source": (CT.cache[CT.settings.currentTab].searchParams.all.country === 'IN' && CT.settings.hotel.useMapMyIndia)? "MMI" : "Google"
                                        });
                                    CT.utils.trackers.ctanalyticsTrackingData('Hotels_TR', 'Page_Viewed', 'SRP_Results_Loaded', {
                                        "searchData": CT.utils.trackers.mixpanelTrackingData
                                    }, 'page_load');
                                }, 400);
                            }, 300);
                            //setTimeout(function() { $loadingBar.addClass('squeezeMe'); }, 2000);
                            //setTimeout(function() { $loaderContainer.hide(); }, 2500);
                        }
                    }
                }
            },



            updateMessages: function(mJson) {
                var tabCache = CT.cache[CT.settings.currentTab],
                    err, tmp, tmp1, tmp2;
                mJson = mJson || CT.masterJson.get();
                err = mJson.err;

                //initiate hideMessage variable for the tab
                tabCache.hideMessages = tabCache.hideMessages || {};

                this.$el.find('.viewController .pageMessageHolder').html('');

                //zero or few results messages
                if (err && (err.zr || err.lr)) {
                    if (err.lr && err.lr != 6) {
                        //this.showZeroOrFewResultNote(undefined, CT.messages[CT.app].zeroResults[err.lr]['few'], 'NotificationTpl', 'top', null, this.$el.find('.viewController .pageMessageHolder'));
                    } else if (err.zr) {
                        this.showOverlayWarning(null, CT.messages[CT.app].zeroResults[err.zr]['zero']);
                        this.getPayLoadForEvent(CT.messages[CT.app].zeroResults[err.zr]['zero']);                    
                    }
                }

                //messages display logic
                tmp = tabCache.searchParams.all.hotelName;
                if (!tabCache.hideMessages.hotelSearchNotification && tmp && tmp != '') {
                    //display hotel specific search notification
                    this.showHotelSearchMsg(tmp, true);
                }
                 
                else if (!tabCache.hideMessages.localityNotification && !tabCache.searchParams.all.SearchTag) {
                    tmp = tabCache.searchParams.all.area;
                    tmp1 = tabCache.searchParams.all.poi;
                    if (tmp && (_.isUndefined(tmp1) || tmp1[0] == '') && _.isArray(tmp) && tmp.length == 1 && tmp[0] != '') {
                        //display area search message
                        if (window.location.search.indexOf("area") != -1);
                        this.showLocalitySearchMsg(tmp, true);
                    } else if (tmp1 && (_.isUndefined(tmp) || tmp[0] == '') && _.isArray(tmp1) && tmp1.length == 1 && tmp1[0] != '') {
                        //display poi search message
                        if (window.location.search.indexOf("poi") != -1)
                            this.showLocalitySearchMsg(tmp1);
                    }
                } 
                else if (!tabCache.hideMessages.nearByNotification) {
                    if (mJson.nch) {
                        //show nearby cities if the hotels found in current city is zero
                        this.showNearByCitiesMsg(mJson.ncm);
                    } else if (!$.isEmptyObject(mJson.ncm)) {
                        //show nearby cities if the hotels found in current city is is greater than zero
                        this.showNearByCitiesMsg(mJson.ncm);
                    }
                }


            },
            getPayLoadForEvent:function(msgObj){
                var params = CT.cache[CT.settings.currentTab].searchParams.all;
                var payLoad = {};
                $.each(params,function(key,value) {
                        payLoad[key] = value.toString();
                });
                    payLoad.errMsg = msgObj['subTitle'] ?msgObj['subTitle'] :  msgObj['title']  ;
                
                CT.utils.trackers.analyticsTrackingError({"searchData":payLoad},'zero_search_result_hotel','');
            },



            realTimePriceUpdate: function(e, hotels) {
                var that = this;


                _.each(hotels, function(obj, item) {

                    CT.utils.Nagger.nag(function(id, hotel) {
                        var firstRms;

                        if (document.getElementById(id) && hotel.rms) {
                            //other hotel details
                            firstRms = hotel.rms[0];
                            //this function modifies hotel details based on firstRms
                            hotel = $.extend(true, hotel, that.getDiscountMarkup(firstRms.tot, firstRms.d, hotel));
                            $('#' + id + ' .rate').html(CT.to_html('HotelPricePartialTpl', hotel));

                            //$("#"+id+" .rate").html("Real Time Update" + id);
                            return true;
                        }

                        return false;

                    }, item, hotels[item]);

                });

            },


            updateMasterJson: function(e) {
                var mJson = CT.masterJson.get()
                var paramsObject = CT.cache[CT.settings.currentTab].searchParams.all;
                var html, err = mJson.err,
                    tmp, tmp1, utmSource = "",
                    utmMedium = "",
                    hotelId = "",
                    diffDate, LOS;
                var tabCache = CT.cache[CT.settings.currentTab];
                var updateCallback = CT.settings.hotel.updateCallback;

                //set load complete variable which is used in updateCallback
                tabCache = CT.cache[CT.settings.currentTab];
                tabCache.isCitySearch = true;
                tabCache.fewResultsMsg = '';

                //zero or few results messages setting in tabCache
                if (err && (err.zr || err.lr)) {
                    if (err.lr && err.lr != 6) {
                        tabCache.fewResultsMsg = CT.messages[CT.app].zeroResults[err.lr]['few'].mainMsg;
                    }
                }
                //CT.utils.setCurrency(mJson.searchType);//set currency type
                $('#ResultContainer_' + CT.settings.currentTab).click(function() {
                    $(".currency ul").hide();
                    $(".countryPicker").hide()

                })
                $(document).click(function () {
                    $('#localityPredictionDiv').hide()
                })
                this.updateProperties(mJson);

                //check for trip advisor call
                if (paramsObject.utm_source && CT.subProd != "wg") {
                    var hotelDetails = CT.masterJson.getHotel(paramsObject.ct_hotelid);

                    tabCache.searchParams.processed.city = mJson.cnm;
                    tabCache.searchParams.all.city = mJson.cnm
                    CT.fire('modifyForm.change', [tabCache.searchParams.processed])
                    $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                    $currentTab.find(".fillCityName").html(tabCache.searchParams.processed.city);
                    $("#GlobalNav").find(".fillCityName").html(tabCache.searchParams.processed.city);

                    if (_.has(CT.settings.general.staticMapToCityId, mJson.city) === true) {
                        mapClass = CT.settings.general.staticMapToCityId[mJson.city];
                        $currentTab.find(".cityMap").removeClass("genericMap");
                    } else {
                        mapClass = CT.settings.general.staticMapToCityId["generic"];
                        $currentTab.find(".cityMap").removeClass("genericMap");
                    }
                    $currentTab.find(".cityMap").addClass(mapClass + " topPlacesMap");
                    if (hotelDetails) {
                        if (hotelDetails.priceInfo) {
                            paramsObject.hotelName = hotelDetails.nm;
                            paramsObject = CT.cache[CT.settings.currentTab].searchParams.all;
                            this.showHotelSearchMsg(paramsObject.hotelName, true);
                        } else {
                            //generate shortID
                            hotelDetails.shortID = CT.utils.shortenID(hotelDetails.id);
                            var html = CT.to_html('TAUnavilableTpl', hotelDetails);
                            $currentTab.find(".taUnavilableHolder").html(html);
                        }
                    }

                    utmSource = paramsObject.utm_source;
                    utmMedium = paramsObject.utmMedium;
                    //hotelId = paramsObject.hotelId
                    this.setPageTitle(paramsObject);
                }
                var paramsForGA = CT.cache[CT.settings.currentTab].searchParams.all
                var todaysDate = moment();
                if (paramsForGA.chk_in != "" && paramsForGA.chk_out != "") {
                    var chkinDate = moment(paramsForGA.chk_in, "DD/MM/YYYY")
                    var chkOutDate = moment(paramsForGA.chk_out, "DD/MM/YYYY")
                    diffDate = chkinDate.diff(todaysDate, 'days');
                    LOS = chkOutDate.diff(chkinDate, 'days');

                }
                if (CT.subProd && CT.subProd == "wg") {
                    var url = "from=" + paramsForGA.city + "&country=" + paramsForGA.country + "&num_rooms=" + paramsForGA.num_rooms + "&D+X=" + diffDate + "&LOS=" + LOS + "&utm_source=" + utmSource + "&utm_medium=" + utmMedium + "& ct_hotelid="
                } else {
                    var url = "city=" + paramsForGA.city + "&country=" + paramsForGA.country + "&num_rooms=" + paramsForGA.num_rooms + "&D+X=" + diffDate + "&LOS=" + LOS + "&utm_source=" + utmSource + "&utm_medium=" + utmMedium + "& ct_hotelid="
                }
                CT.cache[CT.settings.currentTab].paramsForGA = url;


                //hide all the messages by default. based on search criteria enable specific messages in updateMasterJson function
                tabCache.hideMessages = {
                    hotelSearchNotification: true,
                    localityNotification: true,
                    nearByNotification: true
                };

                //enable messages based on search criteria
                tmp = tabCache.searchParams.all.hotelName;
                if (tmp && tmp != '') {
                    tabCache.isCitySearch = false;
                    tabCache.hideMessages.hotelSearchNotification = false;
                }


                tmp = tabCache.searchParams.all.area;
                tmp1 = tabCache.searchParams.all.poi;
                if (tmp && _.isArray(tmp) && tmp.length == 1 && tmp[0] != '') {
                    tabCache.isCitySearch = false;
                    tabCache.hideMessages.localityNotification = false;
                }
                if (tmp1 && _.isArray(tmp1) && tmp1.length == 1 && tmp1[0] != '') {
                    tabCache.isCitySearch = false;
                    tabCache.hideMessages.localityNotification = false;
                }

                /*
                if(mJson.nch == 0) {
                    tabCache.hideMessages.nearByNotification = true;
                }
                if(!$.isEmptyObject(mJson.ncm)) {
                    tabCache.hideMessages.nearByNotification = false;
                }
                */

                //add glass shield
                $('.glassShield').hide();

                //set loading bar width
                this.setLoadingBar(CT.messages.hotel.DoneLoading, '100%', 'hide');
                CT.cache[CT.settings.currentTab].isSRPLoaded = true;
                this.$el.find('.pageLoader .meter').removeClass('finishMe');
                var urlDataOfSrp = _.deserialize(window.location.search)
                if (urlDataOfSrp.poi != "" &&
                    urlDataOfSrp.poi != undefined &&
                    CT.isLocationEnabled == true &&
                    CT.cache[CT.settings.currentTab].latitude != "" &&
                    CT.cache[CT.settings.currentTab].longitude != "") {
                    $("#ResultContainer_" + CT.settings.currentTab).find('nav.sorters a').each(function(index, ele) {
                        $(this).removeClass('current')
                        $(this).removeClass('sortAsc')
                        $(this).removeClass('sortDes')
                    })
                    $("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters a.location").html('Distance from ' + urlDataOfSrp.poi)
                    $("#ResultContainer_" + CT.settings.currentTab).find("nav.sorters a.location").css('display', 'block').addClass('current')
                }
                //CT.cachedElements.$candyBar.remove();
                (function () {
                    window.setTimeout(function () {
                        // Add only when Goa is city logic(and only b2b) here
                        var cityName = _.deserialize(window.location.href.split('results?')[1]).city;
                        if ( cityName && cityName === "Goa" && !(window.product === "B2B" || window.companyConfig) && countryCode === "in") {
                                var lolHtmlURL = "/html-templates/index-cleartrip.comLol.html";
                                if (window.location.host.startsWith("qa2")) {
                                        lolHtmlURL = "/html-templates/index-cleartrip.qa.comLol.html";
                                }
                                $(".resultContainer .layOfTheLand").on().load(lolHtmlURL, function() {
                                        console.log("LOL load was performed.");
                                });
                        }
                    }, 100);
                })();
                
                //this.updateProperties(mJson);
                //Hack for fixing destinations bug where distance is coming =0


                //all fires  -   @todo - move to common place

                // fire create shortlist bar
                (function(params, sl) {
                    params = _.deserialize(params)
                    CT.areaVal = params.area
                    sl.trigger('list.update', {
                        ids: params.shortListed,
                        operation: 'add'
                    }) // updates shortlist DOM
                })(window.location.search.substr(1), this.$('.shortlistContainer'));

                //update filter params from search url
                if (CT.app != 'dp') {
                    if (paramsObject.hotelName && paramsObject.hotelName == "undefined") {
                        paramsObject.hotelName = "";
                    }
                    if (paramsObject.hotelName && (tmp = paramsObject.hotelName) != '') {
                        //TODO : merge smallsearch and mapviewsearch into a single input box - mapviewsearch is a duplicate input - karthik
                        this.$el.find('.smallSearch input, .mapViewSearch input').val(_.titleize(tmp));
                        paramsObject.hotelName = tmp;
                    }
                    if (_.indexOf(paramsObject.area, "undefined") != -1) {
                        paramsObject.area.splice($.inArray("undefined", paramsObject.area), 1);
                    }
                    if (_.isArray(paramsObject.area) && (_.isUndefined(paramsObject.poi) || paramsObject.poi[0] == '') && paramsObject.area.length == 1 && (tmp = paramsObject.area[0]) != '') {
                        this.$el.find('.smallSearch input, .mapViewSearch input').val(_.titleize(tmp)).attr('data-checkboxid', tmp.replace(/\s+/g, '_'));
                    }
                    if (_.indexOf(paramsObject.poi, "undefined") != -1) {
                        paramsObject.poi.splice($.inArray("undefined", paramsObject.poi), 1);
                    }
                    if (_.isArray(paramsObject.poi) && (_.isUndefined(paramsObject.area) || paramsObject.area[0] == '') && paramsObject.poi.length == 1 && (tmp = paramsObject.poi[0]) != '') {
                        this.$el.find('.smallSearch input, .mapViewSearch input').val(_.titleize(tmp)).attr('data-checkboxid', tmp.replace(/\s+/g, '_'));
                    }
                }



                // trigger quickey filter from url.
                if (paramsObject.quickey === 'true')
                    paramsObject.quickeys = "quickeys";
                //this.$el.find('.badgeFilter').find('.quickKeysFilter').click();

                ///To Retain Filters
                //Read the Cookie and proceed if the cookie is "b"
               // var filterCookie = JSON.parse(decodeURIComponent(CT.utils.cookies.read("ct-ab")));
               var filterCookie = CT.utils.getAbTestCookie();
                CT.cache[CT.settings.currentTab].h_retainFilters = filterCookie != null ? filterCookie["h_retain_filters"] : ''; //Store in cache for further reference
                if (CT.cache[CT.settings.currentTab].h_retainFilters == "b") {
                    var retainFiltersData = JSON.parse(localStorage.getItem("recentFilters"));
                    if (window.product != "B2B") {
                        if (!$.isEmptyObject(retainFiltersData)) {
                            var currentTime = new Date().getTime();
                            var timeDiff = (currentTime - retainFiltersData["lastUpdated"]) / 1000;
                            if (timeDiff > 3600)
                                localStorage.removeItem("recentFilters");
                            else {
                                var lastFilter = retainFiltersData;
                                for (var i in lastFilter)
                                    if (i != "lastUpdated")
                                        paramsObject[i] = lastFilter[i]
                            }
                        }
                    }
                }

                // initialize the filters
                this.$el.find(CT.settings.selectors.filters).trigger('filters_update', [mJson, paramsObject, this]);



                CT.fire('initChkavail', []); //checkavail
                //CT.fire('CCR.triggred',[]);//it will currency converter select box.

                // initialize the near by hotels
                var nh = 1;
                if (nh) {
                    //CT.fire('initnbHotels', [{ json : masterJSON, id : $("#"+searchResultViewSettings.attributes.id).find("div.nearbyHotels")}]);
                }


                // initialize the area search
                if (CT.areaVal) {
                    CT.fire('showAreaData.init', []);
                }

                //show hide badges
                tmp = CT.cache[CT.settings.currentTab].badgesStat;
                var quickeyCooie = CT.utils.cookies.read('quickeyTipsy');
                /*if(tmp && tmp.sdr) {
                                        this.$el.find('.badgeFilter').find('.dealsFilter').parent().remove();
                                        $badgeFilterTag = this.$el.find('.badgeFilter').show().find('.quickKeysFilter')
                                        $badgeFilterTag.parent().show();
                                        $badgeFilterTag.find('small').text(tmp.cnt.sdr);
                                    }
                                    else if(tmp && tmp.deals) {
                                        this.$el.find('.badgeFilter').find('.quickKeysFilter').parent().remove();
                                        $badgeFilterTag = this.$el.find('.badgeFilter').show().find('.dealsFilter')
                                        $badgeFilterTag.parent().show();
                                        $badgeFilterTag.find('small').text(tmp.cnt.deals);
                                    } else {
                                        this.$el.find('.badgeFilter').find('.dealsFilter').parent().remove();
                                    }

                                    if(tmp && tmp.wsh && tmp.cnt.wsh !=0) {
                                        $badgeFilterTag = this.$el.find('.badgeFilter').show().find('.weSleepHereFilter')
                                        $badgeFilterTag.parent().show();
                                        $badgeFilterTag.find('small').text(tmp.cnt.wsh);
                                    } else {
                                        this.$el.find('.badgeFilter').find('.weSleepHereFilter').parent().remove();
                                    }

                                    if(tmp && tmp.bp && tmp.cnt.bp !=0) {
                                        $badgeFilterTag = this.$el.find('.badgeFilter').show().find('.ctBookPercentage')
                                        $badgeFilterTag.parent().show();
                                        $badgeFilterTag.find('small').text(tmp.cnt.bp);
                                    } else {
                                        this.$el.find('.badgeFilter').find('.ctBookPercentage').parent().remove();
                                    }*/
                var badgeCnt = CT.cache[CT.settings.currentTab].badgeCnt
                if (window.budgetBadgeFilter.enable == "true" && window.budgetBadgeABVal == "b" && badgeCnt && badgeCnt.budgetHotelCnt && badgeCnt.budgetHotelCnt > 0) {
                    var $budgetBadge = this.$el.find('.badgeFilter').show().find('.budgetBadgeFilter');
                    $budgetBadge.parent().show();
                    $budgetBadge.find('small').text(badgeCnt.budgetHotelCnt);
                    $budgetBadge.find('span').html("Hotels under " + CT.utils.formatForCurrency(window.budgetBadgeFilter.minBudget));
                    CT.cache[CT.settings.currentTab].budgetHotelShown = true
                    //this.$el.find(".primaryBar").addClass("stickyPrimaryBar");
                }


                if (tmp && tmp.abnb && tmp.cnt && tmp.cnt.abnb != 0) {
                    $badgeFilterTag = this.$el.find('.badgeFilter').show().find('.onlyAirBnb')
                    $badgeFilterTag.parent().show();
                    $badgeFilterTag.find('small').text(tmp.cnt.abnb);
                } else {
                    this.$el.find('.badgeFilter').find('.onlyAirBnb').parent().remove();
                }

                if (paramsObject.view === "map") {
                    //this.toggleMapListView();
                    this.$el.find(".mapCanvas").show();
                    CT.fire("changeView", [{
                        view: "mapView",
                        onload: true
                    }]); // to open map view through URL.
                } else {
                    this.initInfScroll(undefined);
                }

                if (!window.isWL) {
                    this.buildMotherDeals(mJson)
                }

                if (window.showTags) {
                    $("body").addClass("tagging");
                    this.buildTags(CT.tagsData);
                } else {
                    // This wierd bit of code is a fix for HOTCON-378
                    // i.e. Tags not displayed on first load, sometimes
                    // The attempted fix is: if window.showTags false, use setTimeout to make sure all
                    // the relevant statements in ct-html/hotelstatic/includes/head.shtml are executed
                    // before this code is run.
                    var _this = this;
                    setTimeout(function(){
                        if (window.showTags) {
                            $("body").addClass("tagging");
                            _this.buildTags(CT.tagsData);
                        } else {
                            _this.$el.find("#hotelsViewSwitcher").show();
                            $(".tagsSorting").remove();
                        }
                    }, 1);
                    // this.$el.find("#hotelsViewSwitcher").show();
                    // $(".tagsSorting").remove();
                }


                if (window.product === "B2B") {
                    var msgObj = CT.messages.hotel.B2B[window.productCode];
                    this.$el.find(".custCareNumber").html(msgObj && msgObj.customerCareNumber.DOM)
                }

                if (CT.settings.general.showFirstRun && CT.settings.general.showFirstRun === true) {
                    firstRun.showFirstRunTipsy(this.$el);
                }

                //End - couting srp render timing.
                CT.settings.srpRenderTime = new Date().getTime() - CT.settings.srpRenderTime;
                console.log(CT.settings.srpRenderTime / 1000);

                //Count time from click of Search button of hotels home page
                CT.cache[CT.settings.currentTab].eventsTimes.totalRenderTime = CT.settings.srpRenderTime;

                CT.utils.trackers.mixpanelTrackingData.hotel360Images = window.vtsShown ? "YES" : "NO"
                try {
                    var fbObj = {
                        content_type: 'hotel',
                        content_ids: window.topHotelIdsArr ? window.topHotelIdsArr : 'NA', // top search results
                        checkin_date: CT.cache[CT.settings.currentTab].searchParams.processed.chk_in ? moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, "DD/MM/YYYY").format("YYYY-MM-DD") : "N/A",
                        checkout_date: CT.cache[CT.settings.currentTab].searchParams.processed.chk_out ? moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_out, "DD/MM/YYYY").format("YYYY-MM-DD") : "N/A",
                        destination: 'NA',
                        city: CT.cache[CT.settings.currentTab].searchParams.processed.city, //recommended
                        region: CT.cache[CT.settings.currentTab].searchParams.processed.state, // region is the state for the US
                        country: CT.cache[CT.settings.currentTab].searchParams.processed.country //recommended
                    }
                    CT.utils.helperFunctions.tpTrack({
                        'tp': 'fb',
                        'category': 'Search',
                        'values': fbObj
                    });
                } catch (e) {}

                // ct_ct tracking call.
                CT.utils.trackers.page_count({
                    n: "sr",
                    p: "h"
                });

            },

            buildTags: function(data) {
                if (!!CT.tagsData){
                    console.warn("buildTags");
                    var tagData = data;
                    var html = CT.to_html('TagsTpl', {
                        "tagData": tagData
                    });
                    this.$el.find(".tagContainer ul").html(html)
                    this.$el.find(".tagContainer").fadeIn(300);
                    var mixpaneltagsData = ""
                    $.each(CT.tagsData, function(i, tags) {
                        mixpaneltagsData += tags.tagName + ","
                    });
                    mixpaneltagsData = CT.utils.helperFunctions.removeCamaInString(mixpaneltagsData)
                    CT.utils.trackers.mixpanelTrackingData.tagsPresent = mixpaneltagsData
                    if (window.showTags) {
                        CT.utils.trackers.mixpanelTrackingData.numTagsClicked = "0"
                    }
                    window.tagsRefreshselected = []
                    CT.numTagsClicked = ""
                    CT.tagsSelected = []
                    if (CT.cache[CT.settings.currentTab].searchParams.all && CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter && CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter.split("-")) {
                        var tagsActive = CT.cache[CT.settings.currentTab].searchParams.all.tagsFilter.split("-");
                        for (var i = 0; i < tagsActive.length; i++) {
                            this.$el.find(".tagContainer ul ." + tagsActive[i]).addClass("active");
                            window.tagsRefreshselected.push(this.$el.find(".tagContainer ul ." + tagsActive[i]).attr('tagname'))
                        }
                        if (window.tagsRefreshselected.length > 0) {
                            this.$el.find(".tagBoxClear").show()
                        }
                        CT.numTagsClicked = window.tagsRefreshselected.length;
                        CT.tagsSelected = window.tagsRefreshselected
                        CT.utils.trackers.mixpanelTrackingData.numTagsClicked = window.tagsRefreshselected ? String(window.tagsRefreshselected.length) : "0"
                        CT.utils.trackers.mixpanelTrackingData.tagsSelected = window.tagsRefreshselected ? String(window.tagsRefreshselected.join(',')) : "N/A"
                    }
                }
            },
            buildMotherDeals: function(masterJson) {
                if (!masterJson.searchType) return true;
                var html = '',
                    that = this;
                var searchType = masterJson.searchType.sellCurr,
                    mDealUrl = CT.settings.offerUrl,
                    srpPageOfferVersion = "";

                if (CT.utils.helperFunctions.isDomesticHotel()) {
                    mDealUrl = mDealUrl + 'B2CHotelSearch_dom_'
                    srpPageOfferVersion = srpPageDomVersion
                } else {
                    mDealUrl = mDealUrl + 'B2CHotelSearch_intl_'
                    srpPageOfferVersion = srpPageIntlVersion
                }

                
                CT.getScript(mDealUrl + window.countryCode.toUpperCase() + '.js?' + srpPageOfferVersion, function() {

                    try {
                        var city, checkin_date, start_date, end_date;

                        if (CT.settings.kashmir) {
                            city = CT.cache[CT.settings.currentTab].searchParams.all.city;
                            checkin_date = Date.parse(moment(CT.cache[CT.settings.currentTab].searchParams.all.chk_in, "DD/MM/YYYY"));
                            start_date = Date.parse(moment(CT.settings.kashmir.start_date, "DD/MM/YYYY"));
                            end_date = Date.parse(moment(CT.settings.kashmir.end_date, "DD/MM/YYYY"));
                        }
                        if (CT.settings.kashmir && city && _.indexOf(CT.settings.kashmir.cities, city.toLowerCase()) != -1 && (checkin_date >= start_date && checkin_date <= end_date)) {

                            soffers = CT.settings.kashmir.srpBanner;

                        } else {
                            soffers = window.search_offers;
                            if (soffers.isFlashSaleEnabled == 'Y') {
                                window.shwFlashSaletag = true;
                            } else {
                                window.shwFlashSaletag = false;
                            }
                        }
                        if (soffers && soffers.DESC1 != '') {
                            if (window.shwFlashSaletag == true) {
                                soffers.shwFlashSaletag = true
                            } else if (window.shwFlashSaletag == undefined) {
                                var flashSaleArrProp = window.flashSaleDeadLine.split(",");
                                var dateArr = flashSaleArrProp[0].split('/');
                                var timeArr = flashSaleArrProp[1].split(':');
                                var timeStr = CT.utils.helperFunctions.calTimeDiff(dateArr, timeArr);
                                if (timeStr && timeStr.rstring) {
                                    soffers.shwFlashSaletag = true
                                }
                            }
                            html = CT.to_html('SearchOfferTpl', soffers);
                            if (window.showTags) {
                                that.$el.find(".primaryBar .mDeal p").html(html)
                            } else {
                                that.$el.find(".listViewResults .mDeal p").html(html)
                            }

                            if (!soffers.LINK1) {
                                that.$el.find(".mDeal p")[0].style.marginTop = "2px";
                            }
                            if (CT.cache[CT.settings.currentTab].viewType != 'map' && window.product !== "B2B") {
                                if (window.showTags) {
                                    that.$el.find(".primaryBar .mDeal p").parent().show();
                                } else {
                                    that.$el.find(".listViewResults .mDeal p").parent().show();
                                }

                            }
                            CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_Motherdeal', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                        }
                    } catch (e) {

                    }
                })
            },


            renderImagesForGateways: function(e) {
                e.stopImmediatePropagation();
                var hotelTag = $(e.target).parents('li.listItem'),
                    hotelId = hotelTag.attr('id'),
                    moreImg = hotelTag.find('.moreImages');
                var hotelObj = CT.masterJson.getHotel(hotelId);
                renderThumbnailsForGateways = function() {
                    var html, renderJson = {},
                        trCount = 4;

                    renderJson.url = [];
                    _.forEach(_.first(hotelObj.img, (trCount)), function(img, index) {
                        renderJson.url.push({
                            src: hotelBaseLink + '/places/hotels/places/hotels/' + CT.utils.shortenID(hotelId) + '/' + hotelId + '/images/' + img,
                            photoIndex: index + 1
                        });
                    });

                    //render images
                    html = CT.to_html('HotelImgThumbTpl', renderJson);
                    hotelTag.find('.moreImages').html(html);

                    // Author: Bhimsen S K
                    var imageElements = hotelTag.find(".moreImages").find(".photoMask").find("img"),
                        parents = hotelTag.find(".moreImages").find(".photoMask");
                    $.each(imageElements, function(index, value) {
                        //CT.utils.helperFunctions.disableRightClickOnElement(value);
                        CT.utils.helperFunctions.imageToDiv(parents[index], value, [], ["position", "opacity", "top", "width"]);
                    });

                    hotelTag.find('img').setLoad(CT.utils.imgAdjust);
                    //remove attrs to block further api calls
                    moreImg.removeAttr('data-imgfetch');

                    //hotelTag.find('ul.thumbnails li:odd').addClass('odd');
                };
                updateQuickLookForGateways = function(respJson) {
                    if (respJson.img)
                        hotelObj.img = respJson.img;
                    renderThumbnailsForGateways()
                };

                if (!hotelObj.img && moreImg.attr('data-imgfetch')) {
                    ajaxUrl = CT.to_html(CT.settings[CT.app].urls.thumbnails, {
                        hotelId: hotelId
                    });
                    $.ajax({
                        url: ajaxUrl,
                        type: 'GET',
                        success: updateQuickLookForGateways
                    });
                } else {
                    renderThumbnailsForGateways();
                }
            },



            openQuickLook: function(e) {
                var hotelTag = $(e.target).parents('li.listItem'),
                    hotelId = hotelTag.attr('id'),
                    quickLookDiv = hotelTag.find('.quickLook'),
                    that = this,
                    trCount, imgUrls, ajaxUrl, trustUrlMap, searchUrl, trustUrlParams = [];
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);
                var updateQuickLook;
                var tabCache = CT.cache[CT.settings.currentTab];
                var isCTUser = unescape(CT.utils.cookies.read('userid')).indexOf('@cleartrip.com');
                var hotelObj = CT.masterJson.getHotel(hotelId);

                this.taxesMarkup(hotelId, e);
                //manual toggle code with many conditions
                if (hotelTag.hasClass('opened') && hotelTag.hasClass('showAmenities')) {
                    hotelTag.removeClass('showAmenities').attr('data-showamenities', 'true');
                    hotelTag.find('.openQuickLook').find('.rArrow').removeClass('rArrow').addClass('dArrow');
                    hotelTag.find(".amIcons li").show();
                    hotelTag.find('.hasPinPoint').hide();
                } else if (hotelTag.hasClass('opened')) {
                    //quickLookDiv.hide();
                    if (hotelTag.attr('data-showamenities') == 'true') {
                        hotelTag.addClass('showAmenities');
                        hotelTag.removeAttr('data-showamenities');

                        if (hotelTag.hasClass('gnTrue') && hotelTag.hasClass('jsHasAm')) {
                            hotelTag.find(".amIcons li").hide();
                            $.each(hotelTag.find(".amIcons .highlightMeLonger span"), function(index, ele) {
                                if (!$(ele).hasClass("amNa")) {
                                    $(ele).closest("li").show();
                                }
                            });
                            hotelTag.find('.hasPinPoint').show();
                        }
                    } else {
                        CT.settings.general.quickLookClickCount = CT.settings.general.quickLookClickCount - 1;
                        hotelTag.removeClass('opened');
                    }

                    hotelTag.find('.openQuickLook').find('.dArrow').removeClass('dArrow').addClass('rArrow');

                    if (hotelTag.hasClass('gnTrue') && !hotelTag.hasClass('jsHasAm')) {
                        quickLookDiv.hide();
                    }

                } else {
                    CT.settings.general.quickLookClickCount = CT.settings.general.quickLookClickCount + 1;
                    hotelTag.addClass('opened');
                    hotelTag.find('.openQuickLook').find('.rArrow').removeClass('rArrow').addClass('dArrow');
                    //if(hotelTag.hasClass('gnTrue') && !hotelTag.hasClass('jsHasAm')) {
                    //  quickLookDiv.show();
                    //}
                }

                //animated toggle code - only if amenities is not checked and not a GN (leisure) filtered result
                //if(this.$el.find('.filtersForm .amenity input:checked').length == 0 && !hotelTag.hasClass('gnTrue')) {
                //TODO: make this code common between flights and hotels
                //added slidetoggle instead of toggle - hope that won't break
                if ($.browser.msie) { //For IE using only toggle because to avoid
                    quickLookDiv.toggle()
                } else {
                    quickLookDiv.slideToggle('300')
                }
                //}
                /*if(CT.settings.general.quickLookClickCount >= CT.settings.general.totalQuickLookOpenForGN){
                                         if(CT.settings[CT.app].guidedNavEnabled && !tabCache.dontShowGNonScroll) {
                                              if(CT.settings[CT.app].guidedNavForCTUsers) {
                                                  if(isCTUser != -1){
                                                      CT.fire('guidedNavTrigger')
                                                  }
                                                      
                                              } else {
                                                  CT.fire('guidedNavTrigger')
                                              }
                                          }
                                        }*/

                renderThumbnails = function() {
                    var html, renderJson = {};

                    //limit image count based on the number of rms displayed
                    if ((trCount = quickLookDiv.find('tr').length) > 3) {
                        trCount = 3;
                    }

                    renderJson.url = [];
                    _.forEach(_.first(hotelObj.img, (trCount * 2)), function(img, index) {
                        renderJson.url.push({
                            src: hotelBaseLink + '/places/hotels/' + CT.utils.shortenID(hotelId) + '/' + hotelId + '/images/' + img,
                            photoIndex: index + 1
                        });
                    });
                    //render images
                    html = CT.to_html('HotelImgThumbTpl', renderJson);
                    hotelTag.find('.hotelPics').html(html);

                    // Author: Bhimsen S K
                    var imageElements = hotelTag.find(".hotelPics").find(".photoMask").find("img"),
                        parents = hotelTag.find(".hotelPics").find(".photoMask");
                    $.each(imageElements, function(index, value) {
                        //CT.utils.helperFunctions.disableRightClickOnElement(value);
                        CT.utils.helperFunctions.imageToDiv(parents[index], value, [], ["position", "opacity", "top", "width"]);
                    });

                    hotelTag.find('img').setLoad(CT.utils.imgAdjust);
                    //remove attrs to block further api calls
                    quickLookDiv.removeAttr('data-imgfetch data-tc');

                    hotelTag.find('ul.thumbnails li:odd').addClass('odd');

                };

                updateQuickLook = function(respJson) {
                    var html, tmp, tmp1;
                    var totRoomNight = Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights) * Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms);

                    if (respJson.img)
                        hotelObj.img = respJson.img;

                    tmp = hotelObj.priceInfo;
                    if (tmp && tmp.rms) {

                        //TODO: make tax and discount markup generation code as common with modal window and update properties - karthik
                        _.forEach(tmp.rms, function(rms) {
                            tmp1 = 'CurrencyFormatTpl';
                            //if postpay hotel, we need to display total amount without tax
                            rms.showTtd = true;
                            rms.bfo = false;
                            if (hotelObj.bfo) {
                                rms.showTtd = false;
                                rms.bfo = true;
                            }
                            // read abtest cookie.
                            if (window.taxAbTest === 'a') {
                                var tavg = rms.avg;
                                var roomNights = Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_nights) * Int(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms);
                                rms.avg -= rms.t;
                                this.getDiscountMarkup(rms.tot, rms.d, rms);
                                if (rms.d > 0)
                                    rms.oamt = CT.utils.formatForCurrency(rms.tot + rms.d, false, null, false);
                                rms.avg = tavg;
                                rms.showTaxLink = false
                                if (rms.t != undefined && rms.t >= 0) {
                                    rms.showTaxLink = true;
                                    if (window.taxAbTest_A == 'b') {
                                        rms.taxAbTest_A = true;
                                    }
                                    if ((rms.t + rms.st + rms.kkc + rms.sbc) > 0) {
                                        rms.taxMarkupPerRoom = CT.utils.formatForCurrency(rms.t + rms.st + rms.kkc + rms.sbc);
                                        rms.taxMarkupTotal = CT.utils.formatForCurrency((rms.t + rms.st + rms.kkc + rms.sbc) * roomNights);
                                    } else {
                                        rms.showTaxLink = false
                                        rms.taxAbTest_A = false;
                                    }
                                }
                            } else {
                                this.getDiscountMarkup(rms.tot, rms.d, rms);
                            }
                            rms.tdtfmt = CT.to_html(tmp1, CT.utils.formatForCurrency(rms.tdt, false, null, true));
                            rms.ttdfmt = CT.to_html(tmp1, CT.utils.formatForCurrency((rms.ttd + (rms.st + rms.sbc + rms.kkc) * totRoomNight), false, null, true));
                            if (rms.d > 0) {
                                rms.sav = CT.to_html(tmp1, CT.utils.formatForCurrency(rms.d, false, null, true));
                            }
                            if (window.taxAbTest === 'a') {
                                rms.avgfmt = CT.to_html(tmp1, CT.utils.formatForCurrency(rms.avg - ((rms.t || 0) + rms.st + rms.kkc + rms.sbc), false, null, true));
                                rms.totalWithoutTaxfmt = CT.to_html(tmp1, CT.utils.formatForCurrency(rms.tot - ((rms.t || 0) + rms.st + rms.kkc + rms.sbc) * roomNights, false, null, true));
                                if (rms.d > 0) {
                                    rms.oamtWithoutTaxfmt = CT.to_html(tmp1, CT.utils.formatForCurrency((rms.tot + rms.d) - ((rms.t || 0) + rms.st + rms.kkc + rms.sbc) * roomNights, false, null, true));
                                } else {
                                    rms.oamtWithoutTaxfmt = ""
                                }
                            } else {
                                if (window.productCode == "AG") {
                                    var agmMarkup = parseInt(rms.agm)
                                    var agmPerRoom = parseInt(agmMarkup / totRoomNight)
                                    rms.avgfmt = CT.to_html(tmp1, CT.utils.formatForCurrency(parseInt(rms.avg + agmPerRoom + (rms.st + rms.kkc + rms.sbc)), false, null, true));
                                } else {
                                    rms.avgfmt = CT.to_html(tmp1, CT.utils.formatForCurrency((rms.avg - (rms.st + rms.kkc + rms.sbc)), false, null, true));
                                }
                            }
                            if (window.productCode == "AG") {
                                var agmMarkup = parseInt(rms.agm)
                                var agmPerRoom = parseInt(agmMarkup / totRoomNight)
                                rms.avgMinusTFmt = CT.to_html(tmp1, CT.utils.formatForCurrency(parseInt(rms.avg + agmPerRoom - rms.t - rms.st - rms.kkc - rms.sbc), false, null, true));
                            } else {
                                rms.avgMinusTFmt = CT.to_html(tmp1, CT.utils.formatForCurrency(rms.avg - rms.t - rms.st - rms.kkc - rms.sbc, false, null, true));
                            }
                            //rms.avgMinusTFmt = CT.to_html(tmp1,CT.utils.formatForCurrency(rms.avg - rms.t, false, null, true));
                            rms.tfmt = CT.to_html(tmp1, CT.utils.formatForCurrency((rms.t + (rms.st + rms.sbc + rms.kkc)), false, null, true));
                        }, that);

                        if (hotelObj.viw)
                            html = that.getVillasRmsMarkup(tmp.rms, false, (hotelObj.pt ? hotelObj.pt[0].name : ""));
                        else
                            html = that.getRmsMarkup(tmp.rms, undefined, hotelObj);

                        quickLookDiv.find('table tbody').html(html);
                        // will be removed later, once I remove the above block and replace with
                        // taxesMarkup function.
                        if (window.taxAbTest === 'a' || window.productCode == "CP") {
                            $('.moreRooms').find('small:first-child').hide();
                        }
                    }
                    if (hotelObj.bfo) {
                        hotelObj.rmsMup = html;
                        //updatedTotalPrice = CT.to_html('HotelPricePartialTpl', hotelObj);
                        //quickLookDiv.parent().find('li.rate').html(updatedTotalPrice);
                    }
                    renderThumbnails();
                };
                
                if (quickLookDiv.attr('data-tc')) {

                    if (hotelObj.priceInfo && hotelObj.priceInfo.tc == 1 && hotelObj.priceInfo.rms && hotelObj.priceInfo.rms.length == 1) {
                        quickLookDiv.find('table tbody').html('').append('<tr><td><span class="loader dotDotDot">&nbsp;</span></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>');
                        CT.utils.updateTrustHotelRoomRates(hotelId, hotelObj, updateQuickLook);
                    }

                    // TODO: move this logic to initializer if it works there - karthik
                    /*
                    trustUrlMap = {
                        city: "city",
                        state: "state",
                        country: "country",
                        noOfRooms: "num_rooms",
                        ckIn: "chk_in",
                        ckOut: "chk_out",
                        ad: "adults1",
                        cd: "children1",
                        nri: "nri"
                    };
                    searchUrl = _.deserialize(window.location.search);
                    _.forEach(trustUrlMap, function(key, index) {
                        if(searchUrl[key]) {
                            trustUrlParams.push({ name: index, value: searchUrl[key] });
                        } else {
                            trustUrlParams.push({ name: index, value: "false" });
                        }
                    });

                    // TODO: change window.location.search to right param - karthik
                    ajaxUrl = Mustache.to_html(CT.settings[CT.app].urls.trust, { pm: trustUrlParams, hotelId: hotelId });
                    $.ajax({
                        url : ajaxUrl,
                        type : 'GET',
                        success : updateQuickLook
                    });
                    */
                } else if (!hotelObj.img && quickLookDiv.attr('data-imgfetch')) {
                    ajaxUrl = CT.to_html(CT.settings[CT.app].urls.thumbnails, {
                        hotelId: hotelId
                    });
                    $.ajax({
                        url: ajaxUrl,
                        type: 'GET',
                        success: updateQuickLook
                    });
                } else {
                    renderThumbnails();
                }

                // send a trackingGA event.
                var action = '',
                    rank = CT.masterJson.getHotel($(e.target).parents("li.listItem").attr("id")).p;
                label = CT.cache[CT.settings.currentTab].paramsForGA + "&rank=" + rank;
                if ($(e.target).is("a"))
                    action = 'H_Details_Viewdetails';
                else if ($(e.target).is("button")) {
                    action = 'H_Details_SelectRoom';
                    label = "rank=" + rank + ",hotelid=" + hotelId;
                }

                if ($currentTab.find('.showCommissionLink i').hasClass('hideComm')) {
                    setTimeout(function() {
                        $currentTab.find('.listItem a.agToolTip').show();
                    }, 400)
                }
                CT.utils.helperFunctions.trackGAEventWrapper(window.twoCol ? 'Hotels_TR_2col' : 'Hotels_TR', action, label, '100');
            },



            /* this function takes filter settings and filter obj as input and calls updatefiltermetadata to update the view
             * container and item are optional parameters. If necessary we can use it
             * @container: is the container having the items list Eg: '.viewController'
             * @item: is the class of item Eg: '.listItem'
             * @settings: is taken from settings.js
             * @masterFilterObj: is the object that has the filters settings made in the view
             */
            applyFilters: function(e, settings, masterFilterObj, container, item, dataSettings) {
                
                /*update the url based on filter params  - TODO move the below block to a seperate function */
                if (!dataSettings || !dataSettings.onload) { // below block to be executed only on user interaction with filter elements.
                    var searchParams = _.deserialize(window.location.search.substr(1).replace(/\+/g, ' ')); // TODO change window.location.href to data.url
                    for (var k in masterFilterObj) {
                        if (masterFilterObj[k].length > 0) {
                            searchParams[k] = masterFilterObj[k].join("-");
                        } else if (searchParams[k]) {
                            delete searchParams[k];
                        }
                    }
                    CT.settings.routes.navigate('/results?' + _.serialize(searchParams), {
                        trigger: false,
                        replace: true
                    })
                }


                var obj = cf.applyfilters(settings, masterFilterObj, container, item);
                this.updateFilterMetaData(obj.eleArr, obj.eleCount);
            }, // applyFilters



            initiatePackageBooking: function(evt) {
                $currentElem = $(evt.target), $hBlock = $currentElem.closest('li');
                $currentElem.attr("disabled", "disabled");
                $currentElem.addClass("loading");
                $('.glassShield').show();
                var form = $("#FormFields").get(0);
                //hotels
                var searchParams = _.deserialize(window.location.search.substr(1).replace(/\+/g, ' '));
                bookingCode = $hBlock.attr("data-bookingcode");
                roomTypeCode = $hBlock.attr("data-roomtypecode");

                hotelId = $hBlock.attr("data-htid");
                hotelIndex = $hBlock.attr("data-htinx");
                var dataItem = CT.masterJson.get().ht[hotelIndex];

                tripAdviseRating = $hBlock.attr("data-tastar");


                var frm_mapper = {
                    'HChkIn': 'chk_in',
                    'HChkOut': 'chk_out',
                    'HDestCode': 'dest_code',
                    //'HState' : 'state',
                    'HCountry': 'country',
                    'HAreaName': 'areaName',
                    'HCity': 'city',
                    'HNumRooms': 'num_rooms'
                };

                var childrenArr = [];
                var adultArr = [];
                _.each(_.keys(searchParams), function(elem, idx) {
                    melem = _.pascalCase("h_" + elem);
                    if (typeof frm_mapper[melem] != 'undefined') {
                        $("#" + melem).val(searchParams[frm_mapper[melem]].replace(/\+/g, ' '));
                    } else if (elem != 'hotelId' && elem != 'loc') {
                        $('<input/>').attr({
                            type: 'hidden',
                            id: _.capitalize(elem),
                            name: elem,
                            value: searchParams[elem]
                        }).appendTo(form);

                        if (elem.indexOf("children") != -1) {
                            childrenArr.push(elem);
                        }

                        if (elem.indexOf("adult") != -1) {
                            adultArr.push(elem);
                        }
                    }
                });
                if (form["carrier"]) {
                    form["carrier"].value = "";
                }
                if (form["airline"]) {
                    form["airline"].value = "";
                }

                form["num_children"].value = childrenArr.length;
                form["num_adults"].value = adultArr.length;
                form["star_rating"].value = tripAdviseRating;
                form["hotelid"].value = hotelId;
                form["bookingCode"].value = bookingCode + "|si-" + CT.masterJson.get().sid;
                form["roomtypecode"].value = roomTypeCode;

                //child Age fix
                var caHash = {};
                for (var room = 0; room < 4; room++) {
                    var caKey = "ca" + (room + 1);
                    if (form[caKey]) {
                        caHash[caKey] = form[caKey].value.split(",");
                        $(form[caKey]).remove();
                    }
                }

                for (var caKey in caHash) {
                    for (var ca = 0; ca < caHash[caKey].length; ca++) {
                        $(form).append($("<input type='hidden' name='" + caKey + "' value='" + caHash[caKey][ca] + "'/>"));
                    }
                }
                //child Age fix

                //flight

                //form["from_city"].value = searchParams.origin.split(",")[0];
                //form["to_city"].value = searchParams.destination.split(",")[0];

                form["timestamp"].value = new Date().getTime();
                form["ts"].value = new Date().getTime();

                var searchJson = CT.masterJson.get().fl;
                var jsonCopy = $.extend(true, {}, searchJson),
                    flMapping = jsonCopy.mapping,
                    onwardFlightJson = [],
                    returnFlightJson = [],
                    flSolution = jsonCopy;

                var onwardFlightObj = $hBlock.find(".flightInfo .summary").get(0);
                var onwardIndx = $(onwardFlightObj).attr("data-foninx");
                //TODO: dirty hack for a bug, remove below 2 lines once the bug is fixed.
                /*if(onwardIndx == null){
                                        onwardIndx = $(onwardFlightObj).attr("data-price").replace('data-foninx=','').replace('"',"").replace('"',"")
                                    }*/

                form['departureJourneyId'].value = onwardIndx;

                var returnFlightObj = $hBlock.find(".flightInfo .summary").get(1);
                var returnIndx = $(returnFlightObj).attr("data-frtinx");
                //TODO: dirty hack for a bug, remove below 2 lines once the bug is fixed.
                /*if(returnIndx == null){
                                        returnIndx = $(returnFlightObj).attr("data-price").replace('data-frtinx=','').replace('"',"").replace('"',"");
                                    }*/

                form['arrivalJourneyId'].value = returnIndx;

                var onwardFlightJson = flMapping.onward[onwardIndx];
                var returnFlightJson = flMapping['return'][returnIndx];

                var flDetails = {};
                _.forEach(onwardFlightJson.c, function(cIdx, index) {
                    CT.FlightSolution.splitFk(flSolution.content[cIdx]);
                    searchResultViewSettings.addFlightLegsInfo('out', flSolution, cIdx, index + 1, form);
                });

                _.forEach(returnFlightJson.c, function(cIdx, index) {
                    CT.FlightSolution.splitFk(flSolution.content[cIdx]);
                    searchResultViewSettings.addFlightLegsInfo('ret', flSolution, cIdx, index + 1, form);
                });

                CT.utils.addHiddenField(form, "out_no_legs", onwardFlightJson.summary.ids.length);
                CT.utils.addHiddenField(form, "ret_no_legs", returnFlightJson.summary.ids.length);

                var isCombo = CT.FlightSolution.isComboCombination(onwardIndx, returnIndx, searchJson);

                var outFkObj = CT.FlightSolution.getCheapFareSelected(onwardFlightJson, isCombo);
                var retFkObj = CT.FlightSolution.getCheapFareSelected(returnFlightJson, isCombo);
                var outFk = outFkObj.fk;
                var retFk = retFkObj.fk;

                //flag to check internaitonal vs domestic
                if (flSolution.jsons.searchType.isIntl === true) {
                    CT.utils.addHiddenField(form, "intl", "y");
                    CT.utils.addHiddenField(form, "fare_key", outFk); //you can pass retfk as well because both are same
                } else {
                    CT.utils.addHiddenField(form, "out_fare_key", outFk);

                    var outFlType = CT.FlightSolution.getFlightType(onwardFlightJson, isCombo);
                    CT.utils.addHiddenField(form, "out_refundable", outFlType);

                    CT.utils.addHiddenField(form, "ret_fare_key", retFk);

                    var retFlType = CT.FlightSolution.getFlightType(returnFlightJson, isCombo);
                    CT.utils.addHiddenField(form, "ret_refundable", retFlType);
                }

                form["dpAmount"].value = $hBlock.attr("data-price");


                //flight + hotel
                form["topLevelRateRules"].value = flSolution.jsons.topLevelRateRules;
                form["emiJson"].value = flSolution.jsons.emiJson;
                /*if(dataItem.ehotelIdmi) {
                                        form["emiJson"].value = flSolution.jsons.emiJson;
                                    }*/

                var pHttps = window.pHttps;
                if (pHttps == undefined || pHttps == null) {
                    pHttps = "https";
                }

                pHttps = "http";

                form.setAttribute("action", pHttps + "://" + location.host + "/packages/itinerary/create");
                form.submit();
                return false;

            },


            addFlightLegsInfo: function(direction, flightObject, cIdx, idx, form) {
                var JSONHiddenFields = {};
                JSONHiddenFields[direction + "_leg_aircode_" + idx] = flightObject.content[cIdx].ac.split(" ")[0];
                JSONHiddenFields[direction + "_leg_flt_num_" + idx] = flightObject.content[cIdx].ac.split(" ")[1];
                JSONHiddenFields[direction + "_leg_arrives_" + idx] = flightObject.content[cIdx].a;
                JSONHiddenFields[direction + "_leg_arrives_date_" + idx] = flightObject.content[cIdx].ad;
                JSONHiddenFields[direction + "_leg_from_" + idx] = flightObject.content[cIdx].fr;
                JSONHiddenFields[direction + "_leg_to_" + idx] = flightObject.content[cIdx].to;
                JSONHiddenFields[direction + "_leg_oa_" + idx] = flightObject.content[cIdx].oa;
                JSONHiddenFields[direction + "_leg_oa_" + idx] = flightObject.content[cIdx].oa;
                JSONHiddenFields[direction + "_leg_departs_date_" + idx] = flightObject.content[cIdx].dpd;
                JSONHiddenFields[direction + "_leg_cabin_type_" + idx] = flightObject.content[cIdx].ct;
                JSONHiddenFields[direction + "_leg_via_" + idx] = flightObject.content[cIdx].ct;
                JSONHiddenFields[direction + "_leg_stops_" + idx] = 0;
                if (flightObject.jsons[flightObject.content[cIdx].fr]) {
                    JSONHiddenFields[direction + "_leg_toAirportName_" + idx] = flightObject.jsons[flightObject.content[cIdx].fr].n;
                    JSONHiddenFields[direction + "_leg_toCityName_" + idx] = flightObject.jsons[flightObject.content[cIdx].fr].c;
                }
                for (var k in JSONHiddenFields) {
                    CT.utils.addHiddenField(form, k, JSONHiddenFields[k]);
                }
            },

            updateFilterMetaData: function(eleArrArr, eleCount) {
                var $currentTab = $('#ResultContainer_' + CT.settings.currentTab);

                //cache filtered element count
                CT.filteredCount = eleCount;

                //update showingCount
                this.updateShowCount(eleCount);

                if (eleCount > 0) {
                    $currentTab.find('.zeroResults').remove();
                    _.forEach(eleArrArr, function(eleArr) {
                        _.forEach(eleArr, function(ele) {
                            $(ele).addClass('filtered').show();
                        });
                    });
                    //trigger pagination if in map view
                    if ($('body').hasClass('mapView')) {
                        $currentTab.trigger('pagination.apply', [$currentTab]);
                    }
                    $currentTab.find('.primaryBar .showingCount').html(eleCount);
                    CT.cache[CT.settings.currentTab].filterValues.undoFilterObj = $.extend(true, {}, CT.applyTheseFilters);
                } else {
                    $currentTab.find('.zeroResults').remove();
                    this.showZeroOrFewResultNote(undefined, CT.messages[CT.app].zeroResults['filter']);
                    $currentTab.find('.listViewResults .pagination').hide();
                }
            },


            zeroResults: function(refKey, newMsg) {
                var $currentResults = this.$el,
                    msg = $.extend(true, {}, CT.messages[CT.app].zeroResults[refKey]),
                    html;

                if (window.isWL && refKey == "zeroResult" && newMsg) {
                    msg.title = newMsg;
                }

                if (refKey == 'genericError') {
                    $('.instHeader').hide();
                }


                if (msg.call) {
                    msg.callm = CT.to_html(CT.messages[CT.app].zeroResults.call, {
                        phoneSales: CT.settings[CT.app].phoneNo.phoneSales
                    });
                }
                if (window.isMobileUA && window.isMobileUA == true) {
                    if (msg.btnlink) {
                        msg.btnlink = "/getaways"
                    }
                    $("#GlobalNav").find(".tempFiltersButton").hide();
                }
                //html = Mustache.to_html($("#ZeroResultsTpl").html(), msg);
                //$currentResults.addClass('blankSlate').find('.listView').prepend(html);
                $('#ResultContainer_' + CT.settings.currentTab).find('.messageScreen').remove();
                if (window.isMobileUA && window.isMobileUA == true) {
                    $('#ResultContainer_' + CT.settings.currentTab).append(CT.to_html('BlankSreenMobileTemplate', msg));
                } else {
                    $('#ResultContainer_' + CT.settings.currentTab).append(CT.to_html('BlankSreenTemplate', msg));
                    this.getPayLoadForEvent(msg);
                }
                $('#ResultContainer_' + CT.settings.currentTab).find(' section.viewContainer, section.primaryBar').hide();
                $('#ResultContainer_' + CT.settings.currentTab).find('#area').hide();
                $('#ResultContainer_' + CT.settings.currentTab + ' .messageScreen').css('min-height', CT.utils.setElementSize([".globalNav", ".globalFooter"], 'height')).css('min-height');
                $('.glassShield').hide();

            },


            /*
             * this function is common for disamberror and dynamic loading failure error
             */
            disambError: function(status) {
                var $currentResults = this.$el,
                    msg = $.extend(true, {}, CT.messages[CT.app].zeroResults["Error" + status]),
                    html;

                if (window.isMobileUA && window.isMobileUA == true) {
                    if (msg.btnlink) {
                        msg.btnlink = "/getaways"
                    }
                    $("#GlobalNav").find(".tempFiltersButton").hide();
                }
                //html = Mustache.to_html($("#hotelDisambError").html(), msg);
                //$(document.body).prepend(html);
                //$currentResults.addClass('blankSlate').find('.listView').prepend(html);
                $("#HotelSearch").find("#Tags").attr("data-tipsytitle", CT.messages.hotel.TryFreshSearch).tipsy({
                    gravity: 'N',
                    trigger: 'manual',
                    className: 'popOver',
                    html: true,
                    opacity: 1,
                    title: "data-tipsytitle"
                }).tipsy('show');
                if (window.isMobileUA && window.isMobileUA == true) {
                    $('#ResultContainer_' + CT.settings.currentTab).append(CT.to_html('BlankSreenMobileTemplate', msg));
                } else {
                    $('#ResultContainer_' + CT.settings.currentTab).append(CT.to_html('BlankSreenTemplate', msg));
                    this.getPayLoadForEvent(msg);
                }
                $('#ResultContainer_' + CT.settings.currentTab).find(' section.viewContainer, section.primaryBar').hide();
                $('#ResultContainer_' + CT.settings.currentTab).find('#area').hide();
                $('#ResultContainer_' + CT.settings.currentTab + ' .messageScreen').css('min-height', CT.utils.setElementSize([".globalNav", ".globalFooter"], 'height')).css('min-height');
                $('.glassShield').hide();

            },



            postRender: function() {
                $("#Interstitial").hide();
                $("#Result, #dpHeaderSection, #Flash").show();
                return this
            },
            updateTravellerState: function (data) {
                var nextState = {
                    SIGNED_IN_GST: "TRIAL",
                    UNSIGNED_GST: "TRIAL",
                    SIGNED_IN_NON_GST: "TRIAL",
                    SIGNED_IN: "TRIAL"
                }
                var dataToBeSent = {
                    id: data.id,
                    userState: nextState[data.userState] || data.userState,
                    gstin: data.gstin,
                    emailID: data.email,
                    gst_holder_name: workPlusUserDetails.gst_holder_name || ''
                };
                if (workPlusUserDetails.gst_holder_name)
                    dataToBeSent.gst_holder_name = workPlusUserDetails.gst_holder_name
                return $.ajax({
                    type: 'PUT',
                    url: data.url,
                    contentType: 'application/json',
                    data: JSON.stringify(dataToBeSent)
                })
            },
            postGstForWPUser:function(status, gst) {
                var url = '/workplus/user/update';
                if (workPlusUserDetails.id) {
                    this.updateTravellerState({
                        url: url,
                        email: workPlusUserDetails.email,
                        id: workPlusUserDetails.id,
                        userState: status,
                        gstin: gst
                    }).success(function () {
                        window.location.reload();
                    })
                } else {
                    this.getGstInfo().success(function (data) {
                        if (data.user && data.user.id && data.user.username) {
                            this.updateTravellerState({
                                url: url,
                                email: data.user.username,
                                id: data.user.id,
                                userState: status,
                                gstin: gst
                            }).success(function () {
                                window.location.reload();
                            })
                        }
                    })
                }
            },

            getGstInfo:function(cb) {
                var path = '/partial/account/profile';
                return $.ajax({
                    url: path,
                    headers: {
                        'Accept': 'text/json'
                    },
                    type: 'GET'
                }).success(
                    function (data) {
                        if (data.user && data.user.gst_details && data.user.gst_details[0]) {                            
                            workPlusUserDetails.gst_holder_name = data.user.gst_details[0].gst_holder_name
                            workPlusUserDetails.gst_number = data.user.gst_details[0].gst_number
                        }
                        if (cb) cb()
                    }
                ).error(
                    function (err) {
                        if (cb) cb()                        
                    }
                )
            },

            getWorkPlusUserState: function(cb) {
                var userId = unescape(CT.utils.cookies.read('userid'));
                window.workPlusUserDetails = {
                    id: userId.split('|').reverse()[0],
                    email: userId.split('|')[0]
                }
                var that = this;
                $.ajax({
                    url: ('/workplus/user/state?userId=') + userId.split('|').reverse()[0],
                    method: "GET",
                    success: function (data, statusText, res){ 
                        that.workPlusUserStateSuccess(data, statusText, res, cb)
                    },
                    error: function () {

                    }
                });
            },

            workPlusUserStateSuccess: function (data, statusText, res, cb) {
                if (res && res.status == 204) {
                    console.log('user does not exist')
                } else if (res && res.status == 200) {
                    workPlusUserDetails.status = data
                }
                this.getGstInfo(cb)
            }

        } // searchResultViewSettings ends



        /* =============================== PRIVATE METHODS ============================ */

        function prepareSkeleton() {
            var $result = $('#Result')
            $('#' + window.twoCol ? window.wgTplForHt ? 'HotelCardTpl' : window.mainTemplate : 'HotelListTpl').appendTo($result)
            $('#HotelRmsRowTpl').appendTo($result)
            $('#HotelImgThumbTpl').appendTo($result)
            $('#ShortlistItemTpl').appendTo($result)
            return store('Skel').set('res', $('.resultTemplate').html())
        }

        //mixpanel Srp Ranks logging
        function mixpanelsrpRanks(hotelDisplayData) {
            if (window.mixpanelswitch && window.mixpanel) {
                var hotelDisplayDataClone = ([]).concat(hotelDisplayData);
                var trackInfo = CT.cache[CT.settings.currentTab].searchParams.all;
                var srpRanks = [];
                var srpFilters = [];
                var srpSort = [];
                if (CT.cache[CT.settings.currentTab].recentFilterData) {

                    var seletedFilters = ['propertyType', 'starFilter', 'taStarRating', 'amenity', 'price', 'area', 'deals', 'freeCancellation', 'popHotels', 'payAtHotel', 'hotelName'];
                    var filterType = _.pick(trackInfo, seletedFilters);
                    _.each(filterType, function(value, key) {
                        if (value)
                            srpFilters.push("filter_" + key + ":" + value);
                        else
                            srpFilters.push("filter_" + key + ":N/A");
                    });
                } else {
                    srpFilters.push("filter_propType:BNB-BH-GH-HH-HS-NOCAT-RS-SA-SP");
                    srpFilters.push("filter_star:5-4-3-2-1");
                }
                if (trackInfo["sort"] && trackInfo["sort"] != "featured") {
                    srpSort.push("sort_" + trackInfo["sort"] + ":" + trackInfo["sort_order"]);
                } else {
                    srpSort.push("sort_featured:asc");
                }
                hotelDisplayDataClone = hotelDisplayDataClone.splice(0, 50);
                if (hotelDisplayDataClone.length == 0) {
                    srpRanks.push("N/A");
                }
                _.each(hotelDisplayDataClone, function(value, key) {
                    srpRanks.push((key + 1) + ":" + value.id + ":" + encodeURIComponent(value.nm));
                });
                CT.utils.trackers.ctanalyticsTrackingData("Hotels_TR", "srpRanksRendered", "srpRanks", {
                    "searchData": CT.utils.trackers.mixpanelTrackingData,
                    'srpFilterType': srpFilters,
                    'srpSortType': srpSort,
                    'srpRanks': srpRanks
                }, 'rank');
            }
        }

        function getResultView(tabId) {
            var newId = 'ResultContainer_' + tabId,
                v
            if ($('#' + newId)[0]) searchResultViewSettings.$el = $('#' + newId)
            else searchResultViewSettings.attributes.id = newId
            searchResultViewSettings.attributes["data-tabid"] = tabId
            searchResultViewSettings.attributes['class'] = 'resultContainer'
            var v = View(searchResultViewSettings, commonSearchResultSettings);
            v.$el.data('v', v)
            return v
        }



        function setCaches(tabId) {
            CT.cache[tabId] = CT.cache[tabId] || {} // Creating cache for this tab Id - contains json, ??
            CT.cache[tabId].maps = {}
            //CT.cache.views[tabId] = CT.cache.views[tabId] || {} //Creating cache for view TODO needed?
            return CT.cache
        }


        // Loads maps dependencies. See 'mapinit' subscription below
        function loadMapsDeps(callback) {
            //>>excludeStart("asyncRequireLoader", pragmas.asyncRequireLoader);
            if (window.define)
                require(['hotels/gmapHotels'], function() {
                    CT.cache[CT.settings.currentTab].mapsDependencyLoaded = true
                    callback({
                        gmapHotelsReady: true,
                        gmapReady: true
                    })
                })
            else
                //>>excludeEnd("asyncRequireLoader");
                CT.getScript(CT.settings[CT.app].urls.gmapHotelsJs, function() {
                    CT.cache[CT.settings.currentTab].mapsDependencyLoaded = true
                    callback({
                        gmapHotelsReady: true,
                        gmapReady: true
                    })
                })
        }


        /* ============================= Module execution starts here ================================ */
        // Parag - this first result container will act as a template for other results
        hotelsSkeleton = $('.resultContainer').addClass('resultTemplate').removeClass('resultContainer').html()

        CT.subscribe('instasearch.hotelContentReady', function(json, callbackParams, _airBnbContent) {
            try {
                var newResultView = fetchHotelsJson.newResultView
                var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
                if (_airBnbContent) {
                    var staticJson = CT.masterJson.update(json);
                } else {
                    var staticJson = CT.masterJson.set(json);
                }
                var mJson = json;
                if (staticJson.ht) {
                    if (_airBnbContent) {
                        CT.masterJson.updateGroupedHotels(staticJson.ht);
                    } else {
                        CT.masterJson.setGroupedHotels(staticJson.ht);
                    }
                    newResultView.postRender()[CT.app === 'dp' ? 'dpRender' : 'renderStatic'](staticJson, paramsHash);
                } else {
                    if (window.isWL && staticJson.msg) { //Making changes for WL international hotels blocking
                        newResultView.postRender().zeroResults('zeroResult', staticJson.msg);
                    } else {
                        newResultView.postRender().zeroResults('genericError');
                    }
                }
                if (callbackParams.isDateLess == true) {
                    window.showTags = false;
                    console.warn("place searchResult");
                    $(".tagsSorting").remove();
                    CT.fire('initialMasterJSON.ready', [staticJson, newResultView, callbackParams])
                    CT.fire('recent.update', [paramsHash]) //save pers after results are rendered
                    if (window.isResultsPage && !window.prefilledFormOnce) {
                        CT.cache.views.searchForm.fire('searchForm.update', [new Pers()]);
                        window.prefilledFormOnce = true;
                    }

                    $(document.body).removeAttr('data-busy');
                }

                //To update global property for tracking the market nature of the city
                CT.utils.trackers.mixpanelTrackingData['marketNature'] = mJson.hmn ? mJson.hmn : "N/A";
                CT.utils.trackers.clevertapGlobleData.marketNature = mJson.hmn ? mJson.hmn : "N/A";
            } catch (e) {
                _errs.push(e);
                throw e;
            }
        });


        CT.subscribe('search.disambError', function(err) {
            try {
                var newResultView = fetchHotelsJson.newResultView
                if (err.status == 400 || err.status == 500) {
                    newResultView.postRender().disambError(err.status);
                } else
                    newResultView.postRender().zeroResults('genericError');

            } catch (e) {
                _errs.push(e);
                throw e;
            }
            CT.utils.CTLogger.logToServer();
        });


        CT.subscribe('instasearch.dynamicLoadReady', function(hotelContent, scData, callBackFuncParams, _airBnbContent) {
            if (scData) {
                var uiShortliestedHotelIds = CT.utils.shortlists.getAllHotelIds(CT.cache[CT.settings.currentTab].searchParams.all.city);
                var isLoggedIn = CT.utils.readCTAuthCookie();                
                if(!scData.slid){
                    scData.sl = uiShortliestedHotelIds;
                    scData.slid = CT.cache[CT.settings.currentTab].searchParams.all.city;
                } else if(uiShortliestedHotelIds.length > 0) {
                    scData.sl = uiShortliestedHotelIds.concat(scData.sl);
                }
                window.CT.subscribe("updateShortlistId", function(data){
                    CT.masterJson.setShortlistId(data.shortlistId);
                });
                //Sync shortlisted hotel on UI
                window.CT.utils.shortlists.sync();
                
                var scDataShortListHash = _.reduce(scData.sl, function(prev, curr) {
                    prev[curr] = true;
                    return prev;
                }, {});
                var slistLength = scData.sl ? scData.sl.length : 0;
                CT.masterJson.setShortlistedHotelCount(slistLength);
                CT.masterJson.setShortListEnabled(scData.sle);
                CT.masterJson.setShortlistId(scData.slid);
            }
            //try{
            var newResultView = fetchHotelsJson.newResultView
            var paramsHash = CT.cache[CT.settings.currentTab].searchParams.all;
            var i = 0;
            var z = 0;
            var staticJson = scData;
            var stpMsg = scData.stpmsg || "This is the highest price for this room within a 30-day window around your check-in date"; //Hardcoding stp msg for  testing
            var disMsg = scData.dismsg || "This is the property's<br> standard rate";
            if (disMsg == "This is the property's standard rate") {
                disMsg = "This is the property's<br> standard rate"
            }
            window.showBundledPrice = scData.sbp || false;
            //Bundle TAX feature only for b2c .com domain so making for others domain and channel type as false
            if (window.showBundledPrice && (window.product == "B2B" || window.countryCode != "in")) {
                window.showBundledPrice = false;
            }

            CT.settings.hotel.sid = staticJson.sid;
            //CT.settings.hotel.airBnbUrls.updateCall = "http://dev.cleartrip.com/hotelstatic/json/staticCityContent.json";
            if (callBackFuncParams.airBnb) {
                CT.settings[CT.app]["airBnb"].urls.updateCall = staticJson.cbu;
                CT.settings[CT.app]["airBnb"].urls.updateCallTimer = staticJson.cbt ? staticJson.cbt : 0;
                if (CT.settings[CT.app]["airBnb"].urls.updateCall == undefined) {
                    CT.settings.hotel.airBnbRatesCallDone = true;
                }
            }
            CT.cache[CT.settings.currentTab].sid = staticJson.sid;
            var sortOrder = staticJson.rn;
            if (callBackFuncParams.airBnb && staticJson.cbu != undefined && _airBnbContent && _airBnbContent.ht.length > 0) {
                var sortable = [];
                for (var k in sortOrder) {
                    sortable.push([k, sortOrder[k]])
                    sortable.sort(function(a, b) {
                        return a[1] - b[1]
                    })
                }
                for (var k = 0; k < sortable.length; k++) {
                    if (k >= 5 && k % 5 == 0) {
                        sortable.splice(k, 0, [_airBnbContent.ht[z].id, k])
                        z++;
                    }
                }
                for (var k = 0; k < _airBnbContent.ht.length; k++) {
                    if (k >= z) {
                        sortable.push([_airBnbContent.ht[z].id, k])
                    }
                }
                sortOrder = _.object(sortable)
            }

            if (callBackFuncParams.opaqueHotelId) {
                var sortable = [],
                    m = 0;
                for (var k in sortOrder) {
                    sortable.push([k, sortOrder[k]])
                    sortable.sort(function(a, b) {
                        return a[1] - b[1]
                    })
                }
                for (var k = 0; k < sortable.length; k++) {
                    if (k >= 3 && k % 3 == 0) {
                        sortable.splice(k, 0, [callBackFuncParams.opaqueHotelId[m], k])
                        m++
                    }
                }
                for (var k = 0; k < callBackFuncParams.opaqueHotelId.length; k++) {
                    if (k >= m) {
                        sortable.push([callBackFuncParams.opaqueHotelId[m], k])
                    }
                }
                sortOrder = _.object(sortable)
            }
            var bookingCookie = CT.utils.cookies.read("hotelBookedCount"),
                isHotelPresent = false,
                lastBookedHotelCnt = 0,
                bookingCookieArr;
            if (bookingCookie) {
                bookingCookieArr = bookingCookie.split("|");
                lastBookedHotelCnt = parseInt(bookingCookieArr[0]);
                lastBookedHotelId = bookingCookieArr[1];
                if (lastBookedHotelCnt >= 2) {
                    isHotelPresent = sortOrder[lastBookedHotelId] ? true : false;
                    if (isHotelPresent == true) {
                        CT.cache[CT.settings.currentTab].lastBooked = true;
                        CT.cache[CT.settings.currentTab].lastBookedHotelId = lastBookedHotelId;
                    }
                }
            }
            var isShortListEnabled = CT.masterJson.isShortListEnabled();
            var sortedHT = _(hotelContent.ht).each(function(hotel, idx) {
                if (isHotelPresent) {
                    hotel.orgIndex = sortOrder[hotel.id];
                    if (hotel.id == lastBookedHotelId) {
                        hotel.p = 1;
                    } else {
                        hotel.p = ++sortOrder[hotel.id];
                    }
                } else {
                    hotel.p = sortOrder[hotel.id];
                }
                hotel.listIdx = idx;
                if (scDataShortListHash[hotel.id]) {
                    hotel.isShortlisted = true
                } else {
                    hotel.isShortlisted = false;
                }
                hotel.isShortListEnabled = isShortListEnabled;
                hotel.stpmsg = stpMsg;
                hotel.dismsg = disMsg;
            });
            // _.sortBy(hotelContent.ht, function(hotel) {
            //     return hotel.p;
            // })

            staticJson = hotelContent;
            //caches[tabId].json = staticJson // storing the json that arrived //TODO add a module for accessing and modifying master json
            if (!staticJson.ht || (staticJson.ht && staticJson.ht.length == 0)) {
                if (window.isWL && staticJson.msg) { //for international search blocking in whitelabel flow
                    newResultView.postRender().zeroResults('zeroResult', staticJson.msg);
                } else {
                    newResultView.postRender().zeroResults('zeroResult');
                }
            } else {
                staticJson = CT.masterJson.set(staticJson);
                CT.masterJson.setGroupedHotels(staticJson.ht);
                var mJson = CT.masterJson.get();
                if (CT.subProd == "wg") {
                    for (var i = 0; i < mJson.wd.d.length; i++) {
                        if ((mJson.wd.d[i].d == 0 || mJson.wd.d[i].t == 0) && mJson.wd.d[i].n != paramsHash.from) {
                            var htObjArr = _.filter(mJson.ht, function(obj) {
                                return (obj.c == mJson.wd.d[i].i && obj.d != 0)
                            });
                            if (htObjArr.length > 0) {
                                if (mJson.wd.d[i].d == 0)
                                    mJson.wd.d[i].d = htObjArr[0].dt;
                                if (mJson.wd.d[i].t == 0)
                                    mJson.wd.d[i].t = htObjArr[0].tt;
                            }
                        }
                    }
                }
                newResultView.postRender()[CT.app === 'dp' ? 'dpRender' : 'renderStatic'](staticJson, paramsHash); // render reuslts with the modified master json
                CT.fire('initialMasterJSON.ready', [staticJson, newResultView, callBackFuncParams]);

                if (paramsHash.utm_source && _.find(staticJson.ht, {
                        'id': paramsHash.dest_code
                    }) != undefined) {
                    var hotelDetails = CT.masterJson.getHotel(paramsHash.dest_code);
                    //do not apply hotel specific search if the hotel is unavailable
                    if (hotelDetails.priceInfo)
                        paramsHash.hotelName = hotelDetails.nm;
                }
                if (CT.subProd == "wg") {
                    paramsHash.wg_rs = true;
                }
                CT.fire('recent.update', [paramsHash]) //save pers after results are rendered

                if (window.isResultsPage && !window.prefilledFormOnce) {
                    CT.cache.views.searchForm.fire('searchForm.update', [new Pers()]);
                    window.prefilledFormOnce = true;
                }

                $(document.body).removeAttr('data-busy');

                CT.utils.CTLogger.logToServer();
            }

            // CT.utils.InstaSearch.clear();
            if (CT.cache[window.parent.CT.settings.currentTab].roomChecked != undefined) {
                CT.utils.helperFunctions.openHotelModalWindow(CT.cache[window.parent.CT.settings.currentTab].roomChecked, '#highlights')

            }

            /*}
                            catch(e){
                                _errs.push(e);
                                throw e;
                            }*/
        });



        /**
         * @param data - Object - all params of the url + tab id + routes data
         */
        CT.subscribe('results', function(paramsHash) { // fired from searchTab.js
            // For visual optimizer 
            if (typeof(_vis_opt_top_initialize) == "function") {
                // _vis_opt_goal_conversion(203);
                // _vis_opt_goal_conversion(222); // for ie
                //var locRef =  window.location.href;
                /* if(locRef.indexOf("utm_source=tripadvisor")!=-1){
                                     _vis_opt_goal_conversion(224);
                                 }else if(locRef.indexOf("org=drs")!=-1){
                                     _vis_opt_goal_conversion(223);
                                    }*/
            }



            CT.utils.cookies.create("defaultHotelsPage", true, 2 / 24);
            if (window.isResultsPage && window.isNewResultsPageSearch == null) {
                window.isNewResultsPageSearch = false; // results is from results-page-load
            } else if (window.isResultsPage && window.isNewResultsPageSearch == false) {
                window.isNewResultsPageSearch = true; // results is from results-page-load's modify search.
            } else {
                window.isNewResultsPageSearch = true; //results is from search page load
            }
            $(window).unbind('.infiList')
            if (window._gaq && window.isNewResultsPageSearch) {
                window._gaq.push(['_trackPageview']);
            }

            if (window.isResultsPage && !window.spotNonCleartripReferrer_onResultPage) { //TODO refactor
                CT.utils.helperFunctions.spotNonCleartripReferrer();
                window.spotNonCleartripReferrer_onResultPage = true;
            }

            var /* Number */ tabId = paramsHash.tabId || CT.settings.currentTab; // tab Id was updated in searchTab.js when tab was created or reused
            var /* View */ newResultView; // storage variable for the new resultView
            var /* CT.cache */ caches = setCaches(tabId) // set cache in CT for this view. 'caches' points to CT.cache

            CT.cache[CT.settings.currentTab].onLoad = true;
            CT.settings.hotel.airBnbRatesCallDone = false;
            //$(document.body).attr('data-busy', true) // setting a flag so that a new modify search does not affect this one (upto a dynamic loading call)
            if (window.hotelTwoCol == true) {
                $(document.body).removeClass("home").addClass(window.srpClass + " srp cTest");
            } else {
                $(document.body).removeClass("home").addClass(window.srpClass + " srp");
            }

            if ($('#ResultContainer_' + tabId).length > 0) View.destroy($('#ResultContainer_' + tabId).data('v')) // result container already exists. Replace it
            newResultView = getResultView(tabId) // get the result View object

            $(document).delegate("h1 .tempFiltersButton", "click", function(e) {
                newResultView.ipadHotelChanges(e)
            });



            fetchHotelsJson.newResultView = newResultView;

            //check for XSS 
            if (CT.utils.helperFunctions.urlContainsScriptTag()) {
                $(".resultTemplate").hide();
                CT.fire("search.disambError", [{
                    status: 400
                }]);
                return false;
            }
            newResultView.renderSkeleton(paramsHash, tabId); //creates a .resultContainer and appends to the main #results div
            //Register Clevertap events data(global properties)
            var dx = "N/A",
                los = "N/A",
                roomNights = "N/A",
                dayOfCheckIn = "N/A";
            if (CT.cache[CT.settings.currentTab].searchParams.processed.chk_in && CT.cache[CT.settings.currentTab].searchParams.processed.chk_out && CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms) {
                dx = String(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, "DD/MM/YYYY").diff(moment(), "days") + 1);
                los = String(Math.abs(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, "DD/MM/YYYY").diff(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_out, "DD/MM/YYYY"), "days")));
                dayOfCheckIn = moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, 'DD/MM/YYYY', true).format('dddd');
                var roomNgts = parseInt(CT.cache[CT.settings.currentTab].searchParams.processed.num_rooms) * Math.abs(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_in, "DD/MM/YYYY").diff(moment(CT.cache[CT.settings.currentTab].searchParams.processed.chk_out, "DD/MM/YYYY"), "days"));
                roomNights = String(roomNgts);
            }
            CT.utils.trackers.clevertapGlobleData = {
                "platform": "Desktop",
                "destinationCity": CT.cache[CT.settings.currentTab].searchParams.processed.city,
                "destinationCountry": $('#Country').val() ? $('#Country').val() : "N/A",
                "marketNature": "N/A",
                "dx": dx,
                "rooms": CT.cache[CT.settings.currentTab].searchParams.all.num_rooms,
                "los": los,
                "DayOfWeek_checkIn": String(dayOfCheckIn),
                "roomNights": roomNights,
                "pax": String(CT.cache[CT.settings.currentTab].searchParams.all.adults + CT.cache[CT.settings.currentTab].searchParams.all.childs),
                "numAdults": String(CT.cache[CT.settings.currentTab].searchParams.all.adults),
                "numChild": String(CT.cache[CT.settings.currentTab].searchParams.all.childs),
                "childAge": CT.cache[CT.settings.currentTab].searchParams.all.ca1 ? String(CT.cache[CT.settings.currentTab].searchParams.all.ca1.join('+')) : "N/A",
                "userSignedInStatus": CT.utils.readCTAuthCookie() ? "Yes" : "No"
            };
            CT.utils.trackers.ctanalyticsTrackingData('Hotels_TR', 'Page_Viewed', 'SRP_Loaded', {
                "searchData": CT.utils.trackers.mixpanelTrackingData
            }, 'page_load');
            dataLayer[0]['People-No'] = CT.cache[CT.settings.currentTab].searchParams.all.adults + '|' + CT.cache[CT.settings.currentTab].searchParams.all.childs;

            var _cTab = newResultView.$el;
            if (window.twoCol == true) {
                // _cTab.find('#modifySearchLink').parents('div.left').removeClass('col4').addClass('col5');
                // _cTab.find('#hotelsViewSwitcher').removeClass('col16').addClass('col15');
                // _cTab.find('.filters').removeClass('col4').addClass('col5');
                // _cTab.find('div.viewController').removeClass('col16').addClass('col19');
                //_cTab.find('aside.mapHotel').hide();
                _cTab.find('.rhsBlock').hide();
                _cTab.find('.lPointer').hide();
            } else if (CT.subProd && CT.subProd != "wg") {
                _cTab.find('#modifySearchLink').parents('div.left').removeClass('col5').addClass('col4');
                _cTab.find('#hotelsViewSwitcher').removeClass('col15').addClass('col16');
                _cTab.find('.filters').removeClass('col5').addClass('col4');
                _cTab.find('div.viewController').removeClass('col19').addClass('col16');
                _cTab.find('.rhsBlock').show();
                //_cTab.find('aside.mapHotel').show();
                _cTab.find('.lPointer').show();
            }
            if (CT.subProd && CT.subProd == "wg" && window.altFilters == "true") {
                _cTab.find('.primaryFilter').show();
            }
            
            //sets the classes in view based on url params
            CT.utils.helperFunctions.setUrlParamsInView(paramsHash);
            //First ajax data for airBnb
            if (CT.subProd == "airBnb") {
                CT.settings[CT.app].airBnbCallStatus.airBnbCall = true;
            }
            if (window.airBnb == true && paramsHash.country != "IN" && CT.subProd != "airBnb") {
                fetchHotelsJson.fetchAirBnbContent();
                CT.settings[CT.app].airBnbCallStatus.airBnbCall = true;
            } else {
                CT.settings.hotel.airBnbRatesCallDone = true;
            }
            
            var modifiedSearchObj = CT.utils.helperFunctions.basicSearchParams(CT.cache[CT.settings.currentTab].searchParams.all);
            CT.cache[CT.settings.currentTab].modifiedSearchObj = modifiedSearchObj

            setTimeout(function(){
                fetchHotelsJson.fetchHotelContent()
                if (CT.cache[CT.settings.currentTab].searchParams.processed.dateLessSearch === false) {
                    fetchHotelsJson.fetchScData();
                }
            }, 0);
            CT.fire('modifyForm.change', [paramsHash]);

            //modify search form prefill if it is a srp page refresh
            if (window.isResultsPage && !window.searchForm_update_once_onResultPage) { //TODO refactor
                CT.cache.views.searchForm.fire('searchForm.update', [new Pers()]);
                window.searchForm_update_once_onResultPage = true
            }

            if (CT.cache[CT.settings.currentTab].searchParams.processed.city == "Goa" && window.internalusers == true && window.enableLiveEngage == true) {
                //CT.utils.loadLiveEngage()
            }

            var los = (paramsHash.chk_in && paramsHash.chk_in != "" && paramsHash.chk_out && paramsHash.chk_out != "" && CT.utils && CT.utils.diffDates) ? CT.utils.diffDates(paramsHash.chk_in, paramsHash.chk_out) : "N/A";
            CT.utils.moengageTrackingObj = {
                "d": paramsHash.city ? paramsHash.city : "N/A",
                "ci": paramsHash.chk_in ? paramsHash.chk_in : "N/A",
                "co": paramsHash.chk_out ? paramsHash.chk_out : "N/A",
                "dx": (paramsHash.chk_in && window.ctCurrentDate && CT.utils && CT.utils.diffDates) ? CT.utils.diffDates(window.ctCurrentDate, paramsHash.chk_in) : "N/A",
                "los": los,
                "st": "wd",
                "rc": paramsHash.num_rooms ? paramsHash.num_rooms : "N/A",
                "rn": (paramsHash.num_rooms && (los && los != "N/A")) ? parseInt(los) * parseInt(paramsHash.num_rooms) : "N/A",
                "pc": (paramsHash.adults && paramsHash.childs && paramsHash.childs != "") ? parseInt(paramsHash.adults) + parseInt(paramsHash.childs) : paramsHash.adults ? paramsHash.adults : "N/A",
                "ac": paramsHash.adults ? paramsHash.adults : "N/A",
                "cc": paramsHash.childs ? paramsHash.childs : "N/A"
            }
            var srpLoadMoengageObj = CT.utils.moengageTrackingObj;
            srpLoadMoengageObj.dl = "";
            srpLoadMoengageObj.shp = "";
            srpLoadMoengageObj.ahp = "";
            srpLoadMoengageObj.bhp = "";
            srpLoadMoengageObj.dhp = "";
            srpLoadMoengageObj.abt = "";
            if (window.moengageEnabled) {
                CT.utils.helperFunctions.tpTrack({
                    'tp': 'moengage',
                    'category': 'hsv',
                    'values': srpLoadMoengageObj
                });
            }
        });



        CT.subscribe('changeView', function(data) { // fired from toggle view
            var viewMap = {
                    "listView": "list",
                    "mapView": "map"
                },
                currentTab = $('#ResultContainer_' + CT.settings.currentTab),
                allDisplayEle, itemId,
                routes = CT.settings.routes,
                mapCache = CT.cache[CT.settings.currentTab].maps;
            CT.utils.helperFunctions.trackClaverTapEvtHotel("Hotel_SRP_ViewToggled", {
                'viewTypeSelected': data.view
            });
            //hide nearby cities notification
            currentTab.trigger('nearByNotification.hide');
            
            var searchParams = routes.getUrlParams();
            searchParams.view = viewMap[data.view];
            if (!data.onload) { // change the routs only if it is throught link-click
                routes.navigate('/results?' + $.param(searchParams), {
                    trigger: false,
                    replace: true
                })
            }

            if (viewMap[data.view] == 'map') {
                $('body').addClass('disablePageScroll mapView').animate({
                    className: 'mapView'
                }, null, '', function() {
                    //TODO: this line is a quick fix for : animate with "className" option is changing "hotel" class to "NaNhotel" class
                    $('body').removeClass('NaNhotel').addClass('hotel');
                    currentTab.find(".contentPopOver").css('display', 'none');
                    if (window.showTags) {
                        currentTab.find(".backLink").show();
                        currentTab.find(".tagContainer").hide();
                    }
                    currentTab.find(".mapViewSearch").css('display', 'none');
                    currentTab.find(".collectionUpSellSRP").css('display', 'none');
                    $(".globalFooter").css('display', 'none');
                    currentTab.find(".rhsBlock").css('display', 'none');
                    currentTab.find('li.listItem').removeClass('opened').find('.quickLook').css('display', 'none');
                    //  currentTab.find('li.flightHotelSRPUpsells').css('display', 'none');

                    // creating callback for after loading maps async
                    window.setupMaps = function(e) {
                        if (!e) mapCache.gmapReady = true
                        else $.extend(mapCache, e)
                        CT.fire('mapinit', '');
                    }


                    /** ============ google maps not available => LOAD MAPS AND ALL IT'S DEPENDENCIES ============ **/
                    if (typeof window.google === "undefined") {
                        loadMapsDeps(setupMaps)
                        CT.getScript('//maps.googleapis.com/maps/api/js?sensor=false&callback=setupMaps&key=' + ((window.productCode == "CP") ? CT.settings.general.mapApiKeyCP : CT.settings.general.mapApiKey));

                        /** ============ google maps is available but not the dependencies => LOAD DEPENDENCIES ============ **/
                        // CAN'T WORK
                        /*} else if(typeof window.google !== "undefined" && !CT.gmapHotelsView){
                                            mapCache.gmapReady = true
                                            loadMapsDeps(setupMaps)*/

                        /** ============ google maps all it's dependencies are available => DON'T LOAD ANYTHING ============ **/
                    } else {
                        if (CT.cache[CT.settings.currentTab].mapsDependencyLoaded == true) {
                            if (!mapCache.gmapReady || !mapCache.gmapHotelsReady) {
                                $.extend(mapCache, {
                                    gmapHotelsReady: true,
                                    gmapReady: true
                                })
                                CT.fire('mapinit', '');
                            }
                        } else {
                            loadMapsDeps(setupMaps)
                            delete window.setupMaps
                        }
                        /*if(!mapCache.gmapReady || !mapCache.gmapHotelsReady){
                                            $.extend(mapCache, {gmapHotelsReady : true, gmapReady : true})
                                            CT.fire('mapinit', '');
                                        }else{
                                            loadMapsDeps(setupMaps)
                                            //$.extend(mapCache, {gmapHotelsReady : true, gmapReady : true})
                                            //CT.fire('mapinit', '');
                                            delete window.setupMaps
                                        }*/
                    }
                });
                $('html').addClass('disablePageScroll');
            } else {
                CT.utils.helperFunctions.trackGAEventWrapper('Hotels_TR', 'H_ListView', CT.cache[CT.settings.currentTab].paramsForGA, '100');
                $('body').removeClass('mapView disablePageScroll slideIn');
                $('html').removeClass('disablePageScroll');
                CT.masterJson.get().clusterMapItems = undefined;
                currentTab.find(".mapViewSearch").hide();

                currentTab.find(".collectionUpSellSRP").show();
                $(".globalFooter").show();
                currentTab.find(".updatingModal").hide();
                currentTab.find(".mapMarker").remove();
                if (window.showTags) {
                    currentTab.find(".backLink").hide();
                    currentTab.find(".primaryBar .mDeal p").show()
                    currentTab.find(".tagContainer").show();
                } else {
                    currentTab.find(".listViewResults .mDeal p").show()
                }
                // currentTab.find(".mDeal").show();                  
                if (window.twoCol != true) {
                    currentTab.find(".rhsBlock").show();
                }
                currentTab.find(".mapHotel").removeAttr("style");
                currentTab.find('.listViewResults .pagination').hide();
                currentTab.find(".viewController").show();
                currentTab.find(".viewController").css("height", "auto");
                currentTab.find(".filters").show();
                currentTab.find(".filters").css("height", "auto");
                currentTab.find(".sliderHandle").attr("data-slide", "slideIn")
                currentTab.find(".sliderHandle").html("");
                //   currentTab.find('li.flightHotelSRPUpsells').css('display', '');
                //display all hotels ( filtered or all )
                /*if (CT.applyTheseFilters.ids) {
                                    delete CT.applyTheseFilters.ids;
                                    currentTab.trigger('filters.apply', [CT.settings[CT.app].filters, CT.applyTheseFilters]);
                                } else {
                                    itemId = this.getDisplayItemId();
                                    if(itemId != undefined) {
                                        currentTab.find(itemId).show();
                                    }
                                }*/
            }
            $('#ResultContainer_' + CT.settings.currentTab).trigger('results.update', [CT.cache[CT.settings.currentTab].sortedHt, {
                idx: 0
            }]);
            if (window.enableOpaque)
                $(".opaqueListUnit").hide();

        });


        CT.subscribe('shortListedHotelCount.update', function(_data) {
            var isLoggedIn = true; //CT.utils.readCTAuthCookie();
            var slistLength = 0
            if (_data && _data.count) {
                slistLength = _data.count;
            } else {
                slistLength = CT.masterJson.getShortListedHotelCount();
            }
            var isShortListEnabled = CT.masterJson.isShortListEnabled();
            if (isShortListEnabled && isLoggedIn) {
                var $parentEle = $("span.shortlistCount").html(slistLength).parents(".stickyBarShortlist");
                $parentEle.show();
            }
        })

        CT.subscribe('triggerTagsFilter', searchResultViewSettings.triggerTagsFilter);

        CT.subscribe('shortlistParam.update', function(_data) { // fired from shortlisted module
            var data = $.extend(_data, true),
                routes = CT.settings.routes
            var searchParams = routes.getUrlParams();
            data.operation = data.operation || "add";


            if (data.operation == "add") {
                searchParams.shortListed = ((searchParams.shortListed !== '' && typeof searchParams.shortListed !== "undefined") ? (searchParams.shortListed + "-") : "") + data.ids;
            } else if (data.operation == "delete") {
                if (searchParams.shortListed) {
                    searchParams.shortListed = _.filter(searchParams.shortListed.split("-"), function(i, id) {
                        if (!_.contains(data.ids, id)) {
                            return id;
                        }
                    }).join("-");
                }
            }
            
            routes.navigate('/results?' + _.serialize(searchParams), {
                trigger: false,
                replace: true
            })
            //CT.fire('changeRoutes',['/results?' + $.param(searchParams) , {trigger:false}]);
        });


        return searchResultViewSettings

    },
    CT.settings);
